import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import api from '../../services/api';

// ============================================================================
// ÍCONES LUMIX
// ============================================================================
const Icons = {
  Tag: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  Save: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Plus: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  CheckDouble: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#53bdeb" strokeWidth="2">
      <path d="m2 12 5 5L20 4" />
      <path d="m2 12 5 5L20 4" />
    </svg>
  ),
  Megaphone: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 11v2a2 2 0 0 0 2 2h3l5 4V5L8 9H5a2 2 0 0 0-2 2Z" />
      <path d="M16 9a5 5 0 0 1 0 6" />
      <path d="M19 6a9 9 0 0 1 0 12" />
    </svg>
  ),
  Users: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  MessageCircle: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8A8.5 8.5 0 0 1 8.7 3.9a8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z" />
    </svg>
  ),
  Handshake: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="m11 17 2 2a2.83 2.83 0 0 0 4 0l3-3a2.83 2.83 0 0 0 0-4l-5-5" />
      <path d="m13 7-6 6 3 3 6-6" />
      <path d="M3 7l4-4 4 4" />
      <path d="m2 14 5 5" />
    </svg>
  ),
  Filter: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),
  Send: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  Upload: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Trash: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),
  Database: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5" />
      <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3" />
    </svg>
  ),
  FileUp: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
      <polyline points="14 2 14 8 20 8" />
      <path d="M12 18v-6" />
      <path d="m9 15 3-3 3 3" />
    </svg>
  ),
  Refresh: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  Spark: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M13 2 11 9 4 11l7 2 2 7 2-7 7-2-7-2-2-7Z" />
    </svg>
  ),
  Shield: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
      <path d="m9 12 2 2 4-5" />
    </svg>
  ),
  Image: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="m21 15-5-5L5 21" />
    </svg>
  ),
};

// ============================================================================
// CONFIGURAÇÕES PADRÃO
// ============================================================================
const defaultWelcomeConfig = {
  usarImagem: true,
  imagemUrl: '',
  mensagem:
    '*Obrigado pela sua compra nas Lumix Óticas!*\n\nAcabamos de concluir a entrega dos seus óculos — e ficaram realmente incríveis em você! 😍\n\nQualquer ajuste, dúvida ou necessidade, pode chamar a gente aqui mesmo.\nEstamos à disposição para garantir que sua nova visão seja a melhor possível.\n\nCom carinho,\n*Equipe Lumix Óticas*',
};

const defaultCampaignForm = {
  _id: null,
  titulo: '',
  mensagem: '',
  usarImagem: false,
  imagemUrl: '',
  statusCampanha: 'RASCUNHO',
  tipoCampanha: 'CLIENTES_MES',
  modoAniversario: 'MES',
  canalWhatsappId: '',
};

const birthdayMonthTemplate =
  '*Parabéns pelo seu mês, {{nome}}!* 🎉🥳\n\nPreparamos uma condição especial de aniversariante pra você renovar sua armação com a gente neste mês.\n\nSe quiser, te mostro as opções aqui mesmo.';

const birthdayTodayTemplate =
  '*Hoje é o seu dia, {{nome}}!* 🎂🎉\n\nPassando pra te desejar um feliz aniversário e te liberar uma condição especial pra você aproveitar hoje com a gente.\n\nSe quiser, te mostro as opções agora mesmo.';


const CAMPAIGN_IDEAS = [
  {
    id: 'birthday-today',
    icon: '🎂',
    label: 'Aniversariantes de hoje',
    description: 'Lista automaticamente quem faz aniversário hoje.',
    tipoCampanha: 'ANIVERSARIANTES',
    modoAniversario: 'HOJE',
    titulo: 'Campanha de Aniversariantes de Hoje',
    mensagem: birthdayTodayTemplate,
  },
  {
    id: 'birthday-month',
    icon: '🎉',
    label: 'Aniversariantes do mês',
    description: 'Crie uma ação para todos os aniversariantes do mês.',
    tipoCampanha: 'ANIVERSARIANTES',
    modoAniversario: 'MES',
    titulo: 'Campanha de Aniversariantes do Mês',
    mensagem: birthdayMonthTemplate,
  },
  {
    id: 'maintenance',
    icon: '🛠️',
    label: 'Manutenção preventiva',
    description: 'Convide clientes recentes para ajuste e limpeza.',
    tipoCampanha: 'CLIENTES_MES',
    modoAniversario: 'MES',
    titulo: 'Manutenção preventiva dos óculos',
    mensagem:
      'Olá, *{{nome}}*! 👓\n\nPassando para lembrar que sua manutenção preventiva está disponível. Podemos fazer limpeza, alinhamento e pequenos ajustes para manter seus óculos confortáveis e bem cuidados.\n\nQuando puder, passe na loja. Será um prazer atender você!',
  },
  {
    id: 'referral',
    icon: '🤝',
    label: 'Indicação de amigos',
    description: 'Reative clientes com uma campanha de indicação.',
    tipoCampanha: 'CLIENTES_MES',
    modoAniversario: 'MES',
    titulo: 'Campanha de indicação',
    mensagem:
      'Olá, *{{nome}}*! Tudo bem? 👓\n\nPreparamos uma condição especial para clientes que indicam amigos e familiares para conhecer nossa ótica.\n\nQuer saber como funciona? Responda esta mensagem e nossa equipe explica para você.',
  },
];

// ============================================================================
// ROTAS DO TEMPLATE DA RÉGUA
// ============================================================================
// Se no seu app.js estiver assim:
// app.use('/api', templateRoutes)
// então essas rotas ficam:
// GET  /api/templates
// POST /api/templates
// POST /api/templates/upload
const TEMPLATE_ROUTES = {
  list: '/api/templates',
  save: '/api/templates',
  upload: '/api/templates/upload',
  image: '/api/templates/imagem',
};

const WELCOME_ROUTES = {
  get: '/ordens-servico/config/boas-vindas',
  save: '/ordens-servico/config/boas-vindas',
  upload: '/ordens-servico/config/boas-vindas/upload',
  image: '/ordens-servico/config/boas-vindas/imagem',
};

const CAMPAIGN_ROUTES = {
  list: '/ordens-servico/api/campanhas',
  save: '/ordens-servico/api/campanhas',
  upload: '/ordens-servico/api/campanhas/upload',
  image: '/ordens-servico/api/campanhas/imagem',
  clientes: '/ordens-servico/api/campanhas/clientes',
  aniversariantes: '/ordens-servico/api/campanhas/aniversariantes',
  enviar: '/ordens-servico/api/campanhas/enviar',
};

const WHATSAPP_CHANNEL_ROUTES = {
  /*
    A primeira rota é a rota oficial usada pelo whatsappController.
    As demais ficam como compatibilidade com instalações antigas.
  */
  listCandidates: [
    '/api/whatsapp/canais',
    '/whatsapp/canais',
    '/api/canais-whatsapp',
    '/canais-whatsapp',
  ],
  status: (canalWhatsappId) =>
    `/api/whatsapp/canais/${encodeURIComponent(canalWhatsappId)}/status`,
};

const CAMPAIGN_CHANNEL_STORAGE_PREFIX = 'lumixCampaignChannel:';

// ============================================================================
// HELPERS
// ============================================================================
const safeParseUser = () => {
  try {
    return JSON.parse(localStorage.getItem('vizumUser')) || {};
  } catch {
    return {};
  }
};

const getEmpresaIdFromUser = (user = {}) => {
  const raw =
    user?.empresaId?._id ||
    user?.empresaId ||
    user?.empresa?._id ||
    user?.empresa?.id ||
    '';

  return raw ? String(raw) : '';
};

const EMPRESA_CRM_STORAGE_KEY = 'lumixCrmEmpresaId';

const lerStorageSeguro = (storage, key) => {
  try {
    return storage?.getItem(key) || '';
  } catch {
    return '';
  }
};

const extrairEmpresaIdDeValor = (valor) => {
  if (!valor) return '';

  if (typeof valor === 'object') {
    return normalizarId(
      valor._id ||
        valor.id ||
        valor.empresaId ||
        valor.empresa?._id ||
        valor.empresa?.id ||
        valor.unidadeId ||
        valor.filialId ||
        ''
    );
  }

  const texto = String(valor || '').trim();
  if (!texto) return '';

  try {
    const parsed = JSON.parse(texto);
    const idParsed = extrairEmpresaIdDeValor(parsed);
    if (idParsed) return idParsed;
  } catch {
    // O valor pode ser diretamente um ObjectId em formato string.
  }

  return texto;
};

const getEmpresaIdDaNavegacao = () => {
  try {
    const params = new URLSearchParams(window.location.search || '');

    return (
      params.get('empresaId') ||
      params.get('empresa') ||
      params.get('unidadeId') ||
      params.get('filialId') ||
      ''
    );
  } catch {
    return '';
  }
};

const getEmpresaIdPersistido = () => {
  const chaves = [
    EMPRESA_CRM_STORAGE_KEY,
    'vizumEmpresaSelecionada',
    'empresaSelecionada',
    'empresaAtual',
    'empresaOperacional',
    'empresaIdAtual',
    'unidadeSelecionada',
  ];

  for (const chave of chaves) {
    const valorLocal = lerStorageSeguro(window.localStorage, chave);
    const idLocal = extrairEmpresaIdDeValor(valorLocal);
    if (idLocal) return idLocal;

    const valorSessao = lerStorageSeguro(window.sessionStorage, chave);
    const idSessao = extrairEmpresaIdDeValor(valorSessao);
    if (idSessao) return idSessao;
  }

  return '';
};

const getCanalWhatsappIdPersistidoGlobal = () => {
  try {
    const params = new URLSearchParams(window.location.search || '');

    const queryId =
      params.get('canalWhatsappId') ||
      params.get('canalId') ||
      params.get('whatsappChannelId') ||
      '';

    if (queryId) return normalizarId(queryId);
  } catch {
    // Segue para os storages.
  }

  const chaves = [
    'lumixCanalWhatsappId',
    'canalWhatsappId',
    'canalWhatsAppId',
    'whatsappChannelId',
    'whatsappCanalSelecionado',
    'canalWhatsappSelecionado',
    'canalSelecionado',
  ];

  for (const chave of chaves) {
    const valorLocal = lerStorageSeguro(window.localStorage, chave);
    const idLocal = extrairEmpresaIdDeValor(valorLocal);
    if (idLocal) return idLocal;

    const valorSessao = lerStorageSeguro(window.sessionStorage, chave);
    const idSessao = extrairEmpresaIdDeValor(valorSessao);
    if (idSessao) return idSessao;
  }

  return '';
};

const getEmpresaLabel = (empresa = {}) => {
  const nome = empresa.nome || empresa.razaoSocial || empresa.fantasia || 'Empresa';
  const unidade = String(empresa.unidade || '').trim();
  const codigo = String(empresa.codigoLoja || empresa.loja || '').trim();

  const complemento = unidade && unidade.toLowerCase() !== String(nome).toLowerCase()
    ? unidade
    : codigo;

  return complemento ? `${nome} · ${complemento}` : nome;
};

const getEmpresaIniciais = (empresa = {}) => {
  const nome = String(empresa.nome || empresa.razaoSocial || empresa.unidade || 'Empresa').trim();
  const partes = nome.split(/\s+/).filter(Boolean);

  if (!partes.length) return 'EM';
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();

  return `${partes[0][0] || ''}${partes[1][0] || ''}`.toUpperCase();
};

const montarParamsEmpresa = (empresaId, extra = {}) => {
  const params = { ...extra };
  if (empresaId) params.empresaId = String(empresaId);
  return params;
};

const anexarEmpresaNoFormData = (formData, empresaId) => {
  if (empresaId) formData.append('empresaId', String(empresaId));
  return formData;
};

const resolverArrayApi = (data, keys = []) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;

  for (const key of keys) {
    if (Array.isArray(data?.[key])) return data[key];
  }

  return [];
};

const normalizarId = (valor) => {
  if (!valor) return '';
  if (typeof valor === 'object') return String(valor?._id || valor?.id || '');
  return String(valor);
};

const normalizarCanalWhatsapp = (canal, empresaIdFallback = '') => {
  if (!canal) return null;

  if (typeof canal === 'string') {
    const id = normalizarId(canal);

    return id
      ? {
          id,
          _id: id,
          empresaId: empresaIdFallback,
          unidadeId: empresaIdFallback,
          nome: `Canal ${id.slice(-6)}`,
          numero: '',
          principal: false,
          status: 'UNKNOWN',
        }
      : null;
  }

  const id = normalizarId(
    canal?._id ||
      canal?.id ||
      canal?.canalWhatsappId ||
      canal?.canalWhatsAppId ||
      canal?.whatsappChannelId ||
      canal?.channelId ||
      ''
  );

  if (!id) return null;

  return {
    ...canal,
    id,
    _id: id,
    empresaId: normalizarId(
      canal?.empresaId?._id ||
        canal?.empresaId ||
        canal?.empresa?._id ||
        canal?.empresa?.id ||
        empresaIdFallback
    ),
    unidadeId: normalizarId(
      canal?.unidadeId?._id ||
        canal?.unidadeId ||
        canal?.filialId ||
        empresaIdFallback
    ),
    nome:
      canal?.nome ||
      canal?.descricao ||
      canal?.label ||
      canal?.apelido ||
      canal?.numero ||
      canal?.telefone ||
      canal?.sessionName ||
      `Canal ${id.slice(-6)}`,
    numero:
      canal?.numero ||
      canal?.telefone ||
      canal?.whatsapp ||
      '',
    principal: canal?.principal === true,
    status: String(canal?.status || canal?.connectionStatus || 'UNKNOWN').toUpperCase(),
  };
};

const deduplicarCanaisWhatsapp = (lista = [], empresaIdFallback = '') => {
  const map = new Map();

  for (const item of lista || []) {
    const canal = normalizarCanalWhatsapp(item, empresaIdFallback);
    if (!canal?.id) continue;

    map.set(canal.id, {
      ...(map.get(canal.id) || {}),
      ...canal,
    });
  }

  return Array.from(map.values());
};

const resolverCanaisRespostaApi = (data, empresaIdFallback = '') => {
  const candidatos = [
    ...(Array.isArray(data) ? data : []),
    ...(Array.isArray(data?.data) ? data.data : []),
    ...(Array.isArray(data?.canais) ? data.canais : []),
    ...(Array.isArray(data?.channels) ? data.channels : []),
    ...(Array.isArray(data?.canaisWhatsapp) ? data.canaisWhatsapp : []),
    ...(Array.isArray(data?.canaisWhatsApp) ? data.canaisWhatsApp : []),
    ...(Array.isArray(data?.items) ? data.items : []),
  ];

  return deduplicarCanaisWhatsapp(candidatos, empresaIdFallback);
};

const extrairCanaisDaEmpresa = (empresa = {}) => {
  const empresaId = normalizarId(empresa?._id || empresa?.id);

  const candidatos = [
    ...(Array.isArray(empresa?.canaisWhatsapp) ? empresa.canaisWhatsapp : []),
    ...(Array.isArray(empresa?.canaisWhatsApp) ? empresa.canaisWhatsApp : []),
    ...(Array.isArray(empresa?.whatsappCanais) ? empresa.whatsappCanais : []),
    ...(Array.isArray(empresa?.whatsappChannels) ? empresa.whatsappChannels : []),
    empresa?.canalWhatsapp,
    empresa?.canalWhatsApp,
    empresa?.whatsappChannel,
    empresa?.canalWhatsappId,
    empresa?.canalWhatsAppId,
    empresa?.whatsappChannelId,
  ].filter(Boolean);

  return deduplicarCanaisWhatsapp(candidatos, empresaId);
};

const canalPertenceEmpresaFront = (canal = {}, empresaId = '') => {
  if (!empresaId) return true;

  const empresaCanalId = normalizarId(canal?.empresaId);
  const unidadeCanalId = normalizarId(canal?.unidadeId);

  /*
    Respostas enxutas podem não trazer empresaId/unidadeId.
    Nesse caso o endpoint já foi filtrado pela empresa selecionada.
  */
  if (!empresaCanalId && !unidadeCanalId) return true;

  return empresaCanalId === empresaId || unidadeCanalId === empresaId;
};

const getCanalWhatsappLabel = (canal = {}) => {
  const nome =
    canal?.nome ||
    canal?.descricao ||
    canal?.label ||
    canal?.sessionName ||
    'Canal WhatsApp';

  const numero = String(
    canal?.numero ||
      canal?.telefone ||
      canal?.whatsapp ||
      ''
  ).trim();

  return numero ? `${nome} · ${numero}` : nome;
};

const getCanalStatusMeta = (statusPayload = {}, canal = {}) => {
  const status = String(
    statusPayload?.status ||
      canal?.status ||
      'UNKNOWN'
  ).toUpperCase();

  const connected =
    statusPayload?.connected === true ||
    status === 'CONNECTED';

  if (connected) {
    return {
      status: 'CONNECTED',
      label: 'Conectado e pronto',
      tone: 'connected',
      description: 'A campanha será enviada somente por este canal.',
      connected: true,
      requiresQr: false,
    };
  }

  if (['QRCODE', 'UNPAIRED', 'NOT_LOGGED'].includes(status)) {
    return {
      status,
      label: 'Precisa conectar',
      tone: 'warning',
      description: 'Abra a área do WhatsApp e escaneie o QR Code deste canal.',
      connected: false,
      requiresQr: true,
    };
  }

  if (['INITIALIZING', 'LOADING', 'RECONNECTING'].includes(status)) {
    return {
      status,
      label: 'Conectando...',
      tone: 'loading',
      description: 'O servidor está restaurando a sessão selecionada.',
      connected: false,
      requiresQr: false,
    };
  }

  if (['DISCONNECTED', 'ERROR', 'NO_CHANNEL'].includes(status)) {
    return {
      status,
      label: 'Desconectado',
      tone: 'danger',
      description: 'Ao enviar, o servidor tentará restaurar somente este canal.',
      connected: false,
      requiresQr: false,
    };
  }

  return {
    status,
    label: 'Status não verificado',
    tone: 'neutral',
    description: 'O canal será validado pelo servidor antes do disparo.',
    connected: false,
    requiresQr: false,
  };
};

const extrairCaminhoPilotos = (valor = '') => {
  if (valor === null || valor === undefined) return '';

  let caminho = typeof valor === 'string' ? valor : String(valor || '');

  caminho = caminho.trim().replace(/\\/g, '/');

  if (!caminho) return '';
  if (caminho.startsWith('blob:')) return '';
  if (caminho.startsWith('data:image/')) return '';

  /*
    Correção principal:
    A API pode devolver o caminho de várias formas:
    - /pilotos/boas-vindas/EMPRESA/ANO/MES/arquivo.webp
    - pilotos/boas-vindas/EMPRESA/ANO/MES/arquivo.webp
    - https://dominio.com/pilotos/boas-vindas/EMPRESA/ANO/MES/arquivo.webp
    - /var/www/lumix-uploads/pilotos/boas-vindas/EMPRESA/ANO/MES/arquivo.webp
    - JSON/string com algum campo contendo /pilotos/...

    O front deve sempre extrair e salvar somente:
    /pilotos/...
  */
  try {
    caminho = decodeURIComponent(caminho);
  } catch {
    // Mantém o valor original se vier com escape inválido.
  }

  caminho = caminho.trim().replace(/\\/g, '/');

  const match = caminho.match(/\/?pilotos\/[^\s"'<>}\],]+/i);

  if (!match?.[0]) return '';

  let caminhoPilotos = match[0].startsWith('/') ? match[0] : `/${match[0]}`;

  caminhoPilotos = caminhoPilotos
    .split('?')[0]
    .split('#')[0]
    .split('&')[0]
    .replace(/[),;]+$/g, '')
    .trim();

  if (!caminhoPilotos.startsWith('/pilotos/')) return '';
  if (caminhoPilotos.includes('..')) return '';

  return caminhoPilotos;
};

const extrairImagemUrlUpload = (data = {}) => {
  const visitados = new WeakSet();

  const buscarRecursivo = (valor) => {
    const direto = extrairCaminhoPilotos(valor);

    if (direto) return direto;

    if (!valor || typeof valor !== 'object') return '';

    if (visitados.has(valor)) return '';
    visitados.add(valor);

    if (Array.isArray(valor)) {
      for (const item of valor) {
        const encontrado = buscarRecursivo(item);
        if (encontrado) return encontrado;
      }

      return '';
    }

    const chavesPrioritarias = [
      'imagemUrl',
      'imageUrl',
      'url',
      'path',
      'filePath',
      'filename',
      'fileName',
      'caminho',
      'caminhoRelativo',
      'relativePath',
      'relativeUrl',
      'publicUrl',
      'secureUrl',
      'secure_url',
      'location',
      'Location',
      'src',
      'href',
      'link',
      'downloadUrl',
      'downloadURL',
      'previewUrl',
    ];

    for (const chave of chavesPrioritarias) {
      if (Object.prototype.hasOwnProperty.call(valor, chave)) {
        const encontrado = buscarRecursivo(valor[chave]);
        if (encontrado) return encontrado;
      }
    }

    for (const item of Object.values(valor)) {
      const encontrado = buscarRecursivo(item);
      if (encontrado) return encontrado;
    }

    return '';
  };

  const encontrado = buscarRecursivo(data);

  if (!encontrado) {
    console.warn('⚠️ [TemplatesManager] Upload não retornou caminho /pilotos/. Payload recebido:', data);
  }

  return encontrado;
};

const getStatusClass = (status) => String(status || 'RASCUNHO').toLowerCase();

const montarErroInteligente = (error, fallback = 'Não foi possível concluir a ação.') => {
  if (!navigator.onLine) return 'Você está sem internet. Verifique a conexão e tente novamente.';

  const message =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    '';

  if (String(message).includes('Network Error')) {
    return 'Não consegui conectar com a API. Verifique se o servidor está online.';
  }

  return message || fallback;
};

const formatarDataBR = (valor) => {
  if (!valor) return '-';

  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return '-';

  return data.toLocaleDateString('pt-BR');
};

const moduleTabs = [
  {
    id: 'pos-venda',
    label: 'Régua pós-venda',
    description: 'Mensagens por marco',
    icon: Icons.MessageCircle,
  },
  {
    id: 'boas-vindas',
    label: 'Boas-vindas',
    description: 'Entrega da OS',
    icon: Icons.Handshake,
  },
  {
    id: 'campanhas',
    label: 'Campanhas',
    description: 'Disparos em lote',
    icon: Icons.Megaphone,
  },
  {
    id: 'base-externa',
    label: 'Base externa',
    description: 'Importações',
    icon: Icons.Database,
  },
];

// ============================================================================
// COMPONENTE
// ============================================================================
export default function TemplatesManager({
  empresaId: empresaIdProp = '',
  empresaSelecionada = null,
  empresaOperacional = null,
  canalWhatsappId: canalWhatsappIdProp = '',
  canalSelecionado = null,
  onEmpresaChange,
}) {
  const userLogado = useMemo(() => safeParseUser(), []);
  const empresaIdUsuario = useMemo(() => getEmpresaIdFromUser(userLogado), [userLogado]);

  const empresaIdExterno = useMemo(
    () =>
      extrairEmpresaIdDeValor(
        empresaIdProp ||
          empresaSelecionada ||
          empresaOperacional ||
          ''
      ),
    [empresaIdProp, empresaSelecionada, empresaOperacional]
  );

  const canalWhatsappIdExterno = useMemo(
    () =>
      normalizarId(
        canalWhatsappIdProp ||
          canalSelecionado?._id ||
          canalSelecionado?.id ||
          canalSelecionado?.canalWhatsappId ||
          canalSelecionado?.whatsappChannelId ||
          ''
      ),
    [canalWhatsappIdProp, canalSelecionado]
  );

  const [empresasDisponiveis, setEmpresasDisponiveis] = useState([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(true);
  const [empresaIdSelecionada, setEmpresaIdSelecionada] = useState(() => (
    empresaIdExterno ||
    getEmpresaIdDaNavegacao() ||
    getEmpresaIdPersistido() ||
    empresaIdUsuario ||
    ''
  ));

  const empresaIdAtual = empresaIdExterno || empresaIdSelecionada || empresaIdUsuario || '';

  const empresaAtual = useMemo(() => {
    return (
      empresasDisponiveis.find((empresa) => normalizarId(empresa?._id || empresa?.id) === empresaIdAtual) ||
      empresaSelecionada ||
      empresaOperacional ||
      null
    );
  }, [empresaIdAtual, empresaOperacional, empresaSelecionada, empresasDisponiveis]);

  const empresaNomeAtual = empresaAtual
    ? getEmpresaLabel(empresaAtual)
    : userLogado?.empresa?.nome || userLogado?.empresaNome || 'Empresa';

  const empresaIniciais = getEmpresaIniciais(
    empresaAtual || userLogado?.empresa || { nome: empresaNomeAtual }
  );

  const [activeModule, setActiveModule] = useState('pos-venda');
  const [notification, setNotification] = useState(null);

  const posVendaFileInputRef = useRef(null);
  const welcomeFileInputRef = useRef(null);
  const campaignFileInputRef = useRef(null);
  const importBaseFileInputRef = useRef(null);

  // Imagens protegidas /pilotos/...
  // O banco continua salvando apenas o caminho relativo.
  // O preview carrega a imagem com token via axios e transforma em Blob URL.
  const [protectedImageBlobs, setProtectedImageBlobs] = useState({});
  const protectedImageBlobRef = useRef({});
  const protectedImageLoadingRef = useRef({});
  const empresaAnteriorRef = useRef('');

  // Pós-venda
  const [templates, setTemplates] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    marco: '',
    titulo: '',
    mensagem: '',
    usarImagem: false,
    imagemUrl: '',
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploadingPosVendaImage, setUploadingPosVendaImage] = useState(false);

  // Boas-vindas
  const [welcomeConfig, setWelcomeConfig] = useState(defaultWelcomeConfig);
  const [savingWelcome, setSavingWelcome] = useState(false);
  const [uploadingWelcomeImage, setUploadingWelcomeImage] = useState(false);

  // Campanhas
  const [campaignView, setCampaignView] = useState('list');
  const [campaignsList, setCampaignsList] = useState([]);
  const [loadingCampaigns, setLoadingCampaigns] = useState(false);
  const [campaignForm, setCampaignForm] = useState(defaultCampaignForm);

  const hoje = new Date();
  const mesAtual = `${String(hoje.getMonth() + 1).padStart(2, '0')}/${hoje.getFullYear()}`;

  const [campaignMonth, setCampaignMonth] = useState(mesAtual);
  const [clientsData, setClientsData] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [savingCampaignDraft, setSavingCampaignDraft] = useState(false);
  const [sendingCampaign, setSendingCampaign] = useState(false);
  const [loadingClients, setLoadingClients] = useState(false);
  const [uploadingCampaignImage, setUploadingCampaignImage] = useState(false);
  const [campaignSearch, setCampaignSearch] = useState('');
  const [campaignStatusFilter, setCampaignStatusFilter] = useState('TODAS');
  const [birthdayTodayClients, setBirthdayTodayClients] = useState([]);
  const [loadingBirthdayToday, setLoadingBirthdayToday] = useState(false);

  const [canaisWhatsapp, setCanaisWhatsapp] = useState([]);
  const [loadingCanaisWhatsapp, setLoadingCanaisWhatsapp] = useState(false);
  const [canalWhatsappIdSelecionado, setCanalWhatsappIdSelecionado] = useState('');
  const [canalStatus, setCanalStatus] = useState({
    status: 'UNKNOWN',
    connected: false,
    runtimeAlive: false,
  });
  const [checkingCanalStatus, setCheckingCanalStatus] = useState(false);

  // Base externa
  const [importedBaseList, setImportedBaseList] = useState([]);
  const [loadingImportedBase, setLoadingImportedBase] = useState(false);
  const [importingBaseFile, setImportingBaseFile] = useState(false);
  const [lastImportSummary, setLastImportSummary] = useState(null);

  // Base externa inteligente
  const [baseSearch, setBaseSearch] = useState('');
  const [baseDragActive, setBaseDragActive] = useState(false);
  const [showInvalidImportExamples, setShowInvalidImportExamples] = useState(false);

  const supportedBaseFormats = useMemo(
    () => ['.xlsx', '.xls', '.csv', '.txt', '.pdf', '.docx', '.doc'],
    []
  );

  const normalizeSearch = useCallback((value = '') => (
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
  ), []);

  const formatarTelefoneBR = useCallback((telefone = '') => {
    const numero = String(telefone || '').replace(/\D/g, '');
    const semDdi = numero.startsWith('55') ? numero.slice(2) : numero;

    if (semDdi.length === 11) {
      return `(${semDdi.slice(0, 2)}) ${semDdi.slice(2, 7)}-${semDdi.slice(7)}`;
    }

    if (semDdi.length === 10) {
      return `(${semDdi.slice(0, 2)}) ${semDdi.slice(2, 6)}-${semDdi.slice(6)}`;
    }

    return telefone || '-';
  }, []);

  const baseStats = useMemo(() => {
    const total = importedBaseList.length;
    const comNascimento = importedBaseList.filter((item) => item.dataNascimento).length;
    const comCompra = importedBaseList.filter((item) => item.dataCompra || item.dataCadastro).length;
    const comEntrega = importedBaseList.filter((item) => item.dataEntrega).length;
    const cidades = new Set(
      importedBaseList
        .map((item) => normalizeSearch(item.cidade))
        .filter(Boolean)
    );

    return {
      total,
      comNascimento,
      comCompra,
      comEntrega,
      cidades: cidades.size,
    };
  }, [importedBaseList, normalizeSearch]);

  const importedBaseFiltered = useMemo(() => {
    const termo = normalizeSearch(baseSearch);

    if (!termo) return importedBaseList;

    return importedBaseList.filter((item) => {
      const alvo = normalizeSearch([
        item.nome,
        item.telefone,
        item.email,
        item.cidade,
        item.estado,
        item.bairro,
        item.documento,
        item.origemArquivo,
      ].filter(Boolean).join(' '));

      return alvo.includes(termo);
    });
  }, [baseSearch, importedBaseList, normalizeSearch]);


  const isBirthdayCampaign = campaignForm.tipoCampanha === 'ANIVERSARIANTES';
  const isBirthdayTodayMode = isBirthdayCampaign && campaignForm.modoAniversario === 'HOJE';
  const isBirthdayMonthMode = isBirthdayCampaign && campaignForm.modoAniversario === 'MES';

  const selectedModule = moduleTabs.find((item) => item.id === activeModule) || moduleTabs[0];

  const campaignTargetLabel = !isBirthdayCampaign
    ? 'Clientes do mês'
    : isBirthdayTodayMode
      ? 'Aniversariantes de hoje'
      : 'Aniversariantes do mês';

  const campaignFilterLabel = !isBirthdayCampaign
    ? 'Filtrar vendas de:'
    : isBirthdayTodayMode
      ? 'Base do mês para aniversariantes de hoje:'
      : 'Filtrar aniversariantes de:';

  const campaignDateColumnLabel = isBirthdayCampaign ? 'Aniversário' : 'Data da compra';

  const campaignEmptyStateLabel = !isBirthdayCampaign
    ? 'Nenhum cliente com WhatsApp encontrado neste mês.'
    : isBirthdayTodayMode
      ? 'Nenhum cliente faz aniversário hoje.'
      : 'Nenhum aniversariante com WhatsApp encontrado neste mês.';


  const canalWhatsappSelecionado = useMemo(
    () =>
      canaisWhatsapp.find(
        (canal) => normalizarId(canal?.id || canal?._id) === canalWhatsappIdSelecionado
      ) || null,
    [canaisWhatsapp, canalWhatsappIdSelecionado]
  );

  const canalStatusMeta = useMemo(
    () => getCanalStatusMeta(canalStatus, canalWhatsappSelecionado || {}),
    [canalStatus, canalWhatsappSelecionado]
  );

  const canalWhatsappLabel = canalWhatsappSelecionado
    ? getCanalWhatsappLabel(canalWhatsappSelecionado)
    : 'Nenhum canal selecionado';

  const campaignsFiltered = useMemo(() => {
    const termo = normalizeSearch(campaignSearch);
    const statusFiltro = String(campaignStatusFilter || 'TODAS').toUpperCase();

    return campaignsList.filter((campaign) => {
      const status = String(campaign?.statusCampanha || 'RASCUNHO').toUpperCase();
      const passaStatus = statusFiltro === 'TODAS' || status === statusFiltro;

      if (!passaStatus) return false;
      if (!termo) return true;

      const alvo = normalizeSearch([
        campaign?.titulo,
        campaign?.tipoCampanha,
        campaign?.modoAniversario,
        campaign?.statusCampanha,
        campaign?.mesFiltro,
      ].filter(Boolean).join(' '));

      return alvo.includes(termo);
    });
  }, [campaignSearch, campaignStatusFilter, campaignsList, normalizeSearch]);

  const birthdayTodayCampaignSent = useMemo(() => {
    const hojeIso = new Date().toISOString().slice(0, 10);
    const statusEnviado = new Set(['CONCLUIDA', 'CONCLUÍDA', 'ENVIADA', 'FINALIZADA', 'PROCESSANDO']);

    return campaignsList.some((campaign) => {
      if (campaign?.tipoCampanha !== 'ANIVERSARIANTES') return false;
      if (campaign?.modoAniversario !== 'HOJE') return false;
      if (!statusEnviado.has(String(campaign?.statusCampanha || '').toUpperCase())) return false;

      const dataReferencia = campaign?.enviadoEm || campaign?.updatedAt || campaign?.createdAt;
      if (!dataReferencia) return true;

      const data = new Date(dataReferencia);
      if (Number.isNaN(data.getTime())) return true;

      return data.toISOString().slice(0, 10) === hojeIso;
    });
  }, [campaignsList]);

  const birthdayTodayPending = birthdayTodayClients.length > 0 && !birthdayTodayCampaignSent;

  const showNotify = useCallback((msg, type = 'success') => {
    setNotification({ msg, type });
    window.clearTimeout(window.__lumixTemplateNotifyTimer);
    window.__lumixTemplateNotifyTimer = window.setTimeout(() => setNotification(null), 3500);
  }, []);

  const limparCacheImagensProtegidas = useCallback(() => {
    Object.values(protectedImageBlobRef.current || {}).forEach((blobUrl) => {
      try {
        URL.revokeObjectURL(blobUrl);
      } catch {
        // Ignora Blob URL já revogada.
      }
    });

    protectedImageBlobRef.current = {};
    protectedImageLoadingRef.current = {};
    setProtectedImageBlobs({});
  }, []);

  const carregarEmpresasDisponiveis = useCallback(async () => {
    setLoadingEmpresas(true);

    try {
      const res = await api.get('/empresas', {
        params: { comResumo: true },
      });

      const empresas = resolverArrayApi(res.data, ['empresas'])
        .filter((empresa) => empresa && empresa.ativo !== false)
        .sort((a, b) => getEmpresaLabel(a).localeCompare(getEmpresaLabel(b), 'pt-BR'));

      setEmpresasDisponiveis(empresas);

      const idsPermitidos = new Set(
        empresas.map((empresa) => normalizarId(empresa?._id || empresa?.id)).filter(Boolean)
      );

      const idDesejado = empresaIdExterno || empresaIdSelecionada || empresaIdUsuario;
      const idInicialValido = idsPermitidos.has(idDesejado)
        ? idDesejado
        : idsPermitidos.has(empresaIdUsuario)
          ? empresaIdUsuario
          : normalizarId(empresas[0]?._id || empresas[0]?.id);

      if (!empresaIdExterno && idInicialValido && idInicialValido !== empresaIdSelecionada) {
        setEmpresaIdSelecionada(idInicialValido);
      }
    } catch (error) {
      console.error('❌ [TemplatesManager] Erro ao carregar empresas:', error);

      if (!empresaIdAtual) {
        showNotify('Não foi possível identificar a empresa operacional.', 'error');
      }
    } finally {
      setLoadingEmpresas(false);
    }
  }, [empresaIdAtual, empresaIdExterno, empresaIdSelecionada, empresaIdUsuario, showNotify]);

  const carregarCanaisWhatsapp = useCallback(async () => {
    if (!empresaIdAtual) {
      setCanaisWhatsapp([]);
      setCanalWhatsappIdSelecionado('');
      setCanalStatus({
        status: 'UNKNOWN',
        connected: false,
        runtimeAlive: false,
      });
      return;
    }

    setLoadingCanaisWhatsapp(true);

    try {
      let canais = extrairCanaisDaEmpresa(empresaAtual || {});

      const canalIdGlobal =
        canalWhatsappIdExterno ||
        getCanalWhatsappIdPersistidoGlobal();

      if (canalIdGlobal) {
        canais = deduplicarCanaisWhatsapp(
          [
            ...canais,
            canalSelecionado || {
              _id: canalIdGlobal,
              empresaId: empresaIdAtual,
              unidadeId: empresaIdAtual,
              nome: 'Canal selecionado no CRM',
            },
          ],
          empresaIdAtual
        );
      }

      /*
        Algumas APIs já devolvem os canais dentro de /empresas?comResumo=true.
        Se não vierem, tenta rotas compatíveis sem quebrar instalações antigas.
      */
      if (!canais.length) {
        for (const endpoint of WHATSAPP_CHANNEL_ROUTES.listCandidates) {
          try {
            const response = await api.get(endpoint, {
              params: {
                empresaId: empresaIdAtual,
                unidadeId: empresaIdAtual,
                ativo: true,
              },
            });

            const lista = resolverCanaisRespostaApi(
              response.data,
              empresaIdAtual
            ).filter((canal) =>
              canalPertenceEmpresaFront(canal, empresaIdAtual)
            );

            if (lista.length) {
              canais = lista;
              break;
            }
          } catch (error) {
            const status = Number(error?.response?.status || 0);

            /*
              404 significa apenas que este projeto usa outro alias de rota.
              Outros erros são registrados, mas não derrubam a tela.
            */
            if (status !== 404) {
              console.warn(
                `[TemplatesManager] Falha ao consultar canais em ${endpoint}:`,
                error?.response?.data?.message ||
                  error?.response?.data?.error ||
                  error.message
              );
            }
          }
        }
      }

      canais = deduplicarCanaisWhatsapp(canais, empresaIdAtual)
        .filter((canal) =>
          canalPertenceEmpresaFront(canal, empresaIdAtual)
        )
        .sort((a, b) => {
          if (a.principal && !b.principal) return -1;
          if (!a.principal && b.principal) return 1;

          return getCanalWhatsappLabel(a).localeCompare(
            getCanalWhatsappLabel(b),
            'pt-BR'
          );
        });

      setCanaisWhatsapp(canais);

      const storageKey = `${CAMPAIGN_CHANNEL_STORAGE_PREFIX}${empresaIdAtual}`;
      const persistido = lerStorageSeguro(
        window.localStorage,
        storageKey
      );

      const ids = new Set(
        canais
          .map((canal) => normalizarId(canal?.id || canal?._id))
          .filter(Boolean)
      );

      const escolhido =
        (ids.has(canalWhatsappIdExterno) && canalWhatsappIdExterno) ||
        (ids.has(canalIdGlobal) && canalIdGlobal) ||
        (ids.has(persistido) && persistido) ||
        normalizarId(
          canais.find((canal) => canal.principal)?.id ||
            canais[0]?.id
        );

      setCanalWhatsappIdSelecionado(escolhido || '');
      setCampaignForm((prev) => ({
        ...prev,
        canalWhatsappId: escolhido || '',
      }));

      if (escolhido) {
        try {
          window.localStorage.setItem(storageKey, escolhido);
        } catch {
          // Mantém a seleção somente na memória.
        }
      }
    } finally {
      setLoadingCanaisWhatsapp(false);
    }
  }, [
    canalSelecionado,
    canalWhatsappIdExterno,
    empresaAtual,
    empresaIdAtual,
  ]);

  const carregarStatusCanalSelecionado = useCallback(async ({
    silencioso = false,
  } = {}) => {
    if (!canalWhatsappIdSelecionado) {
      setCanalStatus({
        status: 'NO_CHANNEL',
        connected: false,
        runtimeAlive: false,
      });

      return null;
    }

    setCheckingCanalStatus(true);

    try {
      const response = await api.get(
        WHATSAPP_CHANNEL_ROUTES.status(canalWhatsappIdSelecionado),
        {
          params: montarParamsEmpresa(empresaIdAtual),
        }
      );

      const payload = response.data || {};

      setCanalStatus({
        ...payload,
        status: String(payload.status || 'UNKNOWN').toUpperCase(),
        connected: payload.connected === true,
      });

      return payload;
    } catch (error) {
      const fallbackStatus = String(
        canalWhatsappSelecionado?.status ||
          'UNKNOWN'
      ).toUpperCase();

      setCanalStatus({
        status: fallbackStatus,
        connected: fallbackStatus === 'CONNECTED',
        runtimeAlive: false,
        error:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error.message,
      });

      if (!silencioso && Number(error?.response?.status || 0) !== 404) {
        showNotify(
          montarErroInteligente(
            error,
            'Não foi possível verificar o canal WhatsApp.'
          ),
          'error'
        );
      }

      return null;
    } finally {
      setCheckingCanalStatus(false);
    }
  }, [
    canalWhatsappIdSelecionado,
    canalWhatsappSelecionado,
    empresaIdAtual,
    showNotify,
  ]);

  const handleCanalWhatsappChange = useCallback((event) => {
    const canalWhatsappId = normalizarId(
      event?.target?.value ||
        event
    );

    setCanalWhatsappIdSelecionado(canalWhatsappId);
    setCanalStatus({
      status: 'UNKNOWN',
      connected: false,
      runtimeAlive: false,
    });
    setCampaignForm((prev) => ({
      ...prev,
      canalWhatsappId,
    }));

    if (empresaIdAtual && canalWhatsappId) {
      try {
        window.localStorage.setItem(
          `${CAMPAIGN_CHANNEL_STORAGE_PREFIX}${empresaIdAtual}`,
          canalWhatsappId
        );
      } catch {
        // Mantém a seleção somente na memória.
      }
    }
  }, [empresaIdAtual]);

  const handleEmpresaSelecionadaChange = useCallback(
    (event) => {
      const novoEmpresaId = normalizarId(event?.target?.value || event);

      if (!novoEmpresaId || novoEmpresaId === empresaIdAtual) return;

      if (!empresaIdExterno) {
        setEmpresaIdSelecionada(novoEmpresaId);

        try {
          window.localStorage.setItem(EMPRESA_CRM_STORAGE_KEY, novoEmpresaId);
        } catch {
          // O navegador pode bloquear armazenamento; a seleção continua na memória.
        }
      }

      const empresa = empresasDisponiveis.find(
        (item) => normalizarId(item?._id || item?.id) === novoEmpresaId
      );

      if (typeof onEmpresaChange === 'function') {
        onEmpresaChange(empresa || novoEmpresaId);
      }
    },
    [empresaIdAtual, empresaIdExterno, empresasDisponiveis, onEmpresaChange]
  );

  const normalizarCaminhoImagemProtegida = useCallback((url) => {
    /*
      Padrão novo:
      - A imagem fica salva fisicamente na VPS em UPLOADS_ROOT.
      - No MongoDB fica salvo só o caminho relativo começando com /pilotos/.
      - Para exibir com segurança, o front NÃO joga esse caminho direto no src.
      - O front busca a imagem com token, recebe Blob e cria uma URL local temporária.

      Correção importante:
      - Alguns uploads retornam "pilotos/..." sem barra inicial.
      - Alguns ambientes retornam URL completa contendo "/pilotos/...".
      - Antes de validar/salvar, sempre normalizamos para "/pilotos/...".
    */
    return extrairCaminhoPilotos(url);
  }, []);

  const montarImagemPublicaLegada = useCallback((url) => {
    if (!url) return '';

    const valor = String(url || '').trim().replace(/\\/g, '/');

    if (!valor) return '';

    if (valor.startsWith('blob:')) return valor;
    if (valor.startsWith('data:image/')) return valor;
    if (valor.startsWith('http://') || valor.startsWith('https://')) return valor;

    const caminho = valor.startsWith('/') ? valor : `/${valor}`;

    /*
      Mantido apenas para não quebrar campanhas antigas/base visual antiga.
      Para régua e boas-vindas, o padrão correto é /pilotos/ + blob protegido.
    */
    if (caminho.startsWith('/uploads/') || caminho.startsWith('/assets/')) {
      const baseUrl = api.defaults.baseURL || '';
      return `${baseUrl}${caminho}`;
    }

    return '';
  }, []);

  const resolverRotaImagemProtegida = useCallback((caminho) => {
    if (!caminho) return '';

    if (caminho.startsWith('/pilotos/templates/regua/')) {
      return TEMPLATE_ROUTES.image;
    }

    if (caminho.startsWith('/pilotos/boas-vindas/')) {
      return WELCOME_ROUTES.image;
    }

    if (caminho.startsWith('/pilotos/campanhas/')) {
      return CAMPAIGN_ROUTES.image;
    }

    return '';
  }, []);

  const getImagemPreviewSrc = useCallback(
    (url) => {
      const caminho = normalizarCaminhoImagemProtegida(url);

      if (caminho) {
        return protectedImageBlobs[caminho] || '';
      }

      return montarImagemPublicaLegada(url);
    },
    [montarImagemPublicaLegada, normalizarCaminhoImagemProtegida, protectedImageBlobs]
  );

  const carregarImagemProtegidaComoBlob = useCallback(
    async (url) => {
      const caminho = normalizarCaminhoImagemProtegida(url);

      if (!caminho) return;

      const rotaImagem = resolverRotaImagemProtegida(caminho);

      if (!rotaImagem) {
        console.warn(
          '⚠️ [TemplatesManager] Caminho /pilotos/ sem rota protegida configurada para preview:',
          caminho
        );
        return;
      }

      if (protectedImageBlobRef.current[caminho]) return;
      if (protectedImageLoadingRef.current[caminho]) return;

      protectedImageLoadingRef.current[caminho] = true;

      try {
        /*
          Aqui está a segurança:
          - NÃO usamos <img src="/pilotos/..."> direto.
          - O axios usa seu interceptor/token normalmente.
          - A API devolve o arquivo protegido.
          - O front cria uma URL temporária local com URL.createObjectURL().
        */
        const res = await api.get(rotaImagem, {
          params: montarParamsEmpresa(empresaIdAtual, {
            path: caminho,
          }),
          responseType: 'blob',
        });

        const blobUrl = URL.createObjectURL(res.data);

        protectedImageBlobRef.current[caminho] = blobUrl;

        setProtectedImageBlobs((prev) => ({
          ...prev,
          [caminho]: blobUrl,
        }));
      } catch (error) {
        console.error('❌ [TemplatesManager] Erro ao carregar imagem protegida:', error);
      } finally {
        protectedImageLoadingRef.current[caminho] = false;
      }
    },
    [empresaIdAtual, normalizarCaminhoImagemProtegida, resolverRotaImagemProtegida]
  );

  const fetchTemplates = useCallback(async () => {
    if (!empresaIdAtual) {
      setTemplates([]);
      setSelectedId(null);
      return;
    }

    setLoading(true);

    try {
      const res = await api.get(TEMPLATE_ROUTES.list, {
        params: montarParamsEmpresa(empresaIdAtual),
      });

      const ordenarGatilhosPosVenda = (a, b) => {
  const marcoA = String(a.marco || '').trim().toLowerCase();
  const marcoB = String(b.marco || '').trim().toLowerCase();

  const pesoMarco = (marco) => {
    if (marco === '0' || marco === 'entrega' || marco === 'dia0') return 0;

    if (
      marco === '7d' ||
      marco === '7' ||
      marco === '7dias' ||
      marco === '7_dias' ||
      marco === 'sete_dias'
    ) {
      return 1;
    }

    const numero = Number(String(marco).replace(/\D/g, ''));

    if (Number.isFinite(numero) && numero > 0) {
      return numero + 1;
    }

    return 999;
  };

  return pesoMarco(marcoA) - pesoMarco(marcoB);
};

const sorted = resolverArrayApi(res.data, ['templates']).sort(ordenarGatilhosPosVenda);

      setTemplates(sorted);

      setSelectedId((atual) => {
        if (atual === 'NEW') return atual;
        if (!sorted.length) return null;

        const aindaExiste = sorted.some(
          (template) => normalizarId(template?._id || template?.id) === normalizarId(atual)
        );

        return aindaExiste ? atual : sorted[0]._id;
      });
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao carregar templates.'), 'error');
    } finally {
      setLoading(false);
    }
  }, [empresaIdAtual, showNotify]);

  const loadWelcomeConfig = useCallback(async () => {
    if (!empresaIdAtual) {
      setWelcomeConfig(defaultWelcomeConfig);
      return;
    }
    try {
      const res = await api.get(WELCOME_ROUTES.get, {
        params: montarParamsEmpresa(empresaIdAtual),
      });

      const dados = res?.data || {};
      const imagemUrlNormalizada = extrairCaminhoPilotos(
        dados?.imagemUrl ||
          dados?.imageUrl ||
          dados?.url ||
          ''
      );

      setWelcomeConfig({
        ...defaultWelcomeConfig,
        ...dados,
        imagemUrl: imagemUrlNormalizada || dados?.imagemUrl || '',
      });
    } catch (error) {
      console.error(error);
    }
  }, [empresaIdAtual]);

  const fetchCampaignsList = useCallback(async () => {
    if (!empresaIdAtual) {
      setCampaignsList([]);
      return;
    }
    setLoadingCampaigns(true);

    try {
      const res = await api.get(CAMPAIGN_ROUTES.list, {
        params: montarParamsEmpresa(empresaIdAtual),
      });

      setCampaignsList(resolverArrayApi(res.data, ['campanhas']));
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao carregar campanhas.'), 'error');
    } finally {
      setLoadingCampaigns(false);
    }
  }, [empresaIdAtual, showNotify]);

  const fetchBirthdayToday = useCallback(async () => {
    if (!empresaIdAtual) {
      setBirthdayTodayClients([]);
      return;
    }

    setLoadingBirthdayToday(true);

    try {
      const res = await api.get(CAMPAIGN_ROUTES.aniversariantes, {
        params: montarParamsEmpresa(empresaIdAtual, {
          mesFiltro: mesAtual,
          modo: 'HOJE',
        }),
      });

      setBirthdayTodayClients(
        resolverArrayApi(res.data, ['clientes', 'aniversariantes'])
      );
    } catch (error) {
      console.error('❌ [TemplatesManager] Erro ao buscar aniversariantes de hoje:', error);
      setBirthdayTodayClients([]);
    } finally {
      setLoadingBirthdayToday(false);
    }
  }, [empresaIdAtual, mesAtual]);

  const fetchImportedBase = useCallback(async () => {
    if (!empresaIdAtual) {
      setImportedBaseList([]);
      return;
    }
    setLoadingImportedBase(true);

    try {
      const res = await api.get('/ordens-servico/api/base-campanhas', {
        params: montarParamsEmpresa(empresaIdAtual),
      });

      setImportedBaseList(resolverArrayApi(res.data, ['contatos', 'base']));
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao carregar base externa.'), 'error');
    } finally {
      setLoadingImportedBase(false);
    }
  }, [empresaIdAtual, showNotify]);

  const fetchCampaignAudience = useCallback(async () => {
    if (!empresaIdAtual) {
      setClientsData([]);
      setSelectedClients([]);
      return;
    }
    setLoadingClients(true);

    try {
      const endpoint = isBirthdayCampaign
        ? CAMPAIGN_ROUTES.aniversariantes
        : CAMPAIGN_ROUTES.clientes;

      const res = await api.get(endpoint, {
        params: montarParamsEmpresa(empresaIdAtual, {
          mesFiltro: campaignMonth,
          modo: campaignForm.modoAniversario || 'MES',
        }),
      });

      const audience = resolverArrayApi(res.data, ['clientes', 'aniversariantes']);
      setClientsData(audience);

      if (!campaignForm._id) {
        setSelectedClients(audience.map((c) => normalizarId(c.id)));
      }
    } catch (error) {
      showNotify(
        montarErroInteligente(
          error,
          isBirthdayCampaign ? 'Erro ao buscar aniversariantes.' : 'Erro ao buscar clientes.'
        ),
        'error'
      );
    } finally {
      setLoadingClients(false);
    }
  }, [
    campaignForm._id,
    campaignForm.modoAniversario,
    campaignMonth,
    empresaIdAtual,
    isBirthdayCampaign,
    showNotify,
  ]);

  useEffect(() => {
    carregarEmpresasDisponiveis();
  }, [carregarEmpresasDisponiveis]);

  useEffect(() => {
    carregarCanaisWhatsapp();
  }, [carregarCanaisWhatsapp]);

  useEffect(() => {
    if (!canalWhatsappIdSelecionado) return undefined;

    carregarStatusCanalSelecionado({ silencioso: true });

    const interval = window.setInterval(() => {
      carregarStatusCanalSelecionado({ silencioso: true });
    }, 20000);

    return () => {
      window.clearInterval(interval);
    };
  }, [
    canalWhatsappIdSelecionado,
    carregarStatusCanalSelecionado,
  ]);

  useEffect(() => {
    if (empresaIdExterno && empresaIdExterno !== empresaIdSelecionada) {
      setEmpresaIdSelecionada(empresaIdExterno);
    }
  }, [empresaIdExterno, empresaIdSelecionada]);

  useEffect(() => {
    if (!empresaIdAtual) return;

    const empresaAnterior = empresaAnteriorRef.current;

    if (empresaAnterior && empresaAnterior !== empresaIdAtual) {
      limparCacheImagensProtegidas();
      setTemplates([]);
      setSelectedId(null);
      setFormData({
        marco: '',
        titulo: '',
        mensagem: '',
        usarImagem: false,
        imagemUrl: '',
      });
      setWelcomeConfig(defaultWelcomeConfig);
      setCampaignsList([]);
      setCampaignForm(defaultCampaignForm);
      setCampaignView('list');
      setCampaignSearch('');
      setCampaignStatusFilter('TODAS');
      setBirthdayTodayClients([]);
      setClientsData([]);
      setSelectedClients([]);
      setCanaisWhatsapp([]);
      setCanalWhatsappIdSelecionado('');
      setCanalStatus({
        status: 'UNKNOWN',
        connected: false,
        runtimeAlive: false,
      });
      setImportedBaseList([]);
      setLastImportSummary(null);
    }

    empresaAnteriorRef.current = empresaIdAtual;

    if (!empresaIdExterno) {
      try {
        window.localStorage.setItem(EMPRESA_CRM_STORAGE_KEY, empresaIdAtual);
      } catch {
        // Mantém seleção apenas na memória quando o storage estiver bloqueado.
      }
    }
  }, [empresaIdAtual, empresaIdExterno, limparCacheImagensProtegidas]);

  useEffect(() => {
    fetchTemplates();
    loadWelcomeConfig();
  }, [fetchTemplates, loadWelcomeConfig]);

  useEffect(() => {
    const imagensParaCarregar = new Set();

    if (formData?.imagemUrl) imagensParaCarregar.add(formData.imagemUrl);
    if (welcomeConfig?.imagemUrl) imagensParaCarregar.add(welcomeConfig.imagemUrl);
    if (campaignForm?.imagemUrl) imagensParaCarregar.add(campaignForm.imagemUrl);

    templates.forEach((template) => {
      if (template?.imagemUrl) imagensParaCarregar.add(template.imagemUrl);
    });

    imagensParaCarregar.forEach((imagemUrl) => {
      carregarImagemProtegidaComoBlob(imagemUrl);
    });
  }, [
    formData.imagemUrl,
    welcomeConfig.imagemUrl,
    campaignForm.imagemUrl,
    templates,
    carregarImagemProtegidaComoBlob,
  ]);

  useEffect(() => {
    return () => {
      limparCacheImagensProtegidas();
    };
  }, [limparCacheImagensProtegidas]);

  useEffect(() => {
    fetchBirthdayToday();
  }, [fetchBirthdayToday]);

  useEffect(() => {
    if (activeModule === 'campanhas' && campaignView === 'list') {
      fetchCampaignsList();
      fetchBirthdayToday();
    }
  }, [activeModule, campaignView, fetchBirthdayToday, fetchCampaignsList]);

  useEffect(() => {
    if (activeModule === 'campanhas' && campaignView === 'editor') {
      fetchCampaignAudience();
    }
  }, [activeModule, campaignView, fetchCampaignAudience]);

  useEffect(() => {
    if (activeModule === 'base-externa') {
      fetchImportedBase();
    }
  }, [activeModule, fetchImportedBase]);

  useEffect(() => {
    if (selectedId && selectedId !== 'NEW') {
      const temp = templates.find((t) => t._id === selectedId);

      if (temp) {
        setFormData({
          marco: temp.marco,
          titulo: temp.titulo,
          mensagem: temp.mensagem,
          usarImagem: temp.usarImagem || false,
          imagemUrl: temp.imagemUrl || '',
        });
      }
    }
  }, [selectedId, templates]);

  const insertTag = (editorId, stateObj, setStateFn) => {
    const textarea = document.getElementById(editorId);
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = stateObj.mensagem || '';

    setStateFn({
      ...stateObj,
      mensagem: `${text.substring(0, start)}{{nome}}${text.substring(end)}`,
    });

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + 8, start + 8);
    }, 10);
  };

  const handleNewTemplate = () => {
    setSelectedId('NEW');
    setFormData({
      marco: '',
      titulo: '',
      mensagem: '',
      usarImagem: false,
      imagemUrl: '',
    });
  };

  const handleSavePosVenda = async () => {
    if (!formData.marco || !formData.titulo || !formData.mensagem) {
      showNotify('Preencha marco, título e mensagem.', 'error');
      return;
    }

    if (formData.usarImagem && !formData.imagemUrl) {
      showNotify('Você marcou para usar imagem, mas ainda não enviou nenhuma imagem.', 'error');
      return;
    }

    const imagemUrlNormalizada = normalizarCaminhoImagemProtegida(formData.imagemUrl);

    if (formData.usarImagem && !imagemUrlNormalizada) {
      showNotify('A imagem precisa estar salva no padrão /pilotos/. Faça um novo upload.', 'error');
      return;
    }

    if (formData.usarImagem && !imagemUrlNormalizada.startsWith('/pilotos/templates/regua/')) {
      showNotify('Essa imagem não pertence à régua pós-venda. Faça um novo upload nesta área.', 'error');
      return;
    }

    setSaving(true);

    try {
      await api.post(TEMPLATE_ROUTES.save, {
        ...formData,
        imagemUrl: formData.usarImagem ? imagemUrlNormalizada : '',
        empresaId: empresaIdAtual || undefined,
      });

      showNotify('Template salvo com sucesso!', 'success');
      await fetchTemplates();
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao salvar template.'), 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleSaveWelcomeConfig = async () => {
    if (!welcomeConfig.mensagem) {
      showNotify('A mensagem de boas-vindas não pode ficar vazia.', 'error');
      return;
    }

    if (welcomeConfig.usarImagem && !welcomeConfig.imagemUrl) {
      showNotify('Você marcou para usar imagem, mas ainda não enviou nenhuma imagem.', 'error');
      return;
    }

    const imagemUrlNormalizada = normalizarCaminhoImagemProtegida(welcomeConfig.imagemUrl);

    if (welcomeConfig.usarImagem && !imagemUrlNormalizada) {
      showNotify('A imagem de boas-vindas precisa estar salva no padrão /pilotos/. Faça um novo upload.', 'error');
      return;
    }

    if (welcomeConfig.usarImagem && !imagemUrlNormalizada.startsWith('/pilotos/boas-vindas/')) {
      showNotify('Essa imagem não pertence às boas-vindas. Faça um novo upload nesta área.', 'error');
      return;
    }

    setSavingWelcome(true);

    try {
      await api.post(WELCOME_ROUTES.save, {
        ...welcomeConfig,
        imagemUrl: welcomeConfig.usarImagem ? imagemUrlNormalizada : '',
        ativo: true,
        empresaId: empresaIdAtual || undefined,
      });

      setWelcomeConfig((prev) => ({
        ...prev,
        imagemUrl: prev.usarImagem ? imagemUrlNormalizada : '',
      }));

      showNotify('Boas-vindas salvas com sucesso!', 'success');
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao salvar boas-vindas.'), 'error');
    } finally {
      setSavingWelcome(false);
    }
  };

  const handleUploadPosVendaImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!String(file.type || '').startsWith('image/')) {
      showNotify('Selecione um arquivo de imagem válido.', 'error');
      if (posVendaFileInputRef.current) posVendaFileInputRef.current.value = null;
      return;
    }

    const limiteMB = 8;
    if (file.size > limiteMB * 1024 * 1024) {
      showNotify(`A imagem precisa ter até ${limiteMB}MB.`, 'error');
      if (posVendaFileInputRef.current) posVendaFileInputRef.current.value = null;
      return;
    }

    const form = anexarEmpresaNoFormData(new FormData(), empresaIdAtual);
    form.append('imagem', file);

    setUploadingPosVendaImage(true);

    try {
      /*
        O backend recebe req.file.buffer via multer.memoryStorage(),
        salva fisicamente na VPS e retorna:
        {
          imagemUrl: '/pilotos/templates/regua/EMPRESA_ID/ANO/MES/arquivo.webp'
        }

        Esse caminho relativo é o que será salvo no MongoDB.
      */
      const res = await api.post(TEMPLATE_ROUTES.upload, form);

      const imagemUrl = extrairImagemUrlUpload(res.data);

      if (!imagemUrl) {
        console.warn('⚠️ [TemplatesManager] Resposta do upload sem caminho /pilotos/:', res.data);
        throw new Error('A API salvou a imagem, mas não retornou um caminho válido em /pilotos/. Verifique no console qual campo a API está retornando.');
      }

      setFormData((prev) => ({
        ...prev,
        usarImagem: true,
        imagemUrl,
      }));

      carregarImagemProtegidaComoBlob(imagemUrl);

      showNotify('Imagem salva na VPS e anexada à régua!', 'success');
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao fazer upload da imagem.'), 'error');
    } finally {
      setUploadingPosVendaImage(false);
      if (posVendaFileInputRef.current) posVendaFileInputRef.current.value = null;
    }
  };

  const handleUploadWelcomeImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!String(file.type || '').startsWith('image/')) {
      showNotify('Selecione um arquivo de imagem válido.', 'error');
      if (welcomeFileInputRef.current) welcomeFileInputRef.current.value = null;
      return;
    }

    const limiteMB = 8;
    if (file.size > limiteMB * 1024 * 1024) {
      showNotify(`A imagem precisa ter até ${limiteMB}MB.`, 'error');
      if (welcomeFileInputRef.current) welcomeFileInputRef.current.value = null;
      return;
    }

    const form = anexarEmpresaNoFormData(new FormData(), empresaIdAtual);
    form.append('imagem', file);

    setUploadingWelcomeImage(true);

    try {
      /*
        O backend recebe req.file.buffer via multer.memoryStorage(),
        salva fisicamente na VPS e retorna:
        {
          imagemUrl: '/pilotos/boas-vindas/EMPRESA_ID/ANO/MES/arquivo.webp'
        }

        Esse caminho relativo é o que será salvo no MongoDB.
      */
      const res = await api.post(WELCOME_ROUTES.upload, form);

      const imagemUrl = extrairImagemUrlUpload(res.data);

      if (!imagemUrl) {
        console.warn('⚠️ [TemplatesManager] Resposta do upload sem caminho /pilotos/:', res.data);
        throw new Error('A API salvou a imagem, mas não retornou um caminho válido em /pilotos/. Verifique no console qual campo a API está retornando.');
      }

      setWelcomeConfig((prev) => ({
        ...prev,
        usarImagem: true,
        imagemUrl,
      }));

      carregarImagemProtegidaComoBlob(imagemUrl);

      showNotify('Imagem de boas-vindas salva na VPS!', 'success');
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao fazer upload da imagem.'), 'error');
    } finally {
      setUploadingWelcomeImage(false);
      if (welcomeFileInputRef.current) welcomeFileInputRef.current.value = null;
    }
  };

  const handleUploadCampaignImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!String(file.type || '').startsWith('image/')) {
      showNotify('Selecione um arquivo de imagem válido.', 'error');
      if (campaignFileInputRef.current) campaignFileInputRef.current.value = null;
      return;
    }

    const limiteMB = 8;
    if (file.size > limiteMB * 1024 * 1024) {
      showNotify(`A imagem precisa ter até ${limiteMB}MB.`, 'error');
      if (campaignFileInputRef.current) campaignFileInputRef.current.value = null;
      return;
    }

    const form = anexarEmpresaNoFormData(new FormData(), empresaIdAtual);
    form.append('imagem', file);

    setUploadingCampaignImage(true);

    try {
      /*
        O backend recebe req.file.buffer via multer.memoryStorage(),
        salva fisicamente na VPS e retorna:
        {
          imagemUrl: '/pilotos/campanhas/EMPRESA_ID/ANO/MES/arquivo.webp'
        }

        Esse caminho relativo é o que será salvo no MongoDB.
      */
      const res = await api.post(CAMPAIGN_ROUTES.upload, form);

      const imagemUrl = extrairImagemUrlUpload(res.data);

      if (!imagemUrl) {
        console.warn('⚠️ [TemplatesManager] Resposta do upload sem caminho /pilotos/:', res.data);
        throw new Error('A API salvou a imagem, mas não retornou um caminho válido em /pilotos/. Verifique no console qual campo a API está retornando.');
      }

      setCampaignForm((prev) => ({
        ...prev,
        usarImagem: true,
        imagemUrl,
      }));

      carregarImagemProtegidaComoBlob(imagemUrl);

      showNotify('Flyer da campanha salvo na VPS!', 'success');
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao fazer upload da imagem.'), 'error');
    } finally {
      setUploadingCampaignImage(false);
      if (campaignFileInputRef.current) campaignFileInputRef.current.value = null;
    }
  };

  const importarArquivoBaseExterna = useCallback(
    async (file) => {
      if (!file) return;

      const ext = `.${String(file.name || '').split('.').pop()}`.toLowerCase();

      if (!supportedBaseFormats.includes(ext)) {
        showNotify('Formato não suportado. Envie Excel, CSV, TXT, PDF ou Word.', 'error');
        return;
      }

      const limiteMB = 25;

      if (file.size > limiteMB * 1024 * 1024) {
        showNotify(`O arquivo precisa ter até ${limiteMB}MB.`, 'error');
        return;
      }

      const form = anexarEmpresaNoFormData(new FormData(), empresaIdAtual);
      form.append('arquivo', file);

      setImportingBaseFile(true);
      setShowInvalidImportExamples(false);

      try {
        const res = await api.post('/ordens-servico/api/base-campanhas/importar', form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        setLastImportSummary(res.data || null);

        const totalValidos = res.data?.totalValidos ?? 0;
        const totalInvalidos = res.data?.totalInvalidos ?? 0;

        showNotify(
          totalInvalidos > 0
            ? `Base importada: ${totalValidos} contatos válidos e ${totalInvalidos} linhas ignoradas.`
            : `Base importada com sucesso: ${totalValidos} contatos válidos.`,
          'success'
        );

        await fetchImportedBase();
      } catch (error) {
        const payload = error?.response?.data;

        if (payload) {
          setLastImportSummary(payload);
          setShowInvalidImportExamples(true);
        }

        showNotify(montarErroInteligente(error, 'Erro ao importar arquivo.'), 'error');
      } finally {
        setImportingBaseFile(false);
        setBaseDragActive(false);
        if (importBaseFileInputRef.current) importBaseFileInputRef.current.value = null;
      }
    },
    [empresaIdAtual, fetchImportedBase, showNotify, supportedBaseFormats]
  );

  const handleImportBaseFile = async (event) => {
    const file = event.target.files?.[0];
    await importarArquivoBaseExterna(file);
  };

  const handleDropBaseFile = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setBaseDragActive(false);

    const file = event.dataTransfer?.files?.[0];
    await importarArquivoBaseExterna(file);
  };

  const handleRemoveImportedContact = async (id) => {
    if (!window.confirm('Deseja remover este contato importado?')) return;

    try {
      await api.delete(`/ordens-servico/api/base-campanhas/${id}`, {
        params: montarParamsEmpresa(empresaIdAtual),
      });

      showNotify('Contato removido com sucesso!', 'success');
      await fetchImportedBase();
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao remover contato.'), 'error');
    }
  };

  const handleToggleClient = (id) => {
    const normalized = normalizarId(id);

    setSelectedClients((prev) =>
      prev.includes(normalized)
        ? prev.filter((clientId) => clientId !== normalized)
        : [...prev, normalized]
    );
  };

  const handleToggleAll = () => {
    setSelectedClients(
      selectedClients.length === clientsData.length
        ? []
        : clientsData.map((client) => normalizarId(client.id))
    );
  };

  const handleNewCampaign = (tipoCampanha = 'CLIENTES_MES') => {
    const isBirthday = tipoCampanha === 'ANIVERSARIANTES';

    setCampaignForm({
      ...defaultCampaignForm,
      tipoCampanha,
      modoAniversario: 'MES',
      titulo: isBirthday ? 'Campanha de Aniversariantes do Mês' : '',
      mensagem: isBirthday ? birthdayMonthTemplate : '',
      canalWhatsappId: canalWhatsappIdSelecionado || '',
    });

    setCampaignMonth(mesAtual);
    setSelectedClients([]);
    setCampaignView('editor');
  };

  const handleUseCampaignIdea = (idea) => {
    if (!idea) return;

    setCampaignForm({
      ...defaultCampaignForm,
      tipoCampanha: idea.tipoCampanha || 'CLIENTES_MES',
      modoAniversario: idea.modoAniversario || 'MES',
      titulo: idea.titulo || '',
      mensagem: idea.mensagem || '',
      canalWhatsappId: canalWhatsappIdSelecionado || '',
    });

    setCampaignMonth(mesAtual);
    setSelectedClients([]);
    setCampaignView('editor');
  };

  const handleEditCampaign = (campanha) => {
    setCampaignForm({
      _id: campanha._id,
      titulo: campanha.titulo || '',
      mensagem: campanha.mensagem || '',
      usarImagem: !!campanha.usarImagem,
      imagemUrl: campanha.imagemUrl || '',
      statusCampanha: campanha.statusCampanha || 'RASCUNHO',
      tipoCampanha: campanha.tipoCampanha || 'CLIENTES_MES',
      modoAniversario: campanha.modoAniversario || 'MES',
      canalWhatsappId:
        normalizarId(campanha.canalWhatsappId) ||
        canalWhatsappIdSelecionado ||
        '',
    });

    const campanhaCanalId = normalizarId(campanha.canalWhatsappId);

    if (campanhaCanalId) {
      setCanalWhatsappIdSelecionado(campanhaCanalId);
      setCanalStatus({
        status: 'UNKNOWN',
        connected: false,
        runtimeAlive: false,
      });
    }

    setCampaignMonth(campanha.mesFiltro || mesAtual);
    setSelectedClients(campanha.clientesSelecionados?.map((c) => normalizarId(c.clienteId)) || []);
    setCampaignView('editor');
  };

  const handleChangeBirthdayMode = (modo) => {
    setCampaignForm((prev) => ({
      ...prev,
      modoAniversario: modo,
      titulo:
        modo === 'HOJE'
          ? prev._id
            ? prev.titulo
            : 'Campanha de Aniversariantes de Hoje'
          : prev._id
            ? prev.titulo
            : 'Campanha de Aniversariantes do Mês',
      mensagem:
        modo === 'HOJE'
          ? prev._id
            ? prev.mensagem
            : birthdayTodayTemplate
          : prev._id
            ? prev.mensagem
            : birthdayMonthTemplate,
    }));

    setSelectedClients([]);
  };

  const handleSaveCampaignDraft = async () => {
    if (!campaignForm.titulo) {
      showNotify('Dê um nome para a campanha.', 'error');
      return;
    }

    if (campaignForm.usarImagem && !campaignForm.imagemUrl) {
      showNotify('Você marcou para usar imagem, mas ainda não enviou nenhum flyer.', 'error');
      return;
    }

    const imagemUrlNormalizada = normalizarCaminhoImagemProtegida(campaignForm.imagemUrl);

    if (campaignForm.usarImagem && !imagemUrlNormalizada) {
      showNotify('O flyer precisa estar salvo no padrão /pilotos/campanhas/. Faça um novo upload.', 'error');
      return;
    }

    if (campaignForm.usarImagem && !imagemUrlNormalizada.startsWith('/pilotos/campanhas/')) {
      showNotify('Esse flyer não pertence às campanhas. Faça um novo upload nesta área.', 'error');
      return;
    }

    setSavingCampaignDraft(true);

    try {
      const payload = {
        ...campaignForm,
        imagemUrl: campaignForm.usarImagem ? imagemUrlNormalizada : '',
        empresaId: empresaIdAtual || undefined,
        canalWhatsappId: canalWhatsappIdSelecionado || undefined,
        canalId: canalWhatsappIdSelecionado || undefined,
        whatsappChannelId: canalWhatsappIdSelecionado || undefined,
        tipoCampanha: campaignForm.tipoCampanha || 'CLIENTES_MES',
        modoAniversario: campaignForm.modoAniversario || 'MES',
        mesFiltro: campaignMonth,
        clientesSelecionados: clientsData
          .filter((client) => selectedClients.includes(normalizarId(client.id)))
          .map((client) => ({
            clienteId: client.id,
            nome: client.nome,
            telefone: client.telefone,
          })),
      };

      if (campaignForm._id) {
        await api.put(`/ordens-servico/api/campanhas/${campaignForm._id}`, payload, {
          params: montarParamsEmpresa(empresaIdAtual),
        });
      } else {
        const res = await api.post(CAMPAIGN_ROUTES.save, payload);
        setCampaignForm((prev) => ({
          ...prev,
          _id: res.data._id,
        }));
      }

      showNotify('Campanha salva com sucesso!', 'success');
      setCampaignView('list');
    } catch (error) {
      showNotify(montarErroInteligente(error, 'Erro ao salvar rascunho.'), 'error');
    } finally {
      setSavingCampaignDraft(false);
    }
  };

  const handleSendCampaign = async () => {
    if (selectedClients.length === 0) {
      showNotify('Selecione pelo menos um cliente.', 'error');
      return;
    }

    if (!campaignForm.mensagem) {
      showNotify('A mensagem não pode estar vazia.', 'error');
      return;
    }

    if (!canalWhatsappIdSelecionado) {
      showNotify(
        'Selecione o canal WhatsApp que fará este disparo.',
        'error'
      );
      return;
    }

    if (canalStatusMeta.requiresQr) {
      showNotify(
        'O canal selecionado precisa ser conectado pelo QR Code antes do disparo.',
        'error'
      );
      return;
    }

    if (campaignForm.usarImagem && !campaignForm.imagemUrl) {
      showNotify('Você marcou para usar imagem, mas ainda não enviou nenhum flyer.', 'error');
      return;
    }

    const imagemUrlNormalizada = normalizarCaminhoImagemProtegida(campaignForm.imagemUrl);

    if (campaignForm.usarImagem && !imagemUrlNormalizada) {
      showNotify('O flyer precisa estar salvo no padrão /pilotos/campanhas/. Faça um novo upload.', 'error');
      return;
    }

    if (campaignForm.usarImagem && !imagemUrlNormalizada.startsWith('/pilotos/campanhas/')) {
      showNotify('Esse flyer não pertence às campanhas. Faça um novo upload nesta área.', 'error');
      return;
    }

    const statusAtual = await carregarStatusCanalSelecionado({
      silencioso: true,
    });

    const metaAtual = getCanalStatusMeta(
      statusAtual || canalStatus,
      canalWhatsappSelecionado || {}
    );

    if (metaAtual.requiresQr) {
      showNotify(
        'O canal selecionado perdeu a sessão e precisa de um novo QR Code.',
        'error'
      );
      return;
    }

    const avisoStatus = metaAtual.connected
      ? 'O canal está conectado.'
      : 'O servidor tentará restaurar somente este canal antes do envio.';

    if (
      !window.confirm(
        `Enviar ${selectedClients.length} mensagem(ns) pela empresa "${empresaNomeAtual}" usando o canal "${canalWhatsappLabel}"?\n\n${avisoStatus}`
      )
    ) {
      return;
    }

    setSendingCampaign(true);

    try {
      const clientesParaEnvio = clientsData.filter((client) =>
        selectedClients.includes(normalizarId(client.id))
      );

      const payload = {
        _id: campaignForm._id,
        empresaId: empresaIdAtual || undefined,
        canalWhatsappId: canalWhatsappIdSelecionado,
        canalId: canalWhatsappIdSelecionado,
        whatsappChannelId: canalWhatsappIdSelecionado,
        titulo: campaignForm.titulo,
        mensagem: campaignForm.mensagem,
        usarImagem: campaignForm.usarImagem,
        imagemUrl: campaignForm.usarImagem ? imagemUrlNormalizada : '',
        tipoCampanha: campaignForm.tipoCampanha || 'CLIENTES_MES',
        modoAniversario: campaignForm.modoAniversario || 'MES',
        mesFiltro: campaignMonth,
        clientes: clientesParaEnvio,
      };

      const response = await api.post(
        CAMPAIGN_ROUTES.enviar,
        payload
      );

      const enviados = Number(response.data?.totalEnviados || 0);
      const falhas = Number(response.data?.totalFalhas || 0);
      const nomeCanalResposta =
        response.data?.canalNome ||
        canalWhatsappLabel;

      if (response.data?.interrompidaPorCanal) {
        showNotify(
          `O canal "${nomeCanalResposta}" caiu durante o disparo. ${enviados} enviada(s) e ${falhas} não enviada(s).`,
          'error'
        );
      } else if (falhas > 0) {
        showNotify(
          `Campanha concluída pelo canal "${nomeCanalResposta}": ${enviados} enviada(s) e ${falhas} falha(s).`,
          'warning'
        );
      } else {
        showNotify(
          `Campanha enviada pelo canal "${nomeCanalResposta}" para ${enviados || selectedClients.length} contato(s).`,
          'success'
        );
      }

      await carregarStatusCanalSelecionado({
        silencioso: true,
      });

      setCampaignView('list');
    } catch (error) {
      const code = String(error?.response?.data?.code || '');

      const fallback =
        code === 'CAMPAIGN_CHANNEL_REQUIRED'
          ? 'Escolha o canal WhatsApp para o disparo.'
          : code === 'CAMPAIGN_CHANNEL_QR_REQUIRED'
            ? 'O canal selecionado precisa de um novo QR Code.'
            : code === 'CAMPAIGN_CHANNEL_DISCONNECTED'
              ? 'O canal selecionado está desconectado e não pôde ser restaurado.'
              : 'Erro ao solicitar disparo.';

      showNotify(
        montarErroInteligente(error, fallback),
        'error'
      );

      await carregarStatusCanalSelecionado({
        silencioso: true,
      });
    } finally {
      setSendingCampaign(false);
    }
  };

  const gerarOpcoesMeses = () => {
    const opcoes = [];
    const hojeLocal = new Date();

    for (let i = 0; i < 24; i += 1) {
      const data = new Date(hojeLocal.getFullYear(), hojeLocal.getMonth() - i, 1);
      const value = `${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`;
      const nomeMes = data.toLocaleString('pt-BR', { month: 'long' });

      opcoes.push(
        <option key={value} value={value}>
          {`${nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1)} / ${data.getFullYear()}`}
        </option>
      );
    }

    return opcoes;
  };

  const renderPreviewText = (text) => {
    if (!text) return <span className="placeholder-text">Sua mensagem aparecerá aqui...</span>;

    return text.split('\n').map((line, index) => (
      <React.Fragment key={`${line}-${index}`}>
        {line.split(/(\*.*?\*|_.*?_|~.*?~|{{nome}})/gi).map((part, partIndex) => {
          if (part.startsWith('*') && part.endsWith('*')) {
            return <strong key={`${part}-${partIndex}`}>{part.slice(1, -1)}</strong>;
          }

          if (part.startsWith('_') && part.endsWith('_')) {
            return <em key={`${part}-${partIndex}`}>{part.slice(1, -1)}</em>;
          }

          if (part.startsWith('~') && part.endsWith('~')) {
            return <del key={`${part}-${partIndex}`}>{part.slice(1, -1)}</del>;
          }

          if (part.toLowerCase() === '{{nome}}') {
            return (
              <span key={`${part}-${partIndex}`} className="var-highlight">
                João Silva
              </span>
            );
          }

          return part;
        })}
        <br />
      </React.Fragment>
    ));
  };

  const renderPhoneMockup = (configObj) => {
    const imagePath = normalizarCaminhoImagemProtegida(configObj?.imagemUrl);
    const imageSrc = getImagemPreviewSrc(configObj?.imagemUrl);
    const rotaImagem = resolverRotaImagemProtegida(imagePath);
    const imageIsLoading = !!(configObj?.usarImagem && imagePath && rotaImagem && !imageSrc);

    return (
      <div className="phone-card">
        <div className="phone-meta">
          <span>Preview WhatsApp</span>
          <strong>Tempo real</strong>
        </div>

        <div className="phone-mockup">
          <div className="phone-notch" />

          <div className="phone-header">
            <div className="ph-avatar">{empresaIniciais}</div>
            <div className="ph-info">
              <span className="ph-name">{empresaNomeAtual}</span>
              <span className="ph-status">Conta comercial</span>
            </div>
          </div>

          <div className="phone-body">
            <div className="msg-bubble incoming">
              {configObj?.usarImagem && imageSrc && (
                <div className="msg-image-preview">
                  <img
                    src={imageSrc}
                    alt="Anexo"
                    onError={(event) => {
                      event.currentTarget.style.display = 'none';
                    }}
                  />
                </div>
              )}

              {imageIsLoading && (
                <div className="image-warning">
                  Carregando imagem protegida...
                </div>
              )}

              {configObj?.usarImagem && configObj?.imagemUrl && imagePath && !rotaImagem && !imageSrc && (
                <div className="image-warning">
                  Imagem em /pilotos/, mas sem rota protegida de preview configurada.
                </div>
              )}

              {configObj?.usarImagem && configObj?.imagemUrl && !imagePath && !imageSrc && (
                <div className="image-warning">
                  Imagem fora do padrão /pilotos/. Faça um novo upload.
                </div>
              )}

              {renderPreviewText(configObj?.mensagem)}

              <div className="msg-meta">
                <span className="msg-time">
                  {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
                <Icons.CheckDouble />
              </div>
            </div>
          </div>

          <div className="phone-footer">
            <div className="ph-input">Mensagem</div>
            <div className="ph-mic">🎤</div>
          </div>
        </div>
      </div>
    );
  };

  const renderImageBox = ({
    active,
    imageUrl,
    uploading,
    inputRef,
    onChange,
    onRemove,
    onOpen,
    label,
  }) => {
    if (!active) return null;

    const imagePath = normalizarCaminhoImagemProtegida(imageUrl);
    const imageSrc = getImagemPreviewSrc(imageUrl);
    const rotaImagem = resolverRotaImagemProtegida(imagePath);
    const imageIsLoading = !!(imageUrl && imagePath && rotaImagem && !imageSrc);

    return (
      <div className="compact-media-field">
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          onChange={onChange}
          style={{ display: 'none' }}
        />

        <div className="compact-media-copy">
          <strong>Imagem da mensagem</strong>
          <span>
            {imageUrl
              ? 'A imagem será enviada antes do texto.'
              : 'Opcional. Use um card leve e horizontal.'}
          </span>
        </div>

        {imageUrl && imageSrc ? (
          <div className="compact-media-preview">
            <button
              type="button"
              className="compact-media-thumb"
              onClick={onOpen}
              title="Trocar imagem"
            >
              <img src={imageSrc} alt={label} />
            </button>

            <div className="compact-media-info">
              <strong>Imagem adicionada</strong>
              <small>{label}</small>

              <div className="compact-media-actions">
                <button type="button" className="media-change-btn" onClick={onOpen} disabled={uploading}>
                  <Icons.Upload /> {uploading ? 'Enviando...' : 'Trocar'}
                </button>

                <button type="button" className="media-remove-btn" onClick={onRemove}>
                  <Icons.Trash /> Remover
                </button>
              </div>
            </div>
          </div>
        ) : imageIsLoading ? (
          <div className="compact-media-status">
            <span className="compact-media-status-icon"><Icons.Image /></span>
            <div>
              <strong>Carregando imagem protegida</strong>
              <small>Buscando o arquivo usando a sessão atual.</small>
            </div>
            <button type="button" className="media-remove-btn" onClick={onRemove}>
              Remover
            </button>
          </div>
        ) : imageUrl && imagePath && !rotaImagem ? (
          <div className="compact-media-status error">
            <span className="compact-media-status-icon"><Icons.Image /></span>
            <div>
              <strong>Prévia indisponível</strong>
              <small>A rota protegida desta imagem não foi configurada.</small>
            </div>
            <button type="button" className="media-remove-btn" onClick={onRemove}>
              Remover
            </button>
          </div>
        ) : imageUrl && !imagePath && !imageSrc ? (
          <div className="compact-media-status error">
            <span className="compact-media-status-icon"><Icons.Image /></span>
            <div>
              <strong>Imagem fora do padrão</strong>
              <small>Envie novamente para salvar no diretório protegido.</small>
            </div>
            <button type="button" className="media-remove-btn" onClick={onRemove}>
              Remover
            </button>
          </div>
        ) : (
          <button type="button" className="compact-media-upload" onClick={onOpen} disabled={uploading}>
            <span><Icons.Upload /></span>
            <div>
              <strong>{uploading ? 'Enviando imagem...' : 'Selecionar imagem'}</strong>
              <small>PNG, JPG ou WEBP. Recomendado: formato horizontal.</small>
            </div>
          </button>
        )}
      </div>
    );
  };

  const renderPosVenda = () => (
    <div className="native-grid">
      <section className="native-card triggers-card">
        <div className="card-title-row">
          <div>
            <span className="card-kicker">AUTOMAÇÃO</span>
            <h3>Gatilhos ativos</h3>
          </div>

          <button type="button" className="mini-action" onClick={handleNewTemplate}>
            <Icons.Plus /> Novo
          </button>
        </div>

        <div className="triggers-list">
          {selectedId === 'NEW' && (
            <button type="button" className="trigger-item active">
              <span className="trigger-icon">✨</span>
              <span>
                <strong>Novo gatilho</strong>
                <small>Crie um marco personalizado</small>
              </span>
            </button>
          )}

          {loading ? (
            <div className="empty-inline">Carregando gatilhos...</div>
          ) : templates.length === 0 ? (
            <div className="empty-inline">Nenhum template encontrado.</div>
          ) : (
            templates.map((template) => (
              <button
                key={template._id}
                type="button"
                className={`trigger-item ${selectedId === template._id ? 'active' : ''}`}
                onClick={() => setSelectedId(template._id)}
              >
                <span className="trigger-icon">
                  {template.marco === '0' ? '🚀' : template.marco === '7d' ? '👓' : '📅'}
                </span>

                <span>
                  <strong>
                    {template.marco === '7d'
                      ? '7 dias'
                      : template.marco === '0'
                        ? 'Entrega'
                        : `Mês ${template.marco}`}
                  </strong>
                  <small>{template.titulo || 'Sem título'}</small>
                </span>
              </button>
            ))
          )}
        </div>
      </section>

      <section className="native-card editor-card">
        <div className="card-title-row">
          <div>
            <span className="card-kicker">EDITOR</span>
            <h3>Configuração do gatilho</h3>
          </div>

          <span className="security-chip">
            <Icons.Shield /> Empresa isolada
          </span>
        </div>

        {selectedId ? (
          <>
            <div className="form-grid">
              <label className="field">
                <span>Nome interno</span>
                <input
                  type="text"
                  value={formData.titulo}
                  onChange={(event) => setFormData({ ...formData, titulo: event.target.value })}
                  placeholder="Ex: acompanhamento 30 dias"
                />
              </label>

              <label className="field small-field">
                <span>Marco</span>
                {selectedId === 'NEW' ? (
                  <input
                    type="text"
                    value={formData.marco}
                    onChange={(event) => setFormData({ ...formData, marco: event.target.value })}
                    placeholder="Ex: 7d, 1, 2"
                  />
                ) : (
                  <div className="locked-value">🔒 {formData.marco}</div>
                )}
              </label>
            </div>

            <div className="toggle-panel">
              <div>
                <strong>Anexar imagem</strong>
                <span>Enviar foto junto ao texto deste marco.</span>
              </div>

              <label className="switch">
                <input
                  type="checkbox"
                  checked={formData.usarImagem}
                  onChange={(event) => setFormData({ ...formData, usarImagem: event.target.checked })}
                />
                <span className="slider" />
              </label>
            </div>

            {renderImageBox({
              active: formData.usarImagem,
              imageUrl: formData.imagemUrl,
              uploading: uploadingPosVendaImage,
              inputRef: posVendaFileInputRef,
              onChange: handleUploadPosVendaImage,
              onRemove: () => setFormData({ ...formData, usarImagem: false, imagemUrl: '' }),
              onOpen: () => posVendaFileInputRef.current?.click(),
              label: 'Imagem da régua pós-venda',
            })}

            <div className="field message-field">
              <div className="textarea-title-row">
                <span>Script da mensagem</span>

                <button
                  type="button"
                  className="tag-btn"
                  onClick={() => insertTag('posvenda-msg', formData, setFormData)}
                >
                  <Icons.Tag /> {'{{nome}}'}
                </button>
              </div>

              <textarea
                id="posvenda-msg"
                value={formData.mensagem}
                onChange={(event) => setFormData({ ...formData, mensagem: event.target.value })}
                placeholder="Escreva a mensagem que será enviada..."
              />

              <div className="editor-bottom">
                <small>{formData.mensagem.length} caracteres</small>

                <button type="button" className="primary-action" onClick={handleSavePosVenda} disabled={saving}>
                  {saving ? 'Salvando...' : <><Icons.Save /> Salvar gatilho</>}
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="empty-state">
            <div>📬</div>
            <strong>Selecione um gatilho</strong>
            <p>Escolha um template da régua ou crie um novo.</p>
          </div>
        )}
      </section>

      <section className="native-card preview-native-card">{renderPhoneMockup(formData)}</section>
    </div>
  );

  const renderBoasVindas = () => (
    <div className="native-grid welcome-grid">
      <section className="native-card editor-card">
        <div className="card-title-row">
          <div>
            <span className="card-kicker">ENTREGA</span>
            <h3>Mensagem de boas-vindas</h3>
            <p>Disparada no fechamento/entrega da ordem de serviço.</p>
          </div>
        </div>

        <div className="toggle-panel">
          <div>
            <strong>Anexar imagem</strong>
            <span>Foto de agradecimento, card promocional ou assinatura visual.</span>
          </div>

          <label className="switch">
            <input
              type="checkbox"
              checked={welcomeConfig.usarImagem}
              onChange={(event) => setWelcomeConfig({ ...welcomeConfig, usarImagem: event.target.checked })}
            />
            <span className="slider" />
          </label>
        </div>

        {renderImageBox({
          active: welcomeConfig.usarImagem,
          imageUrl: welcomeConfig.imagemUrl,
          uploading: uploadingWelcomeImage,
          inputRef: welcomeFileInputRef,
          onChange: handleUploadWelcomeImage,
          onRemove: () => setWelcomeConfig({ ...welcomeConfig, usarImagem: false, imagemUrl: '' }),
          onOpen: () => welcomeFileInputRef.current?.click(),
          label: 'Imagem de boas-vindas',
        })}

        <div className="field message-field">
          <div className="textarea-title-row">
            <span>Script da mensagem</span>

            <button
              type="button"
              className="tag-btn"
              onClick={() => insertTag('welcome-msg', welcomeConfig, setWelcomeConfig)}
            >
              <Icons.Tag /> {'{{nome}}'}
            </button>
          </div>

          <textarea
            id="welcome-msg"
            value={welcomeConfig.mensagem}
            onChange={(event) => setWelcomeConfig({ ...welcomeConfig, mensagem: event.target.value })}
            placeholder="Escreva a mensagem de boas-vindas..."
          />

          <div className="editor-bottom">
            <small>{welcomeConfig.mensagem.length} caracteres</small>

            <button
              type="button"
              className="primary-action"
              onClick={handleSaveWelcomeConfig}
              disabled={savingWelcome}
            >
              {savingWelcome ? 'Salvando...' : <><Icons.Save /> Salvar boas-vindas</>}
            </button>
          </div>
        </div>
      </section>

      <section className="native-card preview-native-card">{renderPhoneMockup(welcomeConfig)}</section>
    </div>
  );

  const renderCampanhasList = () => (
    <section className="native-card campaigns-shell campaigns-command-center">
      <div className="campaigns-head flat-head">
        <div>
          <span className="card-kicker">CAMPANHAS</span>
          <h3>Central de campanhas</h3>
          <p>Crie, filtre e acompanhe os disparos da empresa selecionada.</p>
        </div>

        <button type="button" className="primary-action" onClick={() => handleNewCampaign('CLIENTES_MES')}>
          <Icons.Plus /> Nova campanha
        </button>
      </div>

      <div className={`birthday-command ${birthdayTodayPending ? 'pending' : birthdayTodayCampaignSent ? 'done' : ''}`}>
        <div className="birthday-command-icon">🎂</div>

        <div className="birthday-command-copy">
          <strong>
            {loadingBirthdayToday
              ? 'Verificando aniversariantes de hoje...'
              : birthdayTodayClients.length > 0
                ? `${birthdayTodayClients.length} aniversariante${birthdayTodayClients.length === 1 ? '' : 's'} hoje`
                : 'Nenhum aniversariante hoje'}
          </strong>

          <span>
            {birthdayTodayPending
              ? 'Campanha ainda não enviada. Clique para preparar o disparo.'
              : birthdayTodayCampaignSent
                ? 'A campanha de hoje já foi enviada ou está em processamento.'
                : 'A lista será atualizada automaticamente para a empresa atual.'}
          </span>
        </div>

        {birthdayTodayPending && (
          <button
            type="button"
            className="birthday-command-action"
            onClick={() => handleUseCampaignIdea(CAMPAIGN_IDEAS[0])}
          >
            Preparar agora
          </button>
        )}

        <span className={`attention-dot ${birthdayTodayPending ? 'visible' : ''}`} aria-hidden="true" />
      </div>

      <div className="campaign-ideas-section">
        <div className="section-line-title">
          <div>
            <strong>Comece por uma ideia</strong>
            <span>Modelos rápidos para não começar do zero.</span>
          </div>
        </div>

        <div className="campaign-ideas-grid">
          {CAMPAIGN_IDEAS.map((idea) => (
            <button
              key={idea.id}
              type="button"
              className="campaign-idea-item"
              onClick={() => handleUseCampaignIdea(idea)}
            >
              <span className="campaign-idea-icon">{idea.icon}</span>
              <span>
                <strong>{idea.label}</strong>
                <small>{idea.description}</small>
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className="campaign-list-section">
        <div className="campaign-toolbar-flat">
          <label className="campaign-search-flat">
            <Icons.Filter />
            <input
              type="text"
              value={campaignSearch}
              onChange={(event) => setCampaignSearch(event.target.value)}
              placeholder="Pesquisar campanha..."
            />
          </label>

          <select
            className="campaign-status-filter"
            value={campaignStatusFilter}
            onChange={(event) => setCampaignStatusFilter(event.target.value)}
            aria-label="Filtrar campanhas por status"
          >
            <option value="TODAS">Todos os status</option>
            <option value="RASCUNHO">Rascunhos</option>
            <option value="PROCESSANDO">Processando</option>
            <option value="CONCLUIDA">Concluídas</option>
            <option value="ERRO">Com erro</option>
          </select>

          <span className="flat-count">{campaignsFiltered.length} campanhas</span>
        </div>

        <div className="campaign-table-flat">
          <div className="campaign-table-head">
            <span>Campanha</span>
            <span>Tipo</span>
            <span>Período</span>
            <span>Público</span>
            <span>Status</span>
          </div>

          {loadingCampaigns ? (
            <div className="empty-inline">Carregando campanhas...</div>
          ) : campaignsFiltered.length === 0 ? (
            <div className="empty-state full flat-empty">
              <div>📢</div>
              <strong>Nenhuma campanha encontrada.</strong>
              <p>Crie uma nova campanha ou ajuste os filtros acima.</p>
            </div>
          ) : (
            campaignsFiltered.map((campaign) => (
              <button
                key={campaign._id}
                type="button"
                className="campaign-table-row"
                onClick={() => handleEditCampaign(campaign)}
              >
                <span className="campaign-main-cell">
                  <strong>{campaign.titulo || 'Campanha sem título'}</strong>
                  <small>{campaign.totalEnviados || 0} enviados</small>
                </span>

                <span>
                  {campaign.tipoCampanha === 'ANIVERSARIANTES'
                    ? campaign.modoAniversario === 'HOJE'
                      ? 'Aniversário hoje'
                      : 'Aniversariantes'
                    : 'Clientes do mês'}
                </span>

                <span>{campaign.mesFiltro || '-'}</span>
                <span>{campaign.totalSelecionados || 0} clientes</span>

                <span>
                  <b className={`status-badge ${getStatusClass(campaign.statusCampanha)}`}>
                    {campaign.statusCampanha || 'RASCUNHO'}
                  </b>
                </span>
              </button>
            ))
          )}
        </div>
      </div>
    </section>
  );

  const renderCampanhaEditor = () => (
    <div className="campaign-editor-native">
      <section className="native-card editor-main">
        <div className="editor-header">
          <button type="button" className="icon-action" onClick={() => setCampaignView('list')}>
            <Icons.ArrowLeft /> Voltar
          </button>

          <div>
            <span className="card-kicker">{isBirthdayCampaign ? 'ANIVERSÁRIO' : 'CAMPANHA'}</span>
            <h3>{campaignForm._id ? 'Editar campanha' : 'Criador de campanha'}</h3>
          </div>

          <span className={`status-badge ${getStatusClass(campaignForm.statusCampanha)}`}>
            {campaignForm.statusCampanha}
          </span>
        </div>

        <div className="type-row">
          <button
            type="button"
            className={`type-chip ${!isBirthdayCampaign ? 'active' : ''}`}
            onClick={() =>
              setCampaignForm((prev) => ({
                ...prev,
                tipoCampanha: 'CLIENTES_MES',
                titulo: prev._id ? prev.titulo : '',
                mensagem: prev._id ? prev.mensagem : '',
                modoAniversario: 'MES',
              }))
            }
          >
            📣 Clientes do mês
          </button>

          <button
            type="button"
            className={`type-chip ${isBirthdayCampaign ? 'active' : ''}`}
            onClick={() =>
              setCampaignForm((prev) => ({
                ...prev,
                tipoCampanha: 'ANIVERSARIANTES',
                modoAniversario: prev.modoAniversario || 'MES',
                titulo: prev._id ? prev.titulo : 'Campanha de Aniversariantes do Mês',
                mensagem: prev._id ? prev.mensagem : birthdayMonthTemplate,
              }))
            }
          >
            🎂 Aniversariantes
          </button>
        </div>

        {isBirthdayCampaign && (
          <div className="type-row compact">
            <button
              type="button"
              className={`type-chip ${isBirthdayMonthMode ? 'active' : ''}`}
              onClick={() => handleChangeBirthdayMode('MES')}
            >
              🎉 Mês do aniversário
            </button>

            <button
              type="button"
              className={`type-chip ${isBirthdayTodayMode ? 'active' : ''}`}
              onClick={() => handleChangeBirthdayMode('HOJE')}
            >
              🎂 Hoje é aniversário
            </button>
          </div>
        )}

        <div className={`campaign-channel-panel ${canalStatusMeta.tone}`}>
          <div className="campaign-channel-heading">
            <div className="campaign-channel-icon">
              <Icons.MessageCircle />
            </div>

            <div>
              <span className="card-kicker">CANAL DE ENVIO</span>
              <strong>Escolha por qual WhatsApp a campanha vai sair</strong>
              <small>
                Somente o canal selecionado será usado. Os outros canais podem permanecer desconectados.
              </small>
            </div>
          </div>

          <div className="campaign-channel-controls">
            <label className="channel-select-field">
              <span>WhatsApp selecionado</span>

              <select
                value={canalWhatsappIdSelecionado}
                onChange={handleCanalWhatsappChange}
                disabled={loadingCanaisWhatsapp || canaisWhatsapp.length === 0}
              >
                {loadingCanaisWhatsapp ? (
                  <option value="">Carregando canais...</option>
                ) : canaisWhatsapp.length === 0 ? (
                  <option value="">Nenhum canal encontrado nesta unidade</option>
                ) : (
                  <>
                    <option value="">Selecione um canal</option>
                    {canaisWhatsapp.map((canal) => (
                      <option
                        key={normalizarId(canal.id || canal._id)}
                        value={normalizarId(canal.id || canal._id)}
                      >
                        {getCanalWhatsappLabel(canal)}
                        {canal.principal ? ' · Principal' : ''}
                      </option>
                    ))}
                  </>
                )}
              </select>
            </label>

            <button
              type="button"
              className="channel-refresh-button"
              onClick={() => carregarStatusCanalSelecionado()}
              disabled={!canalWhatsappIdSelecionado || checkingCanalStatus}
              title="Atualizar status do canal"
            >
              <Icons.Refresh />
              {checkingCanalStatus ? 'Verificando...' : 'Atualizar'}
            </button>
          </div>

          <div className="campaign-channel-status">
            <span className={`channel-status-dot ${canalStatusMeta.tone}`} />

            <div>
              <strong>{canalStatusMeta.label}</strong>
              <small>{canalStatusMeta.description}</small>
            </div>

            {canalWhatsappIdSelecionado && (
              <code>{canalWhatsappIdSelecionado.slice(-8)}</code>
            )}
          </div>
        </div>

        <div className="campaign-form-grid">
          <div className="field">
            <span>{isBirthdayCampaign ? 'Nome da campanha de aniversário' : 'Nome da campanha'}</span>
            <input
              type="text"
              value={campaignForm.titulo}
              onChange={(event) => setCampaignForm({ ...campaignForm, titulo: event.target.value })}
              placeholder="Ex: Campanha Dia das Mães"
            />
          </div>

          <div className="toggle-panel">
            <div>
              <strong>Banner / imagem</strong>
              <span>Anexar flyer da campanha.</span>
            </div>

            <label className="switch">
              <input
                type="checkbox"
                checked={campaignForm.usarImagem}
                onChange={(event) => setCampaignForm({ ...campaignForm, usarImagem: event.target.checked })}
              />
              <span className="slider" />
            </label>
          </div>

          {renderImageBox({
            active: campaignForm.usarImagem,
            imageUrl: campaignForm.imagemUrl,
            uploading: uploadingCampaignImage,
            inputRef: campaignFileInputRef,
            onChange: handleUploadCampaignImage,
            onRemove: () => setCampaignForm({ ...campaignForm, imagemUrl: '' }),
            onOpen: () => campaignFileInputRef.current?.click(),
            label: 'Flyer da campanha',
          })}

          <div className="field message-field">
            <div className="textarea-title-row">
              <span>Mensagem da campanha</span>

              <button
                type="button"
                className="tag-btn"
                onClick={() => insertTag('camp-msg', campaignForm, setCampaignForm)}
              >
                <Icons.Tag /> {'{{nome}}'}
              </button>
            </div>

            <textarea
              id="camp-msg"
              value={campaignForm.mensagem}
              onChange={(event) => setCampaignForm({ ...campaignForm, mensagem: event.target.value })}
              placeholder={
                !isBirthdayCampaign
                  ? 'Olá {{nome}}, temos uma oferta especial para você...'
                  : isBirthdayTodayMode
                    ? 'Olá {{nome}}, hoje é o seu dia! Feliz aniversário...'
                    : 'Olá {{nome}}, este é o mês do seu aniversário...'
              }
            />
          </div>

          <div className="editor-bottom">
            <button
              type="button"
              className="secondary-action"
              onClick={handleSaveCampaignDraft}
              disabled={savingCampaignDraft || campaignForm.statusCampanha !== 'RASCUNHO'}
            >
              {savingCampaignDraft ? 'Salvando...' : <><Icons.Save /> Salvar rascunho</>}
            </button>

            <button
              type="button"
              className="send-action"
              onClick={handleSendCampaign}
              disabled={
                sendingCampaign ||
                selectedClients.length === 0 ||
                !canalWhatsappIdSelecionado ||
                canalStatusMeta.requiresQr ||
                campaignForm.statusCampanha === 'CONCLUIDA' ||
                campaignForm.statusCampanha === 'PROCESSANDO'
              }
            >
              {sendingCampaign ? 'Iniciando...' : <><Icons.Send /> Enviar para {selectedClients.length}</>}
            </button>
          </div>
        </div>
      </section>

      <section className="native-card audience-card">
        <div className="audience-head">
          <div>
            <span className="card-kicker">PÚBLICO</span>
            <h3>{campaignTargetLabel}</h3>
          </div>

          <span className="counter-chip">{selectedClients.length} selecionados</span>
        </div>

        <label className="field">
          <span><Icons.Filter /> {campaignFilterLabel}</span>
          <select value={campaignMonth} onChange={(event) => setCampaignMonth(event.target.value)}>
            {gerarOpcoesMeses()}
          </select>
        </label>

        <div className="audience-list">
          <div className="audience-row head">
            <label className="check-line">
              <input
                type="checkbox"
                checked={selectedClients.length === clientsData.length && clientsData.length > 0}
                onChange={handleToggleAll}
              />
              <span />
            </label>
            <strong>Cliente</strong>
            <small>{campaignDateColumnLabel}</small>
          </div>

          {loadingClients ? (
            <div className="empty-inline">Buscando base de clientes...</div>
          ) : clientsData.length === 0 ? (
            <div className="empty-inline">{campaignEmptyStateLabel}</div>
          ) : (
            clientsData.map((client) => (
              <button
                key={normalizarId(client.id)}
                type="button"
                className="audience-row"
                onClick={() => handleToggleClient(normalizarId(client.id))}
              >
                <label className="check-line" onClick={(event) => event.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedClients.includes(normalizarId(client.id))}
                    onChange={() => handleToggleClient(normalizarId(client.id))}
                  />
                  <span />
                </label>

                <strong>
                  {client.nome}
                  <small>{client.telefone}</small>
                </strong>

                <em>{client.data}</em>
              </button>
            ))
          )}
        </div>
      </section>

      <section className="native-card preview-native-card">{renderPhoneMockup(campaignForm)}</section>
    </div>
  );

  const renderCampanhas = () => {
    if (campaignView === 'editor') return renderCampanhaEditor();
    return renderCampanhasList();
  };

  const renderImportInvalidExamples = () => {
    const exemplos = lastImportSummary?.exemplosInvalidos || [];

    if (!exemplos.length) return null;

    return (
      <div className="invalid-import-panel">
        <button
          type="button"
          className="invalid-toggle"
          onClick={() => setShowInvalidImportExamples((prev) => !prev)}
        >
          <span>Linhas ignoradas</span>
          <strong>{exemplos.length} exemplo(s)</strong>
        </button>

        {showInvalidImportExamples && (
          <div className="invalid-list">
            {exemplos.map((item, index) => (
              <div key={`invalid-${index}`} className="invalid-line">
                <strong>{item.motivos?.join(', ') || 'Linha inválida'}</strong>
                <code>{JSON.stringify(item.linha || {}).slice(0, 240)}</code>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderBaseExterna = () => (
    <div className="base-smart-grid">
      <section className="native-card base-import-smart-card">
        <div className="base-hero-top">
          <div>
            <span className="card-kicker">IMPORTAÇÃO INTELIGENTE</span>
            <h3>Base externa universal</h3>
            <p>
              Importe listas de outras óticas sem depender de uma planilha perfeita. O Lumix tenta reconhecer nome,
              telefone, compra, entrega, nascimento, cidade, bairro e outros campos automaticamente.
            </p>
          </div>

          <button type="button" className="secondary-action" onClick={fetchImportedBase} disabled={loadingImportedBase}>
            <Icons.Refresh /> {loadingImportedBase ? 'Atualizando...' : 'Atualizar'}
          </button>
        </div>

        <input
          type="file"
          ref={importBaseFileInputRef}
          style={{ display: 'none' }}
          accept=".xlsx,.xls,.csv,.txt,.pdf,.docx,.doc"
          onChange={handleImportBaseFile}
        />

        <button
          type="button"
          className={`smart-upload-zone ${baseDragActive ? 'dragging' : ''}`}
          onClick={() => importBaseFileInputRef.current?.click()}
          onDragOver={(event) => {
            event.preventDefault();
            setBaseDragActive(true);
          }}
          onDragLeave={() => setBaseDragActive(false)}
          onDrop={handleDropBaseFile}
          disabled={importingBaseFile}
        >
          <span className="upload-orb"><Icons.FileUp /></span>
          <strong>{importingBaseFile ? 'Lendo arquivo e reconhecendo campos...' : 'Arraste um arquivo aqui ou clique para importar'}</strong>
          <small>Excel, CSV, TXT, PDF e Word — até 25MB</small>

          <div className="format-pill-row">
            {supportedBaseFormats.map((format) => (
              <span key={format}>{format}</span>
            ))}
          </div>
        </button>

        <div className="smart-rules-card">
          <strong>Regra para importar bem</strong>
          <p>
            A base precisa ter pelo menos <b>nome</b> e <b>telefone</b>. Datas são opcionais, mas ajudam nas campanhas
            de compra, entrega e aniversário.
          </p>

          <div className="field-map-grid">
            <span>Nome</span>
            <span>Telefone / WhatsApp</span>
            <span>Data da compra</span>
            <span>Data da entrega</span>
            <span>Data nascimento</span>
            <span>Cidade / Bairro / UF</span>
          </div>
        </div>

        {lastImportSummary && (
          <div className="summary-card smart-summary-card">
            <div className="summary-title-line">
              <strong>Última importação</strong>
              <span>{lastImportSummary.tipoArquivo || 'arquivo'}</span>
            </div>

            <div className="summary-grid smart-summary-grid">
              <span>Arquivo <b>{lastImportSummary.arquivo || '-'}</b></span>
              <span>Lidos <b>{lastImportSummary.totalLidos ?? 0}</b></span>
              <span>Linhas úteis <b>{lastImportSummary.totalLinhasUteis ?? lastImportSummary.totalLidos ?? 0}</b></span>
              <span>Válidos <b>{lastImportSummary.totalValidos ?? 0}</b></span>
              <span>Inseridos <b>{lastImportSummary.inseridos ?? 0}</b></span>
              <span>Atualizados <b>{lastImportSummary.atualizados ?? 0}</b></span>
              <span>Ignorados <b>{lastImportSummary.totalInvalidos ?? 0}</b></span>
              <span>Hash <b>{lastImportSummary.hashImportacao || '-'}</b></span>
            </div>

            {renderImportInvalidExamples()}
          </div>
        )}
      </section>

      <section className="native-card base-panel-card">
        <div className="base-dashboard-head">
          <div>
            <span className="card-kicker">CONTATOS</span>
            <h3>Base importada</h3>
            <p>Contatos isolados por empresa, prontos para campanhas e aniversariantes.</p>
          </div>

          <span className="counter-chip">{baseStats.total} registros</span>
        </div>

        <div className="base-metric-grid">
          <div className="base-metric-card">
            <small>Total</small>
            <strong>{baseStats.total}</strong>
            <span>contatos ativos</span>
          </div>

          <div className="base-metric-card">
            <small>Aniversário</small>
            <strong>{baseStats.comNascimento}</strong>
            <span>com nascimento</span>
          </div>

          <div className="base-metric-card">
            <small>Compra</small>
            <strong>{baseStats.comCompra}</strong>
            <span>com data</span>
          </div>

          <div className="base-metric-card">
            <small>Entrega</small>
            <strong>{baseStats.comEntrega}</strong>
            <span>com data</span>
          </div>

          <div className="base-metric-card">
            <small>Cidades</small>
            <strong>{baseStats.cidades}</strong>
            <span>detectadas</span>
          </div>
        </div>

        <div className="base-toolbar">
          <label className="base-search-box">
            <Icons.Filter />
            <input
              type="text"
              value={baseSearch}
              onChange={(event) => setBaseSearch(event.target.value)}
              placeholder="Buscar por nome, telefone, cidade, bairro, arquivo..."
            />
          </label>
        </div>

        <div className="smart-contacts-table">
          <div className="smart-contacts-head">
            <span>Cliente</span>
            <span>Contato</span>
            <span>Datas</span>
            <span>Local</span>
            <span>Ação</span>
          </div>

          {loadingImportedBase ? (
            <div className="empty-state full">
              <div>🔎</div>
              <strong>Carregando contatos...</strong>
              <p>Buscando somente a base da empresa logada.</p>
            </div>
          ) : importedBaseFiltered.length === 0 ? (
            <div className="empty-state full">
              <div>🗂️</div>
              <strong>{importedBaseList.length ? 'Nenhum contato encontrado no filtro.' : 'Nenhuma base importada ainda.'}</strong>
              <p>{importedBaseList.length ? 'Tente limpar a busca ou usar outro termo.' : 'Importe Excel, CSV, TXT, PDF ou Word para começar.'}</p>
            </div>
          ) : (
            importedBaseFiltered.map((item) => (
              <div key={item._id} className="smart-contact-row">
                <div className="contact-name-cell">
                  <strong>{item.nome || 'Sem nome'}</strong>
                  <small>{item.email || item.origemArquivo || 'Origem não informada'}</small>
                </div>

                <div className="contact-phone-cell">
                  <strong>{formatarTelefoneBR(item.telefone)}</strong>
                  <small>{item.documento ? `Doc. ${item.documento}` : 'WhatsApp/telefone'}</small>
                </div>

                <div className="contact-dates-cell">
                  <span>Compra: <b>{formatarDataBR(item.dataCompra || item.dataCadastro)}</b></span>
                  <span>Entrega: <b>{formatarDataBR(item.dataEntrega)}</b></span>
                  <span>Nasc.: <b>{formatarDataBR(item.dataNascimento)}</b></span>
                </div>

                <div className="contact-location-cell">
                  <strong>{item.cidade || '-'}</strong>
                  <small>{[item.bairro, item.estado].filter(Boolean).join(' / ') || '-'}</small>
                </div>

                <button
                  type="button"
                  className="icon-danger"
                  onClick={() => handleRemoveImportedContact(item._id)}
                  title="Remover contato"
                >
                  <Icons.Trash />
                </button>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );

  const renderCurrentModule = () => {
    if (activeModule === 'boas-vindas') return renderBoasVindas();
    if (activeModule === 'campanhas') return renderCampanhas();
    if (activeModule === 'base-externa') return renderBaseExterna();
    return renderPosVenda();
  };

  return (
    <div className="lumix-crm-module">
      <style>{css}</style>

      <div className="crm-workspace">
        <div className="crm-contextbar">
          <div className="context-company">
            <span className="sidebar-company-avatar">{empresaIniciais}</span>

            <div className="context-company-copy">
              <small>Empresa operacional</small>
              <strong>{empresaNomeAtual}</strong>
            </div>

            <select
              className="sidebar-company-select"
              value={empresaIdAtual}
              onChange={handleEmpresaSelecionadaChange}
              disabled={loadingEmpresas || !!empresaIdExterno || empresasDisponiveis.length <= 1}
              aria-label="Selecionar empresa operacional"
            >
              {!empresaIdAtual && <option value="">Selecione uma empresa</option>}

              {empresasDisponiveis.map((empresa) => {
                const id = normalizarId(empresa?._id || empresa?.id);

                return (
                  <option key={id} value={id}>
                    {getEmpresaLabel(empresa)}
                  </option>
                );
              })}
            </select>
          </div>

          <nav className="module-tabs" aria-label="Módulos de relacionamento">
            {moduleTabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeModule === tab.id;
              const showBirthdayBadge = tab.id === 'campanhas' && birthdayTodayClients.length > 0;

              return (
                <button
                  type="button"
                  key={tab.id}
                  className={`module-tab ${isActive ? 'active' : ''}`}
                  onClick={() => {
                    setActiveModule(tab.id);
                    if (tab.id === 'campanhas') setCampaignView('list');
                  }}
                >
                  <span className="tab-icon"><Icon /></span>
                  <span className="tab-copy">
                    <strong>{tab.label}</strong>
                  </span>

                  {showBirthdayBadge && (
                    <span className={`nav-count-badge ${birthdayTodayPending ? 'pending' : ''}`}>
                      {birthdayTodayClients.length}
                    </span>
                  )}
                </button>
              );
            })}
          </nav>
        </div>

        <main className="crm-main">
          <div className="module-heading-flat">
            <div>
              <strong>{selectedModule.label}</strong>
              <span>{selectedModule.description}</span>
            </div>
          </div>

          <div className="module-content">{renderCurrentModule()}</div>
        </main>
      </div>

      {notification && (
        <div className={`notify-card floating-notification ${notification.type}`}>
          {notification.type === 'success' ? '✓' : notification.type === 'warning' ? '!' : '✕'} {notification.msg}
        </div>
      )}
    </div>
  );

}

// ============================================================================
// CSS
// ============================================================================
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  :root {
    --lumix-page: #ffffff;
    --lumix-surface: #ffffff;
    --lumix-soft: #f8fafc;
    --lumix-soft-2: #f1f5f9;
    --lumix-text: #0f172a;
    --lumix-muted: #64748b;
    --lumix-muted-2: #94a3b8;
    --lumix-border: #e5e7eb;
    --lumix-border-strong: #cbd5e1;
    --lumix-blue: #1967d2;
    --lumix-blue-soft: #e8f0fe;
    --lumix-green: #16a34a;
    --lumix-green-soft: #dcfce7;
    --lumix-red: #dc2626;
    --lumix-red-soft: #fee2e2;
    --lumix-amber: #d97706;
    --lumix-amber-soft: #fef3c7;
    --shadow-soft: 0 1px 2px rgba(15, 23, 42, .04);
    --shadow-card: 0 12px 32px rgba(15, 23, 42, .06);
    --radius-xl: 22px;
    --radius-lg: 18px;
    --radius-md: 14px;
    --font: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  * { box-sizing: border-box; }

  button,
  input,
  textarea,
  select { font-family: var(--font); }

  button { -webkit-tap-highlight-color: transparent; }

  .lumix-crm-module {
    width: 100%;
    min-height: 100%;
    padding: 18px;
    background: var(--lumix-page);
    color: var(--lumix-text);
    font-family: var(--font);
  }

  .lumix-crm-module svg {
    flex: 0 0 auto;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .crm-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 0 0 16px;
    margin-bottom: 14px;
    border-bottom: 1px solid var(--lumix-border);
    background: transparent;
  }

  .page-kicker,
  .card-kicker {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    color: var(--lumix-blue);
    background: var(--lumix-blue-soft);
    border: 1px solid #dbeafe;
    border-radius: 999px;
    padding: 4px 8px;
    font-size: 10px;
    font-weight: 950;
    letter-spacing: .07em;
    text-transform: uppercase;
  }

  .crm-top h2 {
    margin: 8px 0 4px;
    font-size: clamp(24px, 3vw, 32px);
    line-height: 1;
    letter-spacing: -.055em;
    font-weight: 950;
  }

  .crm-top p {
    margin: 0;
    color: var(--lumix-muted);
    font-size: 13px;
    line-height: 1.48;
    font-weight: 600;
    max-width: 760px;
  }

  .empresa-chip,
  .security-chip,
  .counter-chip,
  .date-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
    border-radius: 999px;
    padding: 5px 9px;
    font-size: 11px;
    font-weight: 900;
    line-height: 1;
  }

  .empresa-chip,
  .security-chip {
    margin-top: 10px;
    background: var(--lumix-green-soft);
    color: #166534;
    border: 1px solid #bbf7d0;
  }

  .counter-chip {
    background: var(--lumix-blue-soft);
    color: var(--lumix-blue);
    border: 1px solid #dbeafe;
  }

  .date-chip {
    background: var(--lumix-soft);
    color: var(--lumix-muted);
    border: 1px solid var(--lumix-border);
  }

  .notify-card {
    max-width: 460px;
    border-radius: var(--radius-md);
    padding: 10px 12px;
    font-size: 12.5px;
    font-weight: 800;
    line-height: 1.45;
    box-shadow: var(--shadow-soft);
    animation: fadeUp .18s ease both;
  }

  .notify-card.success {
    background: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
  }

  .notify-card.error {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
  }

  .notify-card.warning {
    background: #fffbeb;
    color: #92400e;
    border: 1px solid #fde68a;
  }

  .module-tabs {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 12px;
  }

  .module-tab {
    min-height: 76px;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    background: #fff;
    color: #334155;
    box-shadow: var(--shadow-soft);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 12px;
    text-align: left;
    transition: border-color .16s ease, background .16s ease, transform .16s ease, box-shadow .16s ease;
  }

  .module-tab:hover {
    transform: translateY(-1px);
    background: #fbfdff;
    border-color: #dbeafe;
  }

  .module-tab.active,
  .module-tab.active:hover,
  .module-tab.active:focus,
  .module-tab.active:active {
    color: #0f172a;
    border-color: #bfdbfe;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    box-shadow: 0 12px 30px rgba(25, 103, 210, .10);
    transform: none;
    outline: none;
  }

  .tab-icon {
    width: 40px;
    height: 40px;
    border-radius: var(--radius-md);
    background: var(--lumix-soft);
    color: var(--lumix-blue);
    border: 1px solid var(--lumix-border);
    display: grid;
    place-items: center;
    flex-shrink: 0;
  }

  .module-tab.active .tab-icon {
    color: var(--lumix-blue);
    background: var(--lumix-blue-soft);
    border-color: #dbeafe;
  }

  .module-tab strong,
  .module-tab small { display: block; }

  .module-tab strong {
    font-size: 13px;
    font-weight: 950;
    letter-spacing: -.02em;
  }

  .module-tab small {
    margin-top: 3px;
    color: var(--lumix-muted);
    font-size: 11.5px;
    line-height: 1.35;
    font-weight: 650;
  }

  .module-tab.active small { color: #475569; }

  .module-context {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    padding: 12px;
    margin-bottom: 12px;
    background: #fff;
  }

  .context-icon {
    width: 38px;
    height: 38px;
    border-radius: var(--radius-md);
    display: grid;
    place-items: center;
    background: var(--lumix-soft);
    color: var(--lumix-blue);
    border: 1px solid var(--lumix-border);
  }

  .module-context strong,
  .module-context span { display: block; }

  .module-context strong {
    font-size: 13px;
    font-weight: 950;
  }

  .module-context span {
    margin-top: 2px;
    color: var(--lumix-muted);
    font-size: 12px;
    font-weight: 650;
  }

  .module-content { width: 100%; }

  .native-grid {
    display: grid;
    grid-template-columns: 320px minmax(0, 1fr) 360px;
    gap: 12px;
    align-items: start;
  }

  .welcome-grid {
    grid-template-columns: minmax(0, 1fr) 380px;
  }

  .base-grid {
    display: grid;
    grid-template-columns: 390px minmax(0, 1fr);
    gap: 12px;
    align-items: start;
  }

  .campaign-editor-native {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 380px 360px;
    gap: 12px;
    align-items: start;
  }

  .native-card {
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-xl);
    background: #fff;
    padding: 14px;
    box-shadow: var(--shadow-soft);
  }

  .card-title-row,
  .campaigns-head,
  .audience-head,
  .editor-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
  }

  .card-title-row h3,
  .campaigns-head h3,
  .audience-head h3,
  .editor-header h3 {
    margin: 7px 0 0;
    color: var(--lumix-text);
    font-size: 18px;
    line-height: 1.08;
    font-weight: 950;
    letter-spacing: -.04em;
  }

  .card-title-row p,
  .campaigns-head p,
  .editor-header p {
    margin: 5px 0 0;
    color: var(--lumix-muted);
    font-size: 12.5px;
    line-height: 1.45;
    font-weight: 600;
  }

  .triggers-card { position: sticky; top: 12px; }

  .triggers-list {
    display: grid;
    gap: 8px;
  }

  .trigger-item {
    width: 100%;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    background: #fff;
    color: var(--lumix-text);
    padding: 10px;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 10px;
    align-items: center;
    text-align: left;
    cursor: pointer;
    transition: .16s ease;
  }

  .trigger-item:hover {
    border-color: #dbeafe;
    background: #fbfdff;
  }

  .trigger-item.active {
    border-color: #bfdbfe;
    background: var(--lumix-blue-soft);
  }

  .trigger-icon {
    width: 36px;
    height: 36px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    background: var(--lumix-soft);
    border: 1px solid var(--lumix-border);
    font-size: 16px;
  }

  .trigger-item strong,
  .trigger-item small { display: block; }

  .trigger-item strong {
    font-size: 12.5px;
    font-weight: 950;
  }

  .trigger-item small {
    margin-top: 2px;
    color: var(--lumix-muted);
    font-size: 11.5px;
    font-weight: 650;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .form-grid,
  .campaign-form-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 150px;
    gap: 10px;
  }

  .campaign-form-grid {
    grid-template-columns: 1fr;
  }

  .campaign-channel-panel {
    margin: 12px 0;
    padding: 14px;
    border: 1px solid #dbe3ee;
    border-radius: 18px;
    background:
      linear-gradient(135deg, rgba(255,255,255,.98), rgba(248,250,252,.98));
    box-shadow: 0 10px 28px rgba(15, 23, 42, .06);
    display: grid;
    gap: 13px;
    transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
  }

  .campaign-channel-panel.connected {
    border-color: #a7f3d0;
    background: linear-gradient(135deg, #f0fdf4, #ffffff);
  }

  .campaign-channel-panel.warning {
    border-color: #fde68a;
    background: linear-gradient(135deg, #fffbeb, #ffffff);
  }

  .campaign-channel-panel.danger {
    border-color: #fecaca;
    background: linear-gradient(135deg, #fef2f2, #ffffff);
  }

  .campaign-channel-panel.loading {
    border-color: #bfdbfe;
    background: linear-gradient(135deg, #eff6ff, #ffffff);
  }

  .campaign-channel-heading {
    display: flex;
    align-items: flex-start;
    gap: 11px;
  }

  .campaign-channel-icon {
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    border-radius: 13px;
    background: #0f172a;
    color: #fff;
    display: grid;
    place-items: center;
    box-shadow: 0 8px 18px rgba(15, 23, 42, .15);
  }

  .campaign-channel-heading > div:last-child {
    min-width: 0;
    display: grid;
    gap: 3px;
  }

  .campaign-channel-heading strong {
    color: #0f172a;
    font-size: 14px;
    font-weight: 950;
    line-height: 1.25;
  }

  .campaign-channel-heading small {
    color: #64748b;
    font-size: 11.5px;
    font-weight: 650;
    line-height: 1.45;
  }

  .campaign-channel-controls {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 9px;
    align-items: end;
  }

  .channel-select-field {
    display: grid;
    gap: 6px;
  }

  .channel-select-field > span {
    color: #334155;
    font-size: 11.5px;
    font-weight: 900;
  }

  .channel-select-field select {
    min-height: 44px;
    border-radius: 14px;
    font-weight: 800;
    padding-right: 34px;
  }

  .channel-refresh-button {
    min-height: 44px;
    border: 1px solid #cbd5e1;
    border-radius: 14px;
    background: #fff;
    color: #334155;
    padding: 0 13px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    font-size: 11.5px;
    font-weight: 900;
    cursor: pointer;
    white-space: nowrap;
  }

  .channel-refresh-button:hover:not(:disabled) {
    border-color: #93c5fd;
    background: #eff6ff;
    color: #1d4ed8;
  }

  .campaign-channel-status {
    min-height: 44px;
    padding: 9px 11px;
    border: 1px solid rgba(148, 163, 184, .28);
    border-radius: 14px;
    background: rgba(255,255,255,.76);
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: 9px;
  }

  .campaign-channel-status > div {
    min-width: 0;
    display: grid;
    gap: 2px;
  }

  .campaign-channel-status strong {
    color: #0f172a;
    font-size: 12px;
    font-weight: 950;
  }

  .campaign-channel-status small {
    color: #64748b;
    font-size: 10.8px;
    font-weight: 650;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .campaign-channel-status code {
    border-radius: 999px;
    background: #f1f5f9;
    color: #475569;
    padding: 5px 8px;
    font-size: 10px;
    font-weight: 900;
  }

  .channel-status-dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: #94a3b8;
    box-shadow: 0 0 0 4px rgba(148, 163, 184, .13);
  }

  .channel-status-dot.connected {
    background: #16a34a;
    box-shadow: 0 0 0 4px rgba(22, 163, 74, .13);
  }

  .channel-status-dot.warning {
    background: #d97706;
    box-shadow: 0 0 0 4px rgba(217, 119, 6, .14);
  }

  .channel-status-dot.danger {
    background: #dc2626;
    box-shadow: 0 0 0 4px rgba(220, 38, 38, .13);
  }

  .channel-status-dot.loading {
    background: #2563eb;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, .13);
    animation: channelPulse 1.2s ease-in-out infinite;
  }

  @keyframes channelPulse {
    0%, 100% { opacity: .45; transform: scale(.88); }
    50% { opacity: 1; transform: scale(1); }
  }

  @media (max-width: 760px) {
    .campaign-channel-panel {
      padding: 12px;
      border-radius: 16px;
    }

    .campaign-channel-controls {
      grid-template-columns: 1fr;
    }

    .channel-refresh-button {
      width: 100%;
    }

    .campaign-channel-status {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .campaign-channel-status code {
      display: none;
    }

    .campaign-channel-status small {
      white-space: normal;
    }
  }

  .field {
    display: grid;
    gap: 6px;
  }

  .field > span,
  .textarea-title-row > span,
  .field span svg {
    color: #334155;
    font-size: 11.5px;
    font-weight: 900;
  }

  .small-field { min-width: 130px; }

  input,
  select,
  textarea {
    width: 100%;
    border: 1px solid var(--lumix-border);
    border-radius: 13px;
    background: #fff;
    color: var(--lumix-text);
    outline: none;
    font-size: 12.5px;
    font-weight: 650;
    transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
  }

  input,
  select {
    min-height: 39px;
    padding: 0 11px;
  }

  textarea {
    min-height: 260px;
    padding: 12px;
    line-height: 1.55;
    resize: vertical;
  }

  input:focus,
  select:focus,
  textarea:focus {
    border-color: #bfdbfe;
    box-shadow: 0 0 0 3px rgba(25, 103, 210, .10);
  }

  .locked-value {
    min-height: 39px;
    border: 1px solid var(--lumix-border);
    border-radius: 13px;
    background: var(--lumix-soft);
    color: var(--lumix-muted);
    display: flex;
    align-items: center;
    padding: 0 11px;
    font-size: 12.5px;
    font-weight: 850;
  }

  .toggle-panel {
    margin: 12px 0;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    background: var(--lumix-soft);
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  .toggle-panel strong,
  .toggle-panel span { display: block; }

  .toggle-panel strong {
    font-size: 13px;
    font-weight: 950;
  }

  .toggle-panel span {
    margin-top: 3px;
    color: var(--lumix-muted);
    font-size: 12px;
    font-weight: 650;
    line-height: 1.4;
  }

  .switch {
    position: relative;
    width: 46px;
    height: 26px;
    flex: 0 0 auto;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    inset: 0;
    border-radius: 999px;
    background: #cbd5e1;
    cursor: pointer;
    transition: .16s;
  }

  .slider:before {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    left: 3px;
    top: 3px;
    background: #fff;
    border-radius: 999px;
    transition: .16s;
    box-shadow: 0 1px 2px rgba(15, 23, 42, .15);
  }

  .switch input:checked + .slider { background: var(--lumix-green); }
  .switch input:checked + .slider:before { transform: translateX(20px); }

  .image-box { margin: 12px 0; }

  .upload-box,
  .big-upload {
    width: 100%;
    min-height: 156px;
    border: 1px dashed #cbd5e1;
    border-radius: var(--radius-lg);
    background: var(--lumix-soft);
    color: var(--lumix-muted);
    display: grid;
    place-items: center;
    align-content: center;
    gap: 7px;
    cursor: pointer;
    transition: .16s ease;
    padding: 18px;
    text-align: center;
  }

  .big-upload { min-height: 240px; }

  .upload-box:hover,
  .big-upload:hover {
    border-color: #bfdbfe;
    background: #eff6ff;
    color: var(--lumix-blue);
  }

  .upload-box strong,
  .big-upload strong {
    color: var(--lumix-text);
    font-size: 13px;
    font-weight: 950;
  }

  .upload-box span,
  .big-upload span {
    font-size: 12px;
    font-weight: 700;
  }

  .uploaded-card {
    position: relative;
    height: 210px;
    overflow: hidden;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    background: var(--lumix-soft);
  }

  .uploaded-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .uploaded-overlay {
    position: absolute;
    inset: auto 10px 10px 10px;
    display: flex;
    justify-content: flex-end;
  }

  .textarea-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
  }

  .message-field { margin-top: 12px; }

  .editor-bottom {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .editor-bottom small {
    color: var(--lumix-muted);
    font-size: 11.5px;
    font-weight: 750;
  }

  .primary-action,
  .secondary-action,
  .send-action,
  .mini-action,
  .icon-action,
  .tag-btn,
  .danger-soft-btn,
  .icon-danger {
    min-height: 36px;
    border-radius: 999px;
    border: 1px solid var(--lumix-border);
    background: #fff;
    color: #334155;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 900;
    transition: .16s ease;
    white-space: nowrap;
  }

  .primary-action,
  .send-action {
    border-color: #0f172a;
    background: #0f172a;
    color: #fff;
  }

  .primary-action:hover,
  .send-action:hover { background: #1e293b; }

  .secondary-action:hover,
  .mini-action:hover,
  .icon-action:hover,
  .tag-btn:hover {
    background: var(--lumix-soft);
    border-color: var(--lumix-border-strong);
  }

  .danger-soft-btn,
  .icon-danger {
    color: var(--lumix-red);
    border-color: #fecaca;
    background: #fff;
  }

  .danger-soft-btn:hover,
  .icon-danger:hover { background: #fef2f2; }

  .icon-danger {
    width: 34px;
    padding: 0;
  }

  button:disabled {
    opacity: .55;
    cursor: not-allowed;
  }

  .tag-btn {
    color: var(--lumix-blue);
    border-color: #dbeafe;
    background: var(--lumix-blue-soft);
  }

  .phone-card {
    display: grid;
    gap: 10px;
    justify-items: center;
  }

  .phone-meta {
    width: 100%;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    padding: 12px;
    background: var(--lumix-soft);
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .phone-meta span,
  .phone-meta strong {
    font-size: 12px;
    font-weight: 900;
  }

  .phone-meta span { color: var(--lumix-muted); }
  .phone-meta strong { color: var(--lumix-green); }

  .phone-mockup {
    width: min(100%, 315px);
    height: 610px;
    border: 1px solid #0f172a;
    border-radius: 36px;
    background: #0f172a;
    padding: 10px;
    box-shadow: 0 18px 46px rgba(15, 23, 42, .16);
    position: relative;
    overflow: hidden;
  }

  .phone-notch {
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    width: 82px;
    height: 20px;
    border-radius: 999px;
    background: #020617;
    z-index: 3;
  }

  .phone-header {
    height: 72px;
    border-radius: 28px 28px 0 0;
    background: #075e54;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 24px 13px 10px;
  }

  .ph-avatar {
    width: 34px;
    height: 34px;
    border-radius: 999px;
    background: #fff;
    color: #075e54;
    display: grid;
    place-items: center;
    font-size: 11px;
    font-weight: 950;
  }

  .ph-info { min-width: 0; }
  .ph-name,
  .ph-status { display: block; }
  .ph-name { font-size: 13px; font-weight: 950; }
  .ph-status { font-size: 10.5px; opacity: .78; margin-top: 2px; }

  .phone-body {
    height: calc(100% - 126px);
    background: #efe7dc;
    padding: 14px;
    overflow: auto;
  }

  .msg-bubble {
    max-width: 92%;
    border-radius: 0 15px 15px 15px;
    padding: 10px;
    background: #fff;
    color: #111827;
    box-shadow: 0 1px 1px rgba(15,23,42,.08);
    font-size: 12.2px;
    line-height: 1.46;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .msg-bubble strong { font-weight: 950; }
  .msg-bubble em { font-style: italic; }
  .msg-bubble del { opacity: .8; }

  .msg-image-preview {
    margin: -4px -4px 8px;
    border-radius: 12px;
    overflow: hidden;
    background: var(--lumix-soft);
  }

  .msg-image-preview img {
    width: 100%;
    max-height: 190px;
    object-fit: cover;
    display: block;
  }

  .msg-meta {
    margin-top: 6px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    color: #64748b;
    font-size: 10px;
  }

  .msg-time { font-size: 10px; }

  .phone-footer {
    height: 54px;
    display: grid;
    grid-template-columns: 1fr 38px;
    gap: 8px;
    align-items: center;
    background: #efe7dc;
    border-radius: 0 0 28px 28px;
    padding: 8px;
  }

  .ph-input {
    min-height: 38px;
    border-radius: 999px;
    background: #fff;
    color: #94a3b8;
    display: flex;
    align-items: center;
    padding: 0 13px;
    font-size: 12px;
    font-weight: 700;
  }

  .ph-mic {
    width: 38px;
    height: 38px;
    border-radius: 999px;
    background: #075e54;
    display: grid;
    place-items: center;
  }

  .placeholder-text { color: var(--lumix-muted-2); }
  .var-highlight {
    color: var(--lumix-blue);
    background: var(--lumix-blue-soft);
    border-radius: 7px;
    padding: 1px 4px;
    font-weight: 950;
  }

  .empty-inline,
  .empty-state {
    border: 1px dashed var(--lumix-border-strong);
    border-radius: var(--radius-lg);
    background: var(--lumix-soft);
    color: var(--lumix-muted);
    padding: 16px;
    font-size: 12.5px;
    font-weight: 750;
    text-align: center;
  }

  .empty-state {
    min-height: 220px;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 6px;
  }

  .empty-state div { font-size: 32px; }
  .empty-state strong { color: var(--lumix-text); font-size: 14px; font-weight: 950; }
  .empty-state p { margin: 0; color: var(--lumix-muted); font-size: 12px; line-height: 1.45; }
  .empty-state.full { grid-column: 1 / -1; }

  .campaigns-shell { min-height: 430px; }

  .actions-row,
  .type-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  .type-row {
    margin-bottom: 10px;
  }

  .type-row.compact {
    padding: 8px;
    border-radius: var(--radius-lg);
    border: 1px solid var(--lumix-border);
    background: var(--lumix-soft);
  }

  .type-chip {
    min-height: 36px;
    border: 1px solid var(--lumix-border);
    background: #fff;
    color: #334155;
    border-radius: 999px;
    padding: 0 12px;
    font-size: 12px;
    font-weight: 900;
    cursor: pointer;
  }

  .type-chip.active {
    border-color: #bfdbfe;
    background: var(--lumix-blue-soft);
    color: var(--lumix-blue);
  }

  .campaigns-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .campaign-card {
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    background: #fff;
    padding: 13px;
    text-align: left;
    cursor: pointer;
    transition: .16s ease;
  }

  .campaign-card:hover {
    transform: translateY(-1px);
    border-color: #bfdbfe;
    box-shadow: var(--shadow-card);
  }

  .campaign-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 12px;
  }

  .campaign-kind {
    color: var(--lumix-muted);
    font-size: 11.5px;
    font-weight: 850;
  }

  .campaign-card h4 {
    margin: 8px 0 12px;
    min-height: 38px;
    font-size: 15px;
    line-height: 1.25;
    letter-spacing: -.03em;
    font-weight: 950;
    color: var(--lumix-text);
  }

  .campaign-stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .campaign-stats span {
    border: 1px solid var(--lumix-border);
    background: var(--lumix-soft);
    border-radius: 13px;
    padding: 9px;
    color: var(--lumix-muted);
    font-size: 11px;
    font-weight: 800;
  }

  .campaign-stats strong {
    display: block;
    color: var(--lumix-text);
    font-size: 16px;
    font-weight: 950;
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 5px 8px;
    font-size: 10.5px;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: .04em;
    background: var(--lumix-soft);
    color: var(--lumix-muted);
    border: 1px solid var(--lumix-border);
  }

  .status-badge.rascunho { background: var(--lumix-soft); color: var(--lumix-muted); }
  .status-badge.processando { background: var(--lumix-amber-soft); color: #92400e; border-color: #fde68a; }
  .status-badge.concluida { background: var(--lumix-green-soft); color: #166534; border-color: #bbf7d0; }
  .status-badge.cancelada,
  .status-badge.erro { background: var(--lumix-red-soft); color: #991b1b; border-color: #fecaca; }

  .audience-card,
  .preview-native-card { position: sticky; top: 12px; }

  .audience-list {
    margin-top: 10px;
    display: grid;
    gap: 7px;
    max-height: 590px;
    overflow: auto;
    padding-right: 3px;
  }

  .audience-row {
    width: 100%;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-md);
    background: #fff;
    padding: 9px;
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) auto;
    gap: 9px;
    align-items: center;
    text-align: left;
    color: var(--lumix-text);
  }

  .audience-row:not(.head) { cursor: pointer; }
  .audience-row:not(.head):hover { border-color: #bfdbfe; background: #fbfdff; }

  .audience-row.head {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--lumix-soft);
    color: var(--lumix-muted);
    font-size: 11px;
    font-weight: 950;
  }

  .audience-row strong {
    display: block;
    font-size: 12.5px;
    font-weight: 950;
    min-width: 0;
  }

  .audience-row small {
    display: block;
    margin-top: 2px;
    color: var(--lumix-muted);
    font-size: 11px;
    font-weight: 700;
  }

  .audience-row em {
    color: var(--lumix-muted);
    font-size: 11.5px;
    font-style: normal;
    font-weight: 850;
  }

  .check-line {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    position: relative;
  }

  .check-line input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .check-line span {
    width: 18px;
    height: 18px;
    border-radius: 6px;
    border: 1px solid var(--lumix-border-strong);
    background: #fff;
    display: block;
  }

  .check-line input:checked + span {
    background: var(--lumix-blue);
    border-color: var(--lumix-blue);
    position: relative;
  }

  .check-line input:checked + span:after {
    content: '✓';
    color: #fff;
    font-size: 12px;
    font-weight: 950;
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
  }

  .summary-card {
    margin-top: 12px;
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-lg);
    background: #fff;
    padding: 13px;
  }

  .summary-card > strong {
    display: block;
    font-size: 13px;
    font-weight: 950;
    margin-bottom: 10px;
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .summary-grid span {
    border: 1px solid var(--lumix-border);
    background: var(--lumix-soft);
    border-radius: 13px;
    padding: 9px;
    color: var(--lumix-muted);
    font-size: 11px;
    font-weight: 800;
  }

  .summary-grid b {
    display: block;
    margin-top: 3px;
    color: var(--lumix-text);
    font-size: 12.5px;
    font-weight: 950;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .contacts-table {
    display: grid;
    gap: 7px;
  }

  .contacts-head,
  .contacts-row {
    display: grid;
    grid-template-columns: minmax(170px, 1.4fr) 130px 120px 110px 52px;
    gap: 10px;
    align-items: center;
  }

  .contacts-head {
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-md);
    background: var(--lumix-soft);
    padding: 10px 12px;
    color: var(--lumix-muted);
    font-size: 11px;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: .04em;
  }

  .contacts-row {
    border: 1px solid var(--lumix-border);
    border-radius: var(--radius-md);
    background: #fff;
    padding: 10px 12px;
  }

  .contacts-row strong,
  .contacts-row span {
    min-width: 0;
    color: var(--lumix-text);
    font-size: 12.5px;
    font-weight: 850;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .contacts-row small {
    display: block;
    margin-top: 2px;
    color: var(--lumix-muted);
    font-size: 11px;
    font-weight: 700;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
  }

  
  .invalid-image-card {
    min-height: 160px;
    border: 1px dashed #fecaca;
    background: #fef2f2;
    color: #991b1b;
    border-radius: 18px;
    padding: 18px;
    display: grid;
    place-items: center;
    text-align: center;
    gap: 8px;
  }

  .invalid-image-card strong {
    font-size: 13px;
    font-weight: 950;
  }

  .invalid-image-card span {
    color: #7f1d1d;
    font-size: 12px;
    line-height: 1.45;
  }

  .image-warning {
    border: 1px solid #fecaca;
    background: #fef2f2;
    color: #991b1b;
    border-radius: 12px;
    padding: 9px 10px;
    margin-bottom: 8px;
    font-size: 11.5px;
    font-weight: 800;
    line-height: 1.35;
  }

  @media (max-width: 1280px) {
    .native-grid,
    .campaign-editor-native {
      grid-template-columns: 300px minmax(0, 1fr);
    }

    .preview-native-card {
      grid-column: 1 / -1;
      position: static;
    }

    .phone-card {
      grid-template-columns: 260px minmax(0, 1fr);
      align-items: start;
    }

    .phone-meta { height: fit-content; }

    .base-grid,
    .welcome-grid {
      grid-template-columns: 1fr;
    }

    .contacts-card,
    .audience-card { position: static; }
  }

  @media (max-width: 980px) {
    .lumix-crm-module { padding: 12px; }

    .crm-top {
      display: grid;
      gap: 12px;
    }

    .module-tabs {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .native-grid,
    .campaign-editor-native,
    .base-grid,
    .welcome-grid {
      grid-template-columns: 1fr;
    }

    .triggers-card,
    .audience-card,
    .preview-native-card {
      position: static;
    }

    .phone-card {
      grid-template-columns: 1fr;
      justify-items: center;
    }

    .campaigns-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .contacts-head { display: none; }

    .contacts-row {
      grid-template-columns: 1fr;
      gap: 6px;
      align-items: start;
    }

    .contacts-row strong,
    .contacts-row span {
      white-space: normal;
    }
  }

  @media (max-width: 680px) {
    .crm-top h2 { font-size: 27px; }

    .module-tabs,
    .campaigns-grid,
    .form-grid {
      grid-template-columns: 1fr;
    }

    .module-tab { min-height: 64px; }

    .card-title-row,
    .campaigns-head,
    .audience-head,
    .editor-header,
    .actions-row,
    .editor-bottom,
    .toggle-panel {
      flex-direction: column;
      align-items: stretch;
    }

    .primary-action,
    .secondary-action,
    .send-action,
    .mini-action,
    .icon-action,
    .tag-btn,
    .danger-soft-btn {
      width: 100%;
    }

    .type-row { display: grid; grid-template-columns: 1fr; }

    .phone-mockup {
      width: 100%;
      max-width: 300px;
      height: 555px;
    }

    .uploaded-card { height: 170px; }
    .summary-grid { grid-template-columns: 1fr; }

    .audience-row {
      grid-template-columns: 28px minmax(0, 1fr);
    }

    .audience-row em { grid-column: 2; }
  }


  /* =======================================================
     BASE EXTERNA INTELIGENTE — UI GOOGLE-LIKE
  ======================================================= */

  .base-smart-grid {
    display: grid;
    grid-template-columns: minmax(360px, 430px) minmax(0, 1fr);
    gap: 14px;
    align-items: start;
  }

  .base-import-smart-card,
  .base-panel-card {
    border-color: #e8eaed;
    box-shadow: 0 1px 2px rgba(60, 64, 67, .08), 0 1px 3px rgba(60, 64, 67, .06);
  }

  .base-hero-top,
  .base-dashboard-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 14px;
  }

  .base-hero-top h3,
  .base-dashboard-head h3 {
    margin: 8px 0 5px;
    font-size: 20px;
    line-height: 1.05;
    letter-spacing: -.04em;
    font-weight: 950;
  }

  .base-hero-top p,
  .base-dashboard-head p {
    margin: 0;
    max-width: 740px;
    color: var(--lumix-muted);
    font-size: 12.5px;
    font-weight: 650;
    line-height: 1.55;
  }

  .smart-upload-zone {
    width: 100%;
    min-height: 250px;
    border: 1.5px dashed #d0d7de;
    border-radius: 24px;
    background:
      radial-gradient(circle at top left, rgba(66, 133, 244, .10), transparent 35%),
      radial-gradient(circle at bottom right, rgba(52, 168, 83, .10), transparent 34%),
      #fff;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 10px;
    padding: 24px;
    color: #3c4043;
    cursor: pointer;
    transition: .18s ease;
    text-align: center;
  }

  .smart-upload-zone:hover,
  .smart-upload-zone.dragging {
    border-color: #1a73e8;
    background:
      radial-gradient(circle at top left, rgba(66, 133, 244, .16), transparent 38%),
      radial-gradient(circle at bottom right, rgba(52, 168, 83, .14), transparent 36%),
      #f8fbff;
    transform: translateY(-1px);
  }

  .smart-upload-zone:disabled {
    opacity: .75;
    cursor: progress;
    transform: none;
  }

  .upload-orb {
    width: 56px;
    height: 56px;
    border-radius: 18px;
    display: grid;
    place-items: center;
    background: #e8f0fe;
    color: #1967d2;
    box-shadow: inset 0 0 0 1px #dbeafe;
  }

  .smart-upload-zone strong {
    max-width: 310px;
    color: #202124;
    font-size: 15px;
    font-weight: 950;
    letter-spacing: -.02em;
  }

  .smart-upload-zone small {
    color: #5f6368;
    font-size: 12px;
    font-weight: 700;
  }

  .format-pill-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
    margin-top: 6px;
  }

  .format-pill-row span {
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    background: #fff;
    padding: 5px 8px;
    color: #3c4043;
    font-size: 11px;
    font-weight: 900;
  }

  .smart-rules-card {
    margin-top: 12px;
    border: 1px solid #e8eaed;
    border-radius: 20px;
    background: #f8fafd;
    padding: 14px;
  }

  .smart-rules-card strong {
    display: block;
    color: #202124;
    font-size: 13px;
    font-weight: 950;
    margin-bottom: 5px;
  }

  .smart-rules-card p {
    margin: 0;
    color: #5f6368;
    font-size: 12px;
    line-height: 1.5;
    font-weight: 650;
  }

  .field-map-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
    margin-top: 12px;
  }

  .field-map-grid span {
    border: 1px solid #e8eaed;
    border-radius: 12px;
    background: #fff;
    padding: 8px;
    color: #3c4043;
    font-size: 11px;
    font-weight: 900;
  }

  .summary-title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
  }

  .summary-title-line strong {
    color: #202124;
    font-size: 13px;
    font-weight: 950;
  }

  .summary-title-line span {
    border: 1px solid #dbeafe;
    border-radius: 999px;
    background: #eff6ff;
    color: #1967d2;
    padding: 5px 8px;
    font-size: 11px;
    font-weight: 950;
  }

  .smart-summary-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }

  .invalid-import-panel {
    margin-top: 10px;
    border-top: 1px solid #eef2f7;
    padding-top: 10px;
  }

  .invalid-toggle {
    width: 100%;
    border: 1px solid #fee2e2;
    border-radius: 14px;
    background: #fff7f7;
    color: #991b1b;
    padding: 9px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    font-size: 12px;
    font-weight: 900;
  }

  .invalid-list {
    display: grid;
    gap: 7px;
    margin-top: 8px;
    max-height: 220px;
    overflow: auto;
  }

  .invalid-line {
    border: 1px solid #fee2e2;
    border-radius: 14px;
    background: #fff;
    padding: 9px;
  }

  .invalid-line strong,
  .invalid-line code {
    display: block;
  }

  .invalid-line strong {
    color: #991b1b;
    font-size: 11.5px;
    font-weight: 950;
    margin-bottom: 5px;
  }

  .invalid-line code {
    color: #64748b;
    white-space: normal;
    word-break: break-word;
    font-size: 10.5px;
    line-height: 1.45;
  }

  .base-metric-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 12px;
  }

  .base-metric-card {
    border: 1px solid #e8eaed;
    border-radius: 18px;
    background: #fff;
    padding: 11px;
    min-width: 0;
    box-shadow: 0 1px 2px rgba(60, 64, 67, .04);
  }

  .base-metric-card small,
  .base-metric-card span {
    display: block;
    color: #5f6368;
    font-size: 11px;
    font-weight: 800;
  }

  .base-metric-card strong {
    display: block;
    margin: 5px 0 3px;
    color: #202124;
    font-size: 24px;
    line-height: 1;
    letter-spacing: -.05em;
    font-weight: 950;
  }

  .base-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .base-search-box {
    flex: 1;
    height: 44px;
    border: 1px solid #e8eaed;
    border-radius: 999px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 0 14px;
    color: #64748b;
  }

  .base-search-box input {
    width: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    color: #202124;
    font-size: 13px;
    font-weight: 700;
  }

  .base-search-box:focus-within {
    background: #fff;
    border-color: #bfdbfe;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, .10);
  }

  .smart-contacts-table {
    display: grid;
    gap: 8px;
  }

  .smart-contacts-head,
  .smart-contact-row {
    display: grid;
    grid-template-columns: minmax(190px, 1.25fr) 160px minmax(220px, 1fr) 150px 48px;
    gap: 10px;
    align-items: center;
  }

  .smart-contacts-head {
    border: 1px solid #e8eaed;
    border-radius: 16px;
    background: #f8fafc;
    padding: 10px 12px;
    color: #5f6368;
    font-size: 11px;
    font-weight: 950;
    text-transform: uppercase;
    letter-spacing: .04em;
  }

  .smart-contact-row {
    border: 1px solid #e8eaed;
    border-radius: 18px;
    background: #fff;
    padding: 11px 12px;
    transition: .16s ease;
  }

  .smart-contact-row:hover {
    border-color: #dbeafe;
    box-shadow: 0 2px 10px rgba(60, 64, 67, .08);
    transform: translateY(-1px);
  }

  .contact-name-cell,
  .contact-phone-cell,
  .contact-location-cell,
  .contact-dates-cell {
    min-width: 0;
  }

  .contact-name-cell strong,
  .contact-phone-cell strong,
  .contact-location-cell strong {
    display: block;
    color: #202124;
    font-size: 13px;
    font-weight: 950;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .contact-name-cell small,
  .contact-phone-cell small,
  .contact-location-cell small {
    display: block;
    margin-top: 3px;
    color: #64748b;
    font-size: 11.5px;
    font-weight: 750;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .contact-dates-cell {
    display: grid;
    gap: 3px;
  }

  .contact-dates-cell span {
    color: #64748b;
    font-size: 11.5px;
    font-weight: 800;
  }

  .contact-dates-cell b {
    color: #202124;
    font-weight: 950;
  }

  @media (max-width: 1180px) {
    .base-smart-grid { grid-template-columns: 1fr; }
    .base-metric-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  }

  @media (max-width: 760px) {
    .base-metric-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }

    .smart-contacts-head { display: none; }

    .smart-contact-row {
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .smart-contact-row .icon-danger {
      width: 100%;
      justify-content: center;
    }
  }


  .empresa-context-row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }

  .empresa-selector {
    display: grid;
    gap: 4px;
    min-width: min(100%, 310px);
  }

  .empresa-selector > span {
    color: var(--lumix-muted);
    font-size: 10px;
    font-weight: 900;
    letter-spacing: .045em;
    text-transform: uppercase;
  }

  .empresa-selector select {
    width: 100%;
    height: 36px;
    border: 1px solid var(--lumix-border);
    border-radius: 11px;
    outline: 0;
    background: #fff;
    color: var(--lumix-text);
    padding: 0 34px 0 10px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
  }

  .empresa-selector select:focus {
    border-color: #93c5fd;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, .10);
  }

  .empresa-selector select:disabled {
    color: #475569;
    background: var(--lumix-soft);
    cursor: default;
  }

  .empresa-context-row .empresa-chip {
    margin-top: 0;
    min-height: 36px;
    max-width: min(100%, 440px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (min-width: 901px) {
    .lumix-crm-module { padding: 12px; }
    .crm-top { margin-bottom: 10px; padding-bottom: 11px; }
    .crm-top h2 { font-size: clamp(22px, 2.4vw, 28px); }
    .module-tabs { gap: 8px; margin-bottom: 9px; }
    .module-tab { min-height: 62px; padding: 9px 10px; border-radius: 14px; }
    .tab-icon { width: 34px; height: 34px; border-radius: 11px; }
    .module-context { padding: 9px 10px; margin-bottom: 9px; border-radius: 14px; }
    .context-icon { width: 32px; height: 32px; border-radius: 10px; }
    .native-grid,
    .base-grid,
    .campaign-editor-native { gap: 9px; }
    .native-grid { grid-template-columns: 286px minmax(0, 1fr) 330px; }
    .welcome-grid { grid-template-columns: minmax(0, 1fr) 350px; }
    .native-card { padding: 11px; border-radius: 16px; }
    .card-title-row,
    .campaigns-head,
    .audience-head,
    .editor-header { margin-bottom: 10px; }
    .card-title-row h3,
    .campaigns-head h3,
    .audience-head h3,
    .editor-header h3 { font-size: 16px; }
    .triggers-list { gap: 6px; max-height: calc(100vh - 310px); overflow: auto; padding-right: 2px; }
    .trigger-item { padding: 7px 8px; grid-template-columns: 30px minmax(0, 1fr); gap: 8px; border-radius: 13px; }
    .trigger-icon { width: 30px; height: 30px; border-radius: 10px; font-size: 14px; }
    .phone-mockup { width: min(100%, 286px); height: 540px; border-radius: 30px; padding: 8px; }
    .phone-header { height: 64px; padding-top: 21px; }
    .phone-body { height: calc(100% - 114px); padding: 11px; }
    .phone-footer { height: 50px; }
  }

  @media (max-width: 700px) {
    .empresa-context-row { align-items: stretch; }
    .empresa-selector { width: 100%; min-width: 0; }
    .empresa-context-row .empresa-chip { width: 100%; max-width: 100%; }
  }


  /* ========================================================================
     LUMIX CRM — FLAT DPI / ADS MANAGER
     Navegação fixa, hierarquia clara e baixa densidade visual.
  ======================================================================== */

  .lumix-crm-module {
    min-height: 100vh;
    padding: 0;
    background: #f5f6f8;
    font-size: 12px;
  }

  .crm-appbar {
    position: sticky;
    top: 0;
    z-index: 70;
    min-height: 52px;
    border-bottom: 1px solid #dfe3e8;
    background: rgba(255, 255, 255, .96);
    backdrop-filter: blur(12px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 6px 12px;
  }

  .crm-appbar-brand,
  .crm-appbar-company,
  .sidebar-company-block,
  .module-heading-flat {
    display: flex;
    align-items: center;
  }

  .crm-appbar-brand { gap: 8px; }

  .crm-brand-mark,
  .sidebar-company-avatar {
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    background: #1967d2;
    color: #fff;
    font-weight: 900;
    letter-spacing: -.03em;
  }

  .crm-brand-mark {
    width: 30px;
    height: 30px;
    border-radius: 7px;
    font-size: 11px;
  }

  .crm-appbar-brand strong,
  .crm-appbar-brand small,
  .sidebar-company-block strong,
  .sidebar-company-block small,
  .module-heading-flat strong,
  .module-heading-flat span {
    display: block;
  }

  .crm-appbar-brand strong { font-size: 12px; font-weight: 900; }
  .crm-appbar-brand small { margin-top: 1px; color: #6b7280; font-size: 9.5px; font-weight: 700; }

  .crm-appbar-company { gap: 8px; }
  .compact-company-selector { min-width: 250px; gap: 2px; }
  .compact-company-selector > span { font-size: 8.5px; }
  .compact-company-selector select {
    height: 30px;
    min-height: 30px;
    border-radius: 6px;
    font-size: 10.5px;
    padding-left: 8px;
  }

  .appbar-company-id {
    color: #6b7280;
    font-size: 9px;
    font-weight: 800;
    white-space: nowrap;
  }

  .crm-workspace {
    display: grid;
    grid-template-columns: 194px minmax(0, 1fr);
    min-height: calc(100vh - 52px);
  }

  .crm-sidebar {
    position: sticky;
    top: 52px;
    align-self: start;
    height: calc(100vh - 52px);
    overflow: auto;
    border-right: 1px solid #dfe3e8;
    background: #fff;
    padding: 10px 8px;
  }

  .sidebar-company-block {
    gap: 8px;
    min-width: 0;
    padding: 6px 7px 10px;
    margin-bottom: 5px;
    border-bottom: 1px solid #eceff3;
  }

  .sidebar-company-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #e8f0fe;
    color: #174ea6;
    font-size: 9px;
  }

  .sidebar-company-block > span:last-child { min-width: 0; }
  .sidebar-company-block strong {
    max-width: 132px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #202124;
    font-size: 10.5px;
    font-weight: 900;
  }
  .sidebar-company-block small { margin-top: 1px; color: #6b7280; font-size: 8.5px; font-weight: 700; }

  .sidebar-label {
    display: block;
    padding: 8px 8px 5px;
    color: #9aa0a6;
    font-size: 8.5px;
    font-weight: 900;
    letter-spacing: .08em;
    text-transform: uppercase;
  }

  .module-tabs {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2px;
    margin: 0;
  }

  .module-tab {
    position: relative;
    width: 100%;
    min-height: 42px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    box-shadow: none;
    padding: 5px 7px;
    gap: 8px;
    color: #3c4043;
  }

  .module-tab:hover {
    border: 0;
    background: #f1f3f4;
    box-shadow: none;
    transform: none;
  }

  .module-tab.active,
  .module-tab.active:hover,
  .module-tab.active:focus,
  .module-tab.active:active {
    border: 0;
    background: #e8f0fe;
    color: #174ea6;
    box-shadow: none;
  }

  .module-tab.active::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 7px;
    bottom: 7px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: #1967d2;
  }

  .tab-icon {
    width: 26px;
    height: 26px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #5f6368;
  }

  .tab-icon svg { width: 15px; height: 15px; }
  .module-tab.active .tab-icon { border: 0; background: transparent; color: #1967d2; }
  .tab-copy { min-width: 0; flex: 1; }
  .module-tab strong { font-size: 10.5px; font-weight: 900; }
  .module-tab small { margin-top: 1px; font-size: 8.5px; line-height: 1.2; font-weight: 700; }

  .nav-count-badge {
    min-width: 20px;
    height: 18px;
    border-radius: 999px;
    background: #e8f0fe;
    color: #1967d2;
    display: grid;
    place-items: center;
    padding: 0 5px;
    font-size: 8.5px;
    font-weight: 950;
  }

  .nav-count-badge.pending { background: #fee2e2; color: #b91c1c; }

  .crm-main {
    min-width: 0;
    padding: 10px 12px 18px;
  }

  .module-heading-flat {
    gap: 8px;
    min-height: 42px;
    margin-bottom: 8px;
    border-bottom: 1px solid #dfe3e8;
    padding: 0 2px 8px;
  }

  .module-heading-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #e8f0fe;
    color: #1967d2;
    display: grid;
    place-items: center;
  }

  .module-heading-icon svg { width: 15px; height: 15px; }
  .module-heading-flat strong { color: #202124; font-size: 13px; font-weight: 950; }
  .module-heading-flat span { margin-top: 1px; color: #6b7280; font-size: 9.5px; font-weight: 700; }

  .module-content { min-width: 0; }

  .native-grid,
  .campaign-editor-native,
  .base-grid,
  .base-smart-grid {
    gap: 1px;
    border: 1px solid #dfe3e8;
    border-radius: 8px;
    overflow: hidden;
    background: #dfe3e8;
    align-items: stretch;
  }

  .native-grid { grid-template-columns: 246px minmax(0, 1fr) 296px; }
  .welcome-grid { grid-template-columns: minmax(0, 1fr) 310px; }
  .campaign-editor-native { grid-template-columns: minmax(0, 1fr) 342px 300px; }
  .base-grid { grid-template-columns: 340px minmax(0, 1fr); }

  .native-card {
    border: 0;
    border-radius: 0;
    background: #fff;
    box-shadow: none;
    padding: 10px;
  }

  .campaigns-command-center { border: 1px solid #dfe3e8; border-radius: 8px; overflow: hidden; }

  .page-kicker,
  .card-kicker {
    border: 0;
    border-radius: 4px;
    background: #e8f0fe;
    padding: 3px 5px;
    font-size: 8px;
    letter-spacing: .06em;
  }

  .card-title-row,
  .campaigns-head,
  .audience-head,
  .editor-header { margin-bottom: 9px; }

  .card-title-row h3,
  .campaigns-head h3,
  .audience-head h3,
  .editor-header h3 { margin-top: 5px; font-size: 14px; letter-spacing: -.025em; }

  .card-title-row p,
  .campaigns-head p,
  .editor-header p { margin-top: 3px; font-size: 9.5px; }

  .triggers-list { gap: 2px; }
  .trigger-item {
    grid-template-columns: 27px minmax(0, 1fr);
    gap: 7px;
    border: 0;
    border-radius: 5px;
    padding: 5px 6px;
    background: transparent;
  }
  .trigger-item:hover { border: 0; background: #f1f3f4; }
  .trigger-item.active { border: 0; background: #e8f0fe; }
  .trigger-icon { width: 27px; height: 27px; border: 0; border-radius: 6px; font-size: 12px; }
  .trigger-item strong { font-size: 10px; }
  .trigger-item small { font-size: 8.5px; }

  .field { gap: 4px; }
  .field > span,
  .textarea-title-row > span,
  .field span svg { font-size: 9.5px; }

  input,
  select,
  textarea {
    border-radius: 6px;
    font-size: 10.5px;
  }
  input,
  select { min-height: 32px; height: 32px; padding: 0 8px; }
  textarea { min-height: 190px; padding: 8px; line-height: 1.45; }
  .locked-value { min-height: 32px; border-radius: 6px; padding: 0 8px; font-size: 10px; }

  .toggle-panel {
    margin: 8px 0;
    border: 0;
    border-radius: 6px;
    background: #f5f6f8;
    padding: 8px;
  }
  .toggle-panel strong { font-size: 10.5px; }
  .toggle-panel span { margin-top: 1px; font-size: 9px; }

  .primary-action,
  .secondary-action,
  .send-action,
  .mini-action,
  .icon-action,
  .tag-btn,
  .type-chip {
    min-height: 30px;
    border-radius: 6px;
    box-shadow: none;
    font-size: 9.5px;
  }

  .primary-action:hover,
  .secondary-action:hover,
  .send-action:hover,
  .mini-action:hover,
  .icon-action:hover,
  .tag-btn:hover,
  .type-chip:hover { transform: none; box-shadow: none; }

  .image-box,
  .uploaded-card,
  .invalid-image-card,
  .upload-box { border-radius: 6px; }

  .phone-card { gap: 6px; }
  .phone-mockup { width: min(100%, 260px); height: 490px; border-radius: 25px; box-shadow: none; }

  .floating-notification {
    position: fixed;
    top: 60px;
    right: 12px;
    z-index: 100;
    max-width: 360px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, .12);
  }

  .flat-head { align-items: center; padding-bottom: 9px; border-bottom: 1px solid #eceff3; }

  .birthday-command {
    position: relative;
    display: grid;
    grid-template-columns: 34px minmax(0, 1fr) auto;
    align-items: center;
    gap: 9px;
    min-height: 52px;
    margin: 9px 0 12px;
    border: 1px solid #dfe3e8;
    border-radius: 7px;
    background: #f8f9fa;
    padding: 7px 10px;
  }

  .birthday-command.pending { border-color: #fecaca; background: #fff7f7; }
  .birthday-command.done { border-color: #bbf7d0; background: #f5fff7; }
  .birthday-command-icon { font-size: 18px; text-align: center; }
  .birthday-command-copy strong { display: block; color: #202124; font-size: 10.5px; font-weight: 950; }
  .birthday-command-copy span { display: block; margin-top: 2px; color: #6b7280; font-size: 9px; font-weight: 700; }

  .birthday-command-action {
    border: 0;
    border-radius: 5px;
    background: #1967d2;
    color: #fff;
    padding: 7px 9px;
    cursor: pointer;
    font-size: 9px;
    font-weight: 900;
  }

  .attention-dot {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
    border-radius: 50%;
    background: #ef4444;
    opacity: 0;
  }
  .attention-dot.visible { opacity: 1; animation: pulseDot 1.6s infinite; }

  .campaign-ideas-section { margin-bottom: 12px; }
  .section-line-title {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .section-line-title strong { display: block; font-size: 10.5px; font-weight: 950; }
  .section-line-title span { display: block; margin-top: 1px; color: #6b7280; font-size: 8.5px; font-weight: 700; }

  .campaign-ideas-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    border: 1px solid #dfe3e8;
    border-radius: 7px;
    overflow: hidden;
    background: #dfe3e8;
    gap: 1px;
  }

  .campaign-idea-item {
    min-width: 0;
    min-height: 66px;
    border: 0;
    background: #fff;
    padding: 8px;
    display: flex;
    align-items: flex-start;
    gap: 7px;
    text-align: left;
    cursor: pointer;
  }
  .campaign-idea-item:hover { background: #f8fbff; }
  .campaign-idea-icon { font-size: 17px; }
  .campaign-idea-item strong { display: block; color: #202124; font-size: 9.5px; font-weight: 950; }
  .campaign-idea-item small { display: block; margin-top: 2px; color: #6b7280; font-size: 8px; line-height: 1.35; font-weight: 700; }

  .campaign-list-section { border-top: 1px solid #eceff3; padding-top: 9px; }
  .campaign-toolbar-flat {
    display: grid;
    grid-template-columns: minmax(210px, 1fr) 150px auto;
    align-items: center;
    gap: 7px;
    margin-bottom: 7px;
  }

  .campaign-search-flat {
    height: 32px;
    border: 1px solid #dfe3e8;
    border-radius: 6px;
    background: #fff;
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 0 8px;
    color: #6b7280;
  }
  .campaign-search-flat input { height: auto; min-height: 0; border: 0; padding: 0; background: transparent; box-shadow: none; }
  .campaign-status-filter { height: 32px; }
  .flat-count { color: #6b7280; font-size: 8.5px; font-weight: 900; white-space: nowrap; }

  .campaign-table-flat {
    border: 1px solid #dfe3e8;
    border-radius: 7px;
    overflow: hidden;
  }

  .campaign-table-head,
  .campaign-table-row {
    display: grid;
    grid-template-columns: minmax(220px, 1.7fr) 140px 90px 100px 100px;
    gap: 8px;
    align-items: center;
    padding: 7px 9px;
  }

  .campaign-table-head {
    background: #f5f6f8;
    color: #6b7280;
    font-size: 8px;
    font-weight: 950;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  .campaign-table-row {
    width: 100%;
    border: 0;
    border-top: 1px solid #eceff3;
    background: #fff;
    color: #3c4043;
    text-align: left;
    cursor: pointer;
    font-size: 9px;
    font-weight: 750;
  }
  .campaign-table-row:hover { background: #f8fbff; }
  .campaign-main-cell strong { display: block; color: #202124; font-size: 9.5px; font-weight: 950; }
  .campaign-main-cell small { display: block; margin-top: 1px; color: #6b7280; font-size: 8px; font-weight: 700; }
  .campaign-table-row .status-badge { display: inline-flex; font-size: 7.5px; padding: 4px 5px; }
  .flat-empty { border: 0; border-radius: 0; min-height: 170px; }

  @keyframes pulseDot {
    0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(239, 68, 68, .35); }
    50% { transform: scale(1.08); box-shadow: 0 0 0 5px rgba(239, 68, 68, 0); }
  }

  @media (max-width: 1180px) {
    .crm-workspace { grid-template-columns: 174px minmax(0, 1fr); }
    .native-grid { grid-template-columns: 220px minmax(0, 1fr); }
    .native-grid .preview-native-card { display: none; }
    .campaign-editor-native { grid-template-columns: minmax(0, 1fr) 320px; }
    .campaign-editor-native .preview-native-card { display: none; }
    .campaign-ideas-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  }

  @media (max-width: 820px) {
    .crm-appbar { align-items: flex-start; flex-direction: column; }
    .crm-appbar-company { width: 100%; }
    .compact-company-selector { width: 100%; min-width: 0; }
    .appbar-company-id { display: none; }
    .crm-workspace { display: block; }
    .crm-sidebar {
      position: sticky;
      top: 82px;
      z-index: 50;
      width: 100%;
      height: auto;
      border-right: 0;
      border-bottom: 1px solid #dfe3e8;
      padding: 5px 7px;
    }
    .sidebar-company-block,
    .sidebar-label { display: none; }
    .module-tabs { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 3px; }
    .module-tab { justify-content: center; min-height: 38px; padding: 4px; }
    .module-tab.active::before { left: 8px; right: 8px; top: auto; bottom: -5px; width: auto; height: 3px; border-radius: 3px 3px 0 0; }
    .tab-copy small { display: none; }
    .tab-icon { display: none; }
    .module-tab strong { font-size: 8.5px; text-align: center; }
    .nav-count-badge { position: absolute; top: 1px; right: 2px; }
    .crm-main { padding: 8px; }
    .native-grid,
    .welcome-grid,
    .campaign-editor-native,
    .base-grid { grid-template-columns: 1fr; }
    .native-grid .preview-native-card,
    .campaign-editor-native .preview-native-card { display: block; }
    .campaign-ideas-grid { grid-template-columns: 1fr; }
    .campaign-toolbar-flat { grid-template-columns: 1fr; }
    .campaign-table-head { display: none; }
    .campaign-table-row { grid-template-columns: 1fr 1fr; gap: 5px; }
    .campaign-table-row > span:first-child { grid-column: 1 / -1; }
    .birthday-command { grid-template-columns: 30px minmax(0, 1fr); }
    .birthday-command-action { grid-column: 1 / -1; }
  }


  /* =========================================================================
     V2 — PADRÃO GLOBAL DA PLATAFORMA
     Sem aplicativo dentro do aplicativo, sem cabeçalho duplicado e sem cards
     encaixados.
  ========================================================================= */

  .lumix-crm-module {
    min-height: 100%;
    padding: 0 !important;
    background: #ffffff !important;
    color: #171717 !important;
  }

  .crm-appbar {
    display: none !important;
  }

  .crm-workspace {
    min-height: calc(100dvh - 64px);
    display: grid !important;
    grid-template-columns: 230px minmax(0, 1fr) !important;
    gap: 0 !important;
    background: #ffffff !important;
  }

  .crm-sidebar {
    position: static !important;
    min-height: calc(100dvh - 64px);
    padding: 18px 14px !important;
    border: 0 !important;
    border-right: 1px solid #e7e7e7 !important;
    border-radius: 0 !important;
    background: #f7f7f7 !important;
    box-shadow: none !important;
  }

  .sidebar-company-block {
    display: grid !important;
    gap: 10px !important;
    padding: 0 0 16px !important;
    margin: 0 0 16px !important;
    border: 0 !important;
    border-bottom: 1px solid #dddddd !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .sidebar-company-copy {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .sidebar-company-copy > span:last-child {
    min-width: 0;
    display: grid;
    gap: 2px;
  }

  .sidebar-company-copy small {
    color: #777777 !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    letter-spacing: .05em;
    text-transform: uppercase;
  }

  .sidebar-company-copy strong {
    overflow: hidden;
    color: #171717 !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sidebar-company-avatar {
    width: 30px !important;
    height: 30px !important;
    flex: 0 0 30px;
    border: 1px solid #d3d3d3 !important;
    border-radius: 7px !important;
    color: #111111 !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .sidebar-company-select {
    width: 100%;
    height: 34px;
    padding: 0 30px 0 9px;
    border: 1px solid #d5d5d5;
    border-radius: 7px;
    color: #171717;
    background: #ffffff;
    font: inherit;
    font-size: 11px;
    font-weight: 600;
    outline: none;
  }

  .sidebar-company-select:focus {
    border-color: #111111;
    box-shadow: 0 0 0 2px rgba(0,0,0,.05);
  }

  .sidebar-company-select:disabled {
    color: #777777;
    background: #eeeeee;
  }

  .sidebar-label {
    margin: 0 0 7px !important;
    color: #777777 !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    letter-spacing: .06em !important;
  }

  .module-tabs {
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 2px !important;
  }

  .module-tab,
  .module-tab:hover,
  .module-tab:focus,
  .module-tab:active {
    min-height: 44px !important;
    padding: 7px 8px !important;
    border: 0 !important;
    border-left: 2px solid transparent !important;
    border-radius: 0 !important;
    color: #4e4e4e !important;
    background: transparent !important;
    box-shadow: none !important;
    transform: none !important;
  }

  .module-tab:hover {
    color: #111111 !important;
  }

  .module-tab.active {
    border-left-color: #111111 !important;
    color: #111111 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .module-tab .tab-icon,
  .module-tab:hover .tab-icon,
  .module-tab.active .tab-icon {
    width: 24px !important;
    height: 24px !important;
    color: currentColor !important;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .module-tab .tab-copy strong {
    font-size: 11.5px !important;
    font-weight: 700 !important;
  }

  .module-tab .tab-copy small {
    margin-top: 1px !important;
    color: #858585 !important;
    font-size: 9.5px !important;
    font-weight: 500 !important;
  }

  .crm-main {
    min-width: 0;
    padding: 18px 24px 34px !important;
    background: #ffffff !important;
  }

  .module-heading-flat {
    min-height: 44px !important;
    padding: 0 0 14px !important;
    margin: 0 0 16px !important;
    border: 0 !important;
    border-bottom: 1px solid #ececec !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .module-heading-icon {
    display: none !important;
  }

  .module-heading-flat strong {
    color: #171717 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    letter-spacing: -.02em !important;
  }

  .module-heading-flat span {
    margin-top: 2px !important;
    color: #777777 !important;
    font-size: 11px !important;
    font-weight: 500 !important;
  }

  .module-content {
    padding: 0 !important;
    background: #ffffff !important;
  }

  .native-card,
  .surface-card,
  .flat-card,
  .campaign-card,
  .welcome-card,
  .base-import-smart-card,
  .base-panel-card,
  .triggers-card,
  .audience-card,
  .preview-native-card,
  .contacts-card,
  .phone-card {
    border-color: #e8e8e8 !important;
    border-radius: 10px !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .native-grid,
  .campaign-editor-native,
  .base-grid,
  .welcome-grid,
  .base-smart-grid {
    gap: 14px !important;
  }

  .card-inside-card,
  .nested-card {
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  @media (max-width: 980px) {
    .lumix-crm-module {
      padding: 0 !important;
    }

    .crm-workspace {
      grid-template-columns: 1fr !important;
    }

    .crm-sidebar {
      min-height: auto;
      padding: 12px 14px !important;
      border-right: 0 !important;
      border-bottom: 1px solid #e7e7e7 !important;
    }

    .sidebar-company-block {
      grid-template-columns: minmax(0, 1fr) minmax(170px, 260px);
      align-items: center;
      padding-bottom: 12px !important;
      margin-bottom: 10px !important;
    }

    .module-tabs {
      display: flex !important;
      overflow-x: auto;
      gap: 14px !important;
    }

    .module-tab {
      width: auto !important;
      min-width: max-content;
      border-left: 0 !important;
      border-bottom: 2px solid transparent !important;
    }

    .module-tab.active {
      border-bottom-color: #111111 !important;
    }

    .crm-main {
      padding: 16px !important;
    }
  }

  @media (max-width: 680px) {
    .sidebar-company-block {
      grid-template-columns: 1fr;
    }

    .module-tab .tab-copy small {
      display: none !important;
    }

    .crm-main {
      padding: 14px 12px 24px !important;
    }
  }


  /* =========================================================================
     V3 — NATIVO DA PLATAFORMA
     Remove a sensação de CRM separado e integra todos os módulos ao dashboard.
  ========================================================================= */

  .lumix-crm-module {
    width: 100%;
    min-height: 100%;
    padding: 0 !important;
    color: #171717 !important;
    background: #ffffff !important;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, Arial, sans-serif !important;
  }

  .crm-workspace {
    display: block !important;
    min-height: 100% !important;
    background: #ffffff !important;
  }

  .crm-contextbar {
    position: sticky;
    top: 0;
    z-index: 30;
    display: grid;
    grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
    align-items: center;
    gap: 18px;
    min-height: 58px;
    padding: 8px 20px;
    border-bottom: 1px solid #e8e8e8;
    background: rgba(255,255,255,.98);
  }

  .context-company {
    min-width: 0;
    display: grid;
    grid-template-columns: 30px minmax(0, 1fr) minmax(120px, 170px);
    align-items: center;
    gap: 9px;
  }

  .sidebar-company-avatar {
    width: 30px !important;
    height: 30px !important;
    border: 1px solid #d8d8d8 !important;
    border-radius: 7px !important;
    color: #171717 !important;
    background: #ffffff !important;
    font-size: 9px !important;
    box-shadow: none !important;
  }

  .context-company-copy {
    min-width: 0;
    display: grid;
    gap: 1px;
  }

  .context-company-copy small {
    color: #888888;
    font-size: 8.5px;
    font-weight: 700;
    letter-spacing: .05em;
    text-transform: uppercase;
  }

  .context-company-copy strong {
    overflow: hidden;
    color: #171717;
    font-size: 10.5px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sidebar-company-select {
    width: 100%;
    height: 32px !important;
    padding: 0 28px 0 8px !important;
    border: 1px solid #d8d8d8 !important;
    border-radius: 7px !important;
    color: #171717 !important;
    background: #ffffff !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    box-shadow: none !important;
  }

  .module-tabs {
    display: flex !important;
    align-items: stretch;
    justify-content: flex-end;
    gap: 16px !important;
    min-width: 0;
    margin: 0 !important;
    overflow-x: auto;
  }

  .module-tab,
  .module-tab:hover,
  .module-tab:focus,
  .module-tab:active {
    position: relative;
    width: auto !important;
    min-width: max-content;
    min-height: 40px !important;
    padding: 0 1px !important;
    border: 0 !important;
    border-bottom: 2px solid transparent !important;
    border-radius: 0 !important;
    color: #696969 !important;
    background: transparent !important;
    box-shadow: none !important;
    transform: none !important;
  }

  .module-tab.active,
  .module-tab.active:hover,
  .module-tab.active:focus {
    border-bottom-color: #171717 !important;
    color: #171717 !important;
    background: transparent !important;
  }

  .module-tab.active::before {
    display: none !important;
  }

  .tab-icon {
    width: 20px !important;
    height: 20px !important;
    border: 0 !important;
    border-radius: 0 !important;
    color: currentColor !important;
    background: transparent !important;
  }

  .tab-icon svg {
    width: 14px !important;
    height: 14px !important;
  }

  .tab-copy strong {
    font-size: 10.5px !important;
    font-weight: 700 !important;
  }

  .tab-copy small {
    display: none !important;
  }

  .nav-count-badge {
    min-width: 17px !important;
    height: 17px !important;
    padding: 0 4px !important;
    border-radius: 5px !important;
    font-size: 8.5px !important;
  }

  .crm-main {
    min-width: 0;
    padding: 18px 22px 36px !important;
    background: #ffffff !important;
  }

  .module-heading-flat {
    min-height: 42px !important;
    padding: 0 0 13px !important;
    margin: 0 0 14px !important;
    border: 0 !important;
    border-bottom: 1px solid #ececec !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .module-heading-flat strong {
    color: #171717 !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    letter-spacing: -.015em !important;
  }

  .module-heading-flat span {
    margin-top: 2px !important;
    color: #7a7a7a !important;
    font-size: 10.5px !important;
  }

  .module-content {
    padding: 0 !important;
    background: #ffffff !important;
  }

  .page-kicker,
  .card-kicker,
  .security-chip {
    display: none !important;
  }

  .native-grid {
    display: grid !important;
    grid-template-columns: 230px minmax(0, 1fr) !important;
    gap: 0 !important;
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    background: #ffffff;
  }

  .native-card,
  .editor-card,
  .triggers-card {
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .triggers-card {
    position: static !important;
    border-right: 1px solid #e8e8e8 !important;
    background: #f8f8f8 !important;
  }

  .card-title-row {
    min-height: 50px;
    padding: 10px 12px !important;
    margin: 0 !important;
    border-bottom: 1px solid #ececec;
    align-items: center !important;
  }

  .card-title-row h3 {
    margin: 0 !important;
    color: #171717 !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    letter-spacing: -.01em !important;
  }

  .mini-action,
  .secondary-action,
  .primary-action,
  .ghost-action {
    min-height: 31px !important;
    padding: 0 9px !important;
    border-radius: 6px !important;
    font-size: 9.5px !important;
    font-weight: 650 !important;
    box-shadow: none !important;
    transform: none !important;
  }

  .triggers-list {
    display: grid !important;
    gap: 0 !important;
  }

  .trigger-item {
    min-height: 52px !important;
    padding: 8px 10px !important;
    border: 0 !important;
    border-bottom: 1px solid #ececec !important;
    border-radius: 0 !important;
    grid-template-columns: 26px minmax(0, 1fr) !important;
    gap: 8px !important;
    color: #444444 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .trigger-item:hover {
    background: #f2f2f2 !important;
  }

  .trigger-item.active {
    color: #171717 !important;
    background: #ffffff !important;
    box-shadow: inset 2px 0 0 #171717 !important;
  }

  .trigger-icon {
    width: 24px !important;
    height: 24px !important;
    border: 0 !important;
    border-radius: 5px !important;
    background: #ececec !important;
    font-size: 11px !important;
  }

  .trigger-item strong {
    font-size: 10.5px !important;
    font-weight: 700 !important;
  }

  .trigger-item small {
    margin-top: 1px !important;
    color: #818181 !important;
    font-size: 9px !important;
    font-weight: 500 !important;
  }

  .editor-card > *:not(.card-title-row) {
    padding-left: 14px;
    padding-right: 14px;
  }

  .form-grid,
  .campaign-form-grid {
    gap: 9px !important;
  }

  .field {
    gap: 4px !important;
  }

  .field > span,
  .textarea-title-row > span {
    color: #686868 !important;
    font-size: 9.5px !important;
    font-weight: 700 !important;
  }

  input,
  select,
  textarea {
    border: 1px solid #d8d8d8 !important;
    border-radius: 7px !important;
    color: #171717 !important;
    background: #ffffff !important;
    font-size: 10.5px !important;
    font-weight: 600 !important;
    box-shadow: none !important;
  }

  input,
  select {
    min-height: 33px !important;
    padding: 0 8px !important;
  }

  textarea {
    min-height: 220px !important;
    padding: 9px !important;
  }

  input:focus,
  select:focus,
  textarea:focus {
    border-color: #171717 !important;
    box-shadow: 0 0 0 2px rgba(0,0,0,.05) !important;
  }

  .locked-value,
  .toggle-row,
  .image-upload-zone,
  .preview-phone,
  .editor-side-card,
  .native-preview-card,
  .campaign-form-panel,
  .campaign-audience-panel {
    border-radius: 8px !important;
    box-shadow: none !important;
  }

  .actions-row,
  .editor-actions,
  .form-actions {
    padding-top: 12px !important;
    border-top: 1px solid #ececec !important;
  }

  /* Base externa totalmente nativa */

  .base-smart-grid {
    display: block !important;
  }

  .base-import-smart-card,
  .base-panel-card {
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .base-import-smart-card {
    border-top: 1px solid #e8e8e8 !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }

  .base-hero-top,
  .base-dashboard-head {
    min-height: 54px;
    margin: 0 !important;
    padding: 10px 12px !important;
    border-bottom: 1px solid #ececec;
    align-items: center !important;
  }

  .base-hero-top h3,
  .base-dashboard-head h3 {
    margin: 0 0 2px !important;
    color: #171717 !important;
    font-size: 13px !important;
    line-height: 1.2 !important;
    font-weight: 700 !important;
    letter-spacing: -.015em !important;
  }

  .base-hero-top p,
  .base-dashboard-head p {
    max-width: 760px !important;
    color: #777777 !important;
    font-size: 9.5px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;
  }

  .smart-upload-zone {
    width: auto !important;
    min-height: 112px !important;
    margin: 12px !important;
    padding: 16px !important;
    border: 1px dashed #cfcfcf !important;
    border-radius: 8px !important;
    color: #444444 !important;
    background: #fafafa !important;
    box-shadow: none !important;
    transform: none !important;
  }

  .smart-upload-zone:hover,
  .smart-upload-zone.dragging {
    border-color: #171717 !important;
    background: #f5f5f5 !important;
    transform: none !important;
  }

  .upload-orb {
    width: 34px !important;
    height: 34px !important;
    border: 1px solid #dddddd !important;
    border-radius: 7px !important;
    color: #333333 !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .smart-upload-zone strong {
    color: #171717 !important;
    font-size: 11.5px !important;
    font-weight: 700 !important;
  }

  .smart-upload-zone small {
    color: #777777 !important;
    font-size: 9.5px !important;
  }

  .format-pill-row {
    gap: 4px !important;
    margin-top: 2px !important;
  }

  .format-pill-row span {
    padding: 3px 6px !important;
    border-radius: 5px !important;
    color: #666666 !important;
    background: #ffffff !important;
    font-size: 8.5px !important;
    font-weight: 600 !important;
  }

  .smart-rules-card,
  .base-last-import-card {
    margin: 0 !important;
    padding: 10px 12px !important;
    border: 0 !important;
    border-top: 1px solid #ececec !important;
    border-radius: 0 !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .smart-rules-card strong,
  .base-last-import-card strong {
    color: #171717 !important;
    font-size: 10.5px !important;
    font-weight: 700 !important;
  }

  .smart-rules-card p,
  .base-last-import-card p {
    color: #777777 !important;
    font-size: 9.5px !important;
  }

  .field-map-grid {
    gap: 0 !important;
    margin-top: 8px !important;
    border-top: 1px solid #ececec;
    border-left: 1px solid #ececec;
  }

  .field-map-grid span {
    padding: 7px 8px !important;
    border: 0 !important;
    border-right: 1px solid #ececec !important;
    border-bottom: 1px solid #ececec !important;
    border-radius: 0 !important;
    color: #555555 !important;
    background: #fafafa !important;
    font-size: 9px !important;
    font-weight: 600 !important;
  }

  .base-panel-card {
    margin-top: 14px !important;
    border-top: 1px solid #e8e8e8 !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }

  .base-stats-grid {
    gap: 0 !important;
    padding: 0 !important;
    border-bottom: 1px solid #ececec;
  }

  .base-stat-card {
    min-height: 58px !important;
    padding: 10px 12px !important;
    border: 0 !important;
    border-right: 1px solid #ececec !important;
    border-radius: 0 !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .base-stat-card:last-child {
    border-right: 0 !important;
  }

  .base-stat-card span {
    color: #808080 !important;
    font-size: 8.5px !important;
    font-weight: 700 !important;
  }

  .base-stat-card strong {
    margin-top: 4px !important;
    color: #171717 !important;
    font-size: 18px !important;
    font-weight: 700 !important;
  }

  .base-toolbar {
    padding: 10px 12px !important;
    border-bottom: 1px solid #ececec !important;
    background: #ffffff !important;
  }

  .base-table-wrap,
  .campaign-table-wrap,
  .clients-table-wrap {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .base-table-wrap table,
  .campaign-table-wrap table,
  .clients-table-wrap table {
    background: #ffffff !important;
  }

  .base-table-wrap th,
  .campaign-table-wrap th,
  .clients-table-wrap th {
    padding: 8px 10px !important;
    color: #777777 !important;
    background: #f7f7f7 !important;
    font-size: 8.5px !important;
    font-weight: 700 !important;
  }

  .base-table-wrap td,
  .campaign-table-wrap td,
  .clients-table-wrap td {
    padding: 8px 10px !important;
    border-bottom: 1px solid #eeeeee !important;
    color: #333333 !important;
    font-size: 9.5px !important;
  }

  .floating-notification {
    right: 18px !important;
    bottom: 18px !important;
    border-radius: 8px !important;
    box-shadow: 0 12px 36px rgba(0,0,0,.16) !important;
  }

  @media (max-width: 980px) {
    .crm-contextbar {
      position: static;
      grid-template-columns: 1fr;
      gap: 8px;
      padding: 10px 14px;
    }

    .module-tabs {
      justify-content: flex-start;
    }

    .crm-main {
      padding: 16px 14px 28px !important;
    }

    .native-grid {
      grid-template-columns: 1fr !important;
    }

    .triggers-card {
      border-right: 0 !important;
      border-bottom: 1px solid #e8e8e8 !important;
    }

    .triggers-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .trigger-item {
      border-right: 1px solid #ececec !important;
    }
  }

  @media (max-width: 680px) {
    .context-company {
      grid-template-columns: 30px minmax(0, 1fr);
    }

    .sidebar-company-select {
      grid-column: 1 / -1;
    }

    .module-tab {
      gap: 5px !important;
    }

    .tab-icon {
      display: none !important;
    }

    .crm-main {
      padding: 14px 10px 24px !important;
    }

    .triggers-list {
      grid-template-columns: 1fr !important;
    }

    .base-stats-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }


  /* =========================================================================
     V4 — REDESIGN COMPLETO
     Régua pós-venda, Boas-vindas e Base externa
  ========================================================================= */

  .lumix-crm-module {
    --v4-bg: #ffffff;
    --v4-panel: #ffffff;
    --v4-soft: #f7f8f8;
    --v4-soft-2: #f1f3f3;
    --v4-line: #e5e8e8;
    --v4-line-strong: #d8dddd;
    --v4-text: #1f2929;
    --v4-muted: #747f7f;
    --v4-accent: #254b49;
    --v4-accent-soft: #edf4f3;
    --v4-danger: #a43c35;
    background: var(--v4-bg) !important;
  }

  /* Área geral */
  .lumix-crm-module .crm-main {
    padding: 18px 20px 32px !important;
    background: #fff !important;
  }

  .lumix-crm-module .module-heading {
    margin-bottom: 14px !important;
    padding-bottom: 12px !important;
    border-bottom: 1px solid var(--v4-line) !important;
  }

  .lumix-crm-module .module-heading h1,
  .lumix-crm-module .module-heading h2 {
    color: var(--v4-text) !important;
    font-size: 18px !important;
    line-height: 1.2 !important;
    letter-spacing: -.025em !important;
  }

  .lumix-crm-module .module-heading p {
    color: var(--v4-muted) !important;
    font-size: 11px !important;
  }

  .lumix-crm-module .native-card {
    border: 0 !important;
    border-radius: 0 !important;
    background: #fff !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .card-kicker {
    display: none !important;
  }

  .lumix-crm-module .card-title-row {
    min-height: 54px;
    margin: 0 !important;
    padding: 11px 13px !important;
    border-bottom: 1px solid var(--v4-line) !important;
    align-items: center !important;
  }

  .lumix-crm-module .card-title-row h3 {
    margin: 0 !important;
    color: var(--v4-text) !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    letter-spacing: -.015em !important;
  }

  .lumix-crm-module .card-title-row p {
    margin: 3px 0 0 !important;
    color: var(--v4-muted) !important;
    font-size: 10px !important;
  }

  .lumix-crm-module .mini-action,
  .lumix-crm-module .secondary-action,
  .lumix-crm-module .primary-action {
    min-height: 32px !important;
    padding: 0 10px !important;
    border-radius: 7px !important;
    font-size: 10.5px !important;
    font-weight: 700 !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .mini-action,
  .lumix-crm-module .secondary-action {
    border: 1px solid var(--v4-line-strong) !important;
    color: #354343 !important;
    background: #fff !important;
  }

  .lumix-crm-module .primary-action {
    border: 1px solid var(--v4-accent) !important;
    color: #fff !important;
    background: var(--v4-accent) !important;
  }

  /* -------------------------------------------------------------------------
     RÉGUA PÓS-VENDA
  ------------------------------------------------------------------------- */
  .lumix-crm-module .native-grid:not(.welcome-grid) {
    display: grid !important;
    grid-template-columns: 245px minmax(0, 1fr) 300px !important;
    gap: 0 !important;
    align-items: stretch !important;
    border: 1px solid var(--v4-line) !important;
    background: #fff !important;
  }

  .lumix-crm-module .triggers-card {
    min-width: 0;
    border-right: 1px solid var(--v4-line) !important;
    background: var(--v4-soft) !important;
  }

  .lumix-crm-module .triggers-list {
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 0 !important;
    padding: 0 !important;
  }

  .lumix-crm-module .trigger-item {
    min-height: 58px !important;
    padding: 9px 11px !important;
    grid-template-columns: 30px minmax(0, 1fr) !important;
    gap: 8px !important;
    border: 0 !important;
    border-bottom: 1px solid var(--v4-line) !important;
    border-radius: 0 !important;
    color: #3d4949 !important;
    background: transparent !important;
    box-shadow: none !important;
    text-align: left !important;
  }

  .lumix-crm-module .trigger-item:hover {
    background: #f1f4f4 !important;
  }

  .lumix-crm-module .trigger-item.active {
    color: var(--v4-text) !important;
    background: #fff !important;
    box-shadow: inset 3px 0 0 var(--v4-accent) !important;
  }

  .lumix-crm-module .trigger-icon {
    width: 27px !important;
    height: 27px !important;
    display: grid !important;
    place-items: center !important;
    border: 1px solid var(--v4-line-strong) !important;
    border-radius: 6px !important;
    background: #fff !important;
    font-size: 12px !important;
  }

  .lumix-crm-module .trigger-item strong {
    color: inherit !important;
    font-size: 11px !important;
    font-weight: 700 !important;
  }

  .lumix-crm-module .trigger-item small {
    margin-top: 2px !important;
    color: var(--v4-muted) !important;
    font-size: 9.5px !important;
  }

  .lumix-crm-module .editor-card {
    min-width: 0;
    padding: 0 !important;
  }

  .lumix-crm-module .editor-card > .form-grid,
  .lumix-crm-module .editor-card > .toggle-panel,
  .lumix-crm-module .editor-card > .compact-media-field,
  .lumix-crm-module .editor-card > .message-field {
    margin-left: 14px !important;
    margin-right: 14px !important;
  }

  .lumix-crm-module .form-grid {
    margin-top: 14px !important;
    gap: 10px !important;
  }

  .lumix-crm-module .field {
    gap: 5px !important;
  }

  .lumix-crm-module .field > span,
  .lumix-crm-module .textarea-title-row > span {
    color: #596464 !important;
    font-size: 9.5px !important;
    font-weight: 700 !important;
    letter-spacing: .03em !important;
    text-transform: uppercase !important;
  }

  .lumix-crm-module input,
  .lumix-crm-module select,
  .lumix-crm-module textarea,
  .lumix-crm-module .locked-value {
    border: 1px solid var(--v4-line-strong) !important;
    border-radius: 7px !important;
    color: var(--v4-text) !important;
    background: #fff !important;
    box-shadow: none !important;
  }

  .lumix-crm-module input,
  .lumix-crm-module select,
  .lumix-crm-module .locked-value {
    min-height: 34px !important;
    padding: 0 9px !important;
    font-size: 11px !important;
  }

  .lumix-crm-module textarea {
    min-height: 220px !important;
    padding: 10px !important;
    font-size: 11.5px !important;
    line-height: 1.5 !important;
    resize: vertical !important;
  }

  .lumix-crm-module input:focus,
  .lumix-crm-module select:focus,
  .lumix-crm-module textarea:focus {
    border-color: var(--v4-accent) !important;
    box-shadow: 0 0 0 2px rgba(37,75,73,.08) !important;
  }

  .lumix-crm-module .toggle-panel {
    min-height: 50px !important;
    margin-top: 12px !important;
    padding: 9px 10px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 8px !important;
    background: var(--v4-soft) !important;
  }

  .lumix-crm-module .toggle-panel strong {
    color: var(--v4-text) !important;
    font-size: 10.5px !important;
  }

  .lumix-crm-module .toggle-panel span {
    color: var(--v4-muted) !important;
    font-size: 9.5px !important;
  }

  .lumix-crm-module .security-chip {
    padding: 4px 7px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 6px !important;
    color: #61706f !important;
    background: var(--v4-soft) !important;
    font-size: 9px !important;
  }

  .lumix-crm-module .message-field {
    margin-top: 13px !important;
    margin-bottom: 14px !important;
  }

  .lumix-crm-module .textarea-title-row {
    margin-bottom: 6px !important;
  }

  .lumix-crm-module .tag-btn {
    min-height: 26px !important;
    padding: 0 7px !important;
    border: 1px solid var(--v4-line-strong) !important;
    border-radius: 6px !important;
    color: #455353 !important;
    background: #fff !important;
    font-size: 9px !important;
  }

  .lumix-crm-module .editor-bottom {
    margin-top: 8px !important;
    padding-top: 9px !important;
    border-top: 1px solid var(--v4-line) !important;
  }

  .lumix-crm-module .editor-bottom small {
    color: var(--v4-muted) !important;
    font-size: 9.5px !important;
  }

  /* Imagem compacta */
  .lumix-crm-module .compact-media-field {
    margin-top: 12px !important;
    padding: 10px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 8px !important;
    background: #fff !important;
  }

  .lumix-crm-module .compact-media-copy {
    margin-bottom: 8px !important;
    display: grid !important;
    gap: 2px !important;
  }

  .lumix-crm-module .compact-media-copy strong {
    color: var(--v4-text) !important;
    font-size: 10.5px !important;
  }

  .lumix-crm-module .compact-media-copy span {
    color: var(--v4-muted) !important;
    font-size: 9.5px !important;
  }

  .lumix-crm-module .compact-media-preview {
    display: grid !important;
    grid-template-columns: 96px minmax(0, 1fr) !important;
    gap: 10px !important;
    align-items: center !important;
    padding: 8px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 7px !important;
    background: var(--v4-soft) !important;
  }

  .lumix-crm-module .compact-media-thumb {
    width: 96px !important;
    height: 66px !important;
    padding: 0 !important;
    overflow: hidden !important;
    border: 1px solid var(--v4-line-strong) !important;
    border-radius: 6px !important;
    background: #fff !important;
  }

  .lumix-crm-module .compact-media-thumb img {
    width: 100% !important;
    height: 100% !important;
    display: block !important;
    object-fit: cover !important;
  }

  .lumix-crm-module .compact-media-info {
    min-width: 0;
    display: grid !important;
    gap: 2px !important;
  }

  .lumix-crm-module .compact-media-info strong {
    color: var(--v4-text) !important;
    font-size: 10.5px !important;
  }

  .lumix-crm-module .compact-media-info small {
    overflow: hidden !important;
    color: var(--v4-muted) !important;
    font-size: 9px !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .lumix-crm-module .compact-media-actions {
    margin-top: 6px !important;
    display: flex !important;
    gap: 6px !important;
  }

  .lumix-crm-module .media-change-btn,
  .lumix-crm-module .media-remove-btn {
    min-height: 27px !important;
    padding: 0 7px !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 5px !important;
    border-radius: 6px !important;
    font-size: 9.5px !important;
    font-weight: 700 !important;
  }

  .lumix-crm-module .media-change-btn {
    border: 1px solid var(--v4-line-strong) !important;
    color: #455353 !important;
    background: #fff !important;
  }

  .lumix-crm-module .media-remove-btn {
    border: 1px solid #ead6d3 !important;
    color: var(--v4-danger) !important;
    background: #fff8f7 !important;
  }

  .lumix-crm-module .compact-media-upload,
  .lumix-crm-module .compact-media-status {
    width: 100% !important;
    min-height: 58px !important;
    padding: 9px 10px !important;
    display: grid !important;
    grid-template-columns: 30px minmax(0, 1fr) auto !important;
    gap: 9px !important;
    align-items: center !important;
    border: 1px dashed var(--v4-line-strong) !important;
    border-radius: 7px !important;
    color: #465454 !important;
    background: var(--v4-soft) !important;
    text-align: left !important;
  }

  .lumix-crm-module .compact-media-upload > span,
  .lumix-crm-module .compact-media-status-icon {
    width: 28px !important;
    height: 28px !important;
    display: grid !important;
    place-items: center !important;
    border-radius: 6px !important;
    color: var(--v4-accent) !important;
    background: var(--v4-accent-soft) !important;
  }

  .lumix-crm-module .compact-media-upload strong,
  .lumix-crm-module .compact-media-status strong {
    display: block !important;
    color: var(--v4-text) !important;
    font-size: 10.5px !important;
  }

  .lumix-crm-module .compact-media-upload small,
  .lumix-crm-module .compact-media-status small {
    display: block !important;
    margin-top: 2px !important;
    color: var(--v4-muted) !important;
    font-size: 9px !important;
  }

  /* Prévia lateral menor */
  .lumix-crm-module .preview-native-card {
    min-width: 0;
    padding: 12px !important;
    border-left: 1px solid var(--v4-line) !important;
    background: var(--v4-soft) !important;
  }

  .lumix-crm-module .phone-card {
    position: sticky !important;
    top: 12px !important;
  }

  .lumix-crm-module .phone-meta {
    margin-bottom: 8px !important;
  }

  .lumix-crm-module .phone-meta span,
  .lumix-crm-module .phone-meta strong {
    font-size: 9px !important;
  }

  .lumix-crm-module .phone-mockup {
    width: 100% !important;
    max-width: 255px !important;
    min-height: 410px !important;
    margin: 0 auto !important;
    border: 1px solid #cfd5d5 !important;
    border-radius: 20px !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .phone-body {
    min-height: 310px !important;
    padding: 10px 8px !important;
  }

  .lumix-crm-module .msg-bubble {
    max-width: 94% !important;
    padding: 7px !important;
    font-size: 10px !important;
    line-height: 1.45 !important;
  }

  .lumix-crm-module .msg-image-preview {
    max-height: 112px !important;
    margin-bottom: 6px !important;
    overflow: hidden !important;
    border-radius: 6px !important;
  }

  .lumix-crm-module .msg-image-preview img {
    width: 100% !important;
    max-height: 112px !important;
    object-fit: cover !important;
  }

  /* -------------------------------------------------------------------------
     BOAS-VINDAS
  ------------------------------------------------------------------------- */
  .lumix-crm-module .welcome-grid {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) 300px !important;
    gap: 0 !important;
    align-items: stretch !important;
    border: 1px solid var(--v4-line) !important;
    background: #fff !important;
  }

  .lumix-crm-module .welcome-grid .editor-card {
    border-right: 0 !important;
  }

  .lumix-crm-module .welcome-grid .editor-card > .toggle-panel,
  .lumix-crm-module .welcome-grid .editor-card > .compact-media-field,
  .lumix-crm-module .welcome-grid .editor-card > .message-field {
    margin-left: 14px !important;
    margin-right: 14px !important;
  }

  /* -------------------------------------------------------------------------
     BASE EXTERNA
  ------------------------------------------------------------------------- */
  .lumix-crm-module .base-smart-grid {
    display: grid !important;
    grid-template-columns: 330px minmax(0, 1fr) !important;
    gap: 0 !important;
    align-items: stretch !important;
    border: 1px solid var(--v4-line) !important;
    background: #fff !important;
  }

  .lumix-crm-module .base-import-smart-card {
    min-width: 0;
    padding: 0 !important;
    border-right: 1px solid var(--v4-line) !important;
    background: var(--v4-soft) !important;
  }

  .lumix-crm-module .base-hero-top {
    min-height: 72px !important;
    padding: 12px 13px !important;
    border-bottom: 1px solid var(--v4-line) !important;
    align-items: center !important;
  }

  .lumix-crm-module .base-hero-top h3 {
    margin: 0 0 3px !important;
    color: var(--v4-text) !important;
    font-size: 13px !important;
    font-weight: 700 !important;
  }

  .lumix-crm-module .base-hero-top p {
    margin: 0 !important;
    color: var(--v4-muted) !important;
    font-size: 9.5px !important;
    line-height: 1.4 !important;
  }

  .lumix-crm-module .smart-upload-zone {
    width: auto !important;
    min-height: 132px !important;
    margin: 12px !important;
    padding: 15px 12px !important;
    border: 1px dashed #bdc8c7 !important;
    border-radius: 9px !important;
    color: #3f4d4d !important;
    background: #fff !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .smart-upload-zone.dragging {
    border-color: var(--v4-accent) !important;
    background: var(--v4-accent-soft) !important;
  }

  .lumix-crm-module .upload-orb {
    width: 38px !important;
    height: 38px !important;
    border-radius: 8px !important;
    color: var(--v4-accent) !important;
    background: var(--v4-accent-soft) !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .smart-upload-zone strong {
    margin-top: 8px !important;
    font-size: 10.5px !important;
  }

  .lumix-crm-module .smart-upload-zone small {
    margin-top: 3px !important;
    color: var(--v4-muted) !important;
    font-size: 9px !important;
  }

  .lumix-crm-module .format-pill-row {
    margin-top: 9px !important;
    gap: 4px !important;
  }

  .lumix-crm-module .format-pill-row span {
    padding: 3px 5px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 5px !important;
    color: #657070 !important;
    background: var(--v4-soft) !important;
    font-size: 8px !important;
  }

  .lumix-crm-module .smart-rules-card {
    margin: 0 12px 12px !important;
    padding: 10px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 8px !important;
    background: #fff !important;
  }

  .lumix-crm-module .smart-rules-card > strong {
    color: var(--v4-text) !important;
    font-size: 10px !important;
  }

  .lumix-crm-module .smart-rules-card > p {
    margin: 3px 0 8px !important;
    color: var(--v4-muted) !important;
    font-size: 9px !important;
    line-height: 1.4 !important;
  }

  .lumix-crm-module .field-map-grid {
    grid-template-columns: 1fr 1fr !important;
    gap: 4px !important;
  }

  .lumix-crm-module .field-map-grid span {
    padding: 5px !important;
    border-radius: 5px !important;
    color: #556161 !important;
    background: var(--v4-soft) !important;
    font-size: 8.5px !important;
  }

  .lumix-crm-module .summary-card {
    margin: 0 12px 12px !important;
    padding: 10px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 8px !important;
    background: #fff !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .summary-grid {
    grid-template-columns: 1fr 1fr !important;
    gap: 5px !important;
  }

  .lumix-crm-module .summary-grid span {
    padding: 5px !important;
    border-radius: 5px !important;
    background: var(--v4-soft) !important;
    font-size: 8.5px !important;
  }

  .lumix-crm-module .base-panel-card {
    min-width: 0;
    padding: 0 !important;
  }

  .lumix-crm-module .base-dashboard-head {
    min-height: 66px !important;
    padding: 11px 13px !important;
    border-bottom: 1px solid var(--v4-line) !important;
    align-items: center !important;
  }

  .lumix-crm-module .base-dashboard-head h3 {
    margin: 0 0 3px !important;
    color: var(--v4-text) !important;
    font-size: 13px !important;
    font-weight: 700 !important;
  }

  .lumix-crm-module .base-dashboard-head p {
    margin: 0 !important;
    color: var(--v4-muted) !important;
    font-size: 9.5px !important;
  }

  .lumix-crm-module .counter-chip {
    padding: 4px 7px !important;
    border: 1px solid var(--v4-line) !important;
    border-radius: 6px !important;
    color: #586666 !important;
    background: var(--v4-soft) !important;
    font-size: 9px !important;
  }

  .lumix-crm-module .base-metric-grid {
    display: grid !important;
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    gap: 0 !important;
    border-bottom: 1px solid var(--v4-line) !important;
  }

  .lumix-crm-module .base-metric-card {
    min-height: 65px !important;
    padding: 10px !important;
    border: 0 !important;
    border-right: 1px solid var(--v4-line) !important;
    border-radius: 0 !important;
    background: #fff !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .base-metric-card:last-child {
    border-right: 0 !important;
  }

  .lumix-crm-module .base-metric-card small {
    color: var(--v4-muted) !important;
    font-size: 8.5px !important;
    text-transform: uppercase !important;
    letter-spacing: .04em !important;
  }

  .lumix-crm-module .base-metric-card strong {
    margin-top: 4px !important;
    color: var(--v4-text) !important;
    font-size: 17px !important;
    line-height: 1 !important;
  }

  .lumix-crm-module .base-metric-card span {
    margin-top: 3px !important;
    color: #8a9292 !important;
    font-size: 8.5px !important;
  }

  .lumix-crm-module .base-toolbar {
    padding: 10px 12px !important;
    border-bottom: 1px solid var(--v4-line) !important;
    background: var(--v4-soft) !important;
  }

  .lumix-crm-module .base-search-box {
    min-height: 34px !important;
    border: 1px solid var(--v4-line-strong) !important;
    border-radius: 7px !important;
    background: #fff !important;
  }

  .lumix-crm-module .base-search-box input {
    border: 0 !important;
    box-shadow: none !important;
  }

  .lumix-crm-module .smart-contacts-table {
    border: 0 !important;
    border-radius: 0 !important;
    background: #fff !important;
  }

  .lumix-crm-module .smart-contacts-head {
    min-height: 34px !important;
    padding: 0 11px !important;
    border-bottom: 1px solid var(--v4-line) !important;
    color: #737d7d !important;
    background: #f4f6f6 !important;
    font-size: 8.5px !important;
    font-weight: 700 !important;
  }

  .lumix-crm-module .smart-contact-row {
    min-height: 62px !important;
    padding: 8px 11px !important;
    border-bottom: 1px solid var(--v4-line) !important;
    background: #fff !important;
  }

  .lumix-crm-module .smart-contact-row:hover {
    background: #fafbfb !important;
  }

  .lumix-crm-module .smart-contact-row strong {
    color: var(--v4-text) !important;
    font-size: 10px !important;
  }

  .lumix-crm-module .smart-contact-row small,
  .lumix-crm-module .smart-contact-row span {
    color: var(--v4-muted) !important;
    font-size: 8.5px !important;
  }

  .lumix-crm-module .icon-danger {
    width: 28px !important;
    height: 28px !important;
    border: 1px solid #ead6d3 !important;
    border-radius: 6px !important;
    color: var(--v4-danger) !important;
    background: #fff8f7 !important;
  }

  /* Responsivo */
  @media (max-width: 1180px) {
    .lumix-crm-module .native-grid:not(.welcome-grid) {
      grid-template-columns: 220px minmax(0, 1fr) !important;
    }

    .lumix-crm-module .native-grid:not(.welcome-grid) .preview-native-card {
      grid-column: 1 / -1 !important;
      border-top: 1px solid var(--v4-line) !important;
      border-left: 0 !important;
    }

    .lumix-crm-module .native-grid:not(.welcome-grid) .phone-card {
      position: static !important;
      max-width: 300px !important;
      margin: auto !important;
    }

    .lumix-crm-module .base-smart-grid {
      grid-template-columns: 300px minmax(0, 1fr) !important;
    }
  }

  @media (max-width: 900px) {
    .lumix-crm-module .native-grid:not(.welcome-grid),
    .lumix-crm-module .welcome-grid,
    .lumix-crm-module .base-smart-grid {
      grid-template-columns: 1fr !important;
    }

    .lumix-crm-module .triggers-card,
    .lumix-crm-module .base-import-smart-card {
      border-right: 0 !important;
      border-bottom: 1px solid var(--v4-line) !important;
    }

    .lumix-crm-module .triggers-list {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .lumix-crm-module .preview-native-card {
      border-top: 1px solid var(--v4-line) !important;
      border-left: 0 !important;
    }

    .lumix-crm-module .phone-card {
      position: static !important;
    }
  }

  @media (max-width: 640px) {
    .lumix-crm-module .crm-main {
      padding: 12px 8px 24px !important;
    }

    .lumix-crm-module .triggers-list {
      grid-template-columns: 1fr !important;
    }

    .lumix-crm-module .form-grid,
    .lumix-crm-module .base-metric-grid {
      grid-template-columns: 1fr !important;
    }

    .lumix-crm-module .base-metric-card {
      border-right: 0 !important;
      border-bottom: 1px solid var(--v4-line) !important;
    }

    .lumix-crm-module .compact-media-preview {
      grid-template-columns: 78px minmax(0, 1fr) !important;
    }

    .lumix-crm-module .compact-media-thumb {
      width: 78px !important;
      height: 58px !important;
    }

    .lumix-crm-module .smart-contacts-head {
      display: none !important;
    }

    .lumix-crm-module .smart-contact-row {
      grid-template-columns: 1fr auto !important;
      gap: 8px !important;
    }

    .lumix-crm-module .contact-phone-cell,
    .lumix-crm-module .contact-dates-cell,
    .lumix-crm-module .contact-location-cell {
      grid-column: 1 / -1 !important;
    }
  }

`;
